// import React, { useState, useEffect, useRef, useCallback, useContext, useMemo } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { AuthContext } from './../../AuthContext/AuthContext';
// import {
//   Box, Card, CardContent, CardMedia, Typography, IconButton,
//   Button, Tooltip, Chip, CircularProgress, Tabs, Tab,
// } from '@mui/material';
// import { CheckCircle } from '@mui/icons-material';
// import {
//   FavoriteBorder, Favorite, Share, Call, Chat,
//   LocationOn, ChevronLeft, ChevronRight,
// } from '@mui/icons-material'; 
// import axios from 'axios';
// import buildingImage from './../../../Images/house.jpeg';
// import CustomSearchBar from './CustomSearch';
// import BottomNavbar from './CustomBottomNav';
// import { BASE_URL } from './../../Api/ApiUrls';
// import LimitModal from '../Buy Module/LimitModal';
// import SubscriptionModal from '../Buy Module/SubscriptionModal';
// import AlertModal from '../Buy Module/AlertModal';
// import GuestLoginModal from '../../GuestLoginModal';
// import CopyFailureAlert from '../Alertpage/CopyAlert/CopyFailureAlert';
// import CopySuccessAlert from '../Alertpage/CopyAlert/CopySuccessAlert';
// import { NODE_API } from '../Buy Module/NodeApi';

// const PAGE_SIZE = 20;

// // ─── Skeleton card ──────────────────────────────────────────────────────────────
// const SkeletonCard = () => (
//   <Box sx={{
//     mb: 1.2, mx: 2, borderRadius: 3, overflow: 'hidden', boxShadow: 2,
//     backgroundColor: '#fff',
//     animation: 'skeletonPulse 1.5s ease-in-out infinite',
//     '@keyframes skeletonPulse': { '0%,100%': { opacity: 1 }, '50%': { opacity: 0.45 } },
//   }}>
//     <Box sx={{ height: 140, backgroundColor: '#ddd' }} />
//     <Box sx={{ p: 1.5 }}>
//       <Box sx={{ height: 14, backgroundColor: '#e0e0e0', borderRadius: 1, mb: 1, width: '65%' }} />
//       <Box sx={{ height: 12, backgroundColor: '#e0e0e0', borderRadius: 1, mb: 1, width: '45%' }} />
//       <Box sx={{ height: 12, backgroundColor: '#e0e0e0', borderRadius: 1, mb: 1.5, width: '55%' }} />
//       <Box sx={{ display: 'flex', gap: 1 }}>
//         <Box sx={{ flex: 1, height: 32, backgroundColor: '#e0e0e0', borderRadius: 1 }} />
//         <Box sx={{ flex: 1, height: 32, backgroundColor: '#e0e0e0', borderRadius: 1 }} />
//         <Box sx={{ flex: 1, height: 32, backgroundColor: '#e0e0e0', borderRadius: 1 }} />
//       </Box>
//     </Box>
//   </Box>
// );

// // ─── Chip skeleton row ──────────────────────────────────────────────────────────
// const ChipRowSkeleton = () => (
//   <Box sx={{ display: 'flex', gap: 1, px: 2, pb: 1, overflowX: 'hidden' }}>
//     {[80, 60, 100, 70, 90].map((w, i) => (
//       <Box key={i} sx={{
//         width: w, height: 32, borderRadius: 16, flexShrink: 0,
//         backgroundColor: '#d0d0d0',
//         animation: 'skeletonPulse 1.5s ease-in-out infinite',
//         '@keyframes skeletonPulse': { '0%,100%': { opacity: 1 }, '50%': { opacity: 0.45 } },
//       }} />
//     ))}
//   </Box>
// );

// // ─── Scroll sentinel ────────────────────────────────────────────────────────────
// const ScrollSentinel = ({ onVisible, hasMore, loading }) => {
//   const ref = useRef(null);
//   useEffect(() => {
//     const el = ref.current;
//     if (!el) return;
//     const observer = new IntersectionObserver(
//       ([entry]) => { if (entry.isIntersecting && hasMore && !loading) onVisible(); },
//       { threshold: 0.1, rootMargin: '200px' }
//     );
//     observer.observe(el);
//     return () => observer.disconnect();
//   }, [onVisible, hasMore, loading]);

//   return (
//     <Box ref={ref} sx={{ py: 3, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//       {loading && <CircularProgress size={28} sx={{ color: '#8B7355' }} />}
//       {!loading && !hasMore && (
//         <Typography variant="caption" sx={{ color: '#999', fontStyle: 'italic' }}>
//           ✓ All properties loaded
//         </Typography>
//       )}
//     </Box>
//   );
// };

// // ─── Parse raw API row → card shape ────────────────────────────────────────────
// const parseProperty = (item) => {
//   const parseCoord = (coord) => {
//     if (!coord) return null;
//     return parseFloat(String(coord).replace(/"/g, '').replace(':', '.'));
//   };

//   let images = [buildingImage];
//   if (item.property_images?.length > 0) {
//     images = item.property_images.map(img => {
//       if (typeof img === 'string') return img.startsWith('http') ? img : `${BASE_URL}${img}`;
//       if (img.image)
//        return img.image.startsWith('http')
//          ? img.image
//          : `${BASE_URL}/${img.image.replace(/^\/+/, '')}`;
//       if (img.url)   return img.url.startsWith('http')   ? img.url   : `${BASE_URL}${img.url}`;
//       if (img.path)  return img.path.startsWith('http')  ? img.path  : `${BASE_URL}${img.path}`;
//       return buildingImage;
//     });
//   } else if (item.images?.length > 0) {
//     images = item.images.map(img =>
//       typeof img === 'string' && img.startsWith('http') ? img : `${BASE_URL}${img}`
//     );
//   }

//   return {
//     id:            String(item.property_id),
//     title:         item.category_name || item.property_type || 'Property',
//     property_name: item.property_name,
//     location:      item.location || 'Not specified',
//     date:          item.created_at?.split('T')[0],
//     facing:        item.facing?.replace(/"/g, '') || 'N/A',
//     price:         Number(item.price) || 0,
//     createdAt:     item.created_at,
//     fullData:      item,
//     length:        item.length,
//     width:         item.width,
//     listedBy:      item.posted_by?.replace(/"/g, '') || 'Agent',
//     mobile_no:     item.mobile_no,
//     units:         item.units || '',
//     category_id:   item.category_id,
//     category_name: item.category_name || '',
//     images,
//     site_area: item.site_area,
//     area: item.site_area
//       ? `${item.site_area} ${['ft','m','cm','in'].includes(item.units) ? `Sq ${item.units}` : item.units || 'Sq ft'}`
//       : 0,
//     max_acres:  item.max_acres ? `${item.max_acres} ${item.units || 'acres'}` : 'N/A',
//     dimensions: item.roadwidth ? `${item.roadwidth} ft road` : 'N/A',
//     posted_by:  item.posted_by?.replace(/"/g, '') || 'Agent',
//     lat:        parseCoord(item.lat),
//     long:       parseCoord(item.long),
//     owner:      item.user_id,
//     propertyData:    item,
//     property_images: item.property_images,
//     property_type:   item.property_type || '',
//   };
// };

// // ─── Debounce hook ──────────────────────────────────────────────────────────────
// const useDebounce = (value, delay) => {
//   const [debounced, setDebounced] = useState(value);
//   useEffect(() => {
//     const t = setTimeout(() => setDebounced(value), delay);
//     return () => clearTimeout(t);
//   }, [value, delay]);
//   return debounced;
// };

// // ─── Generic paginated fetch hook ──────────────────────────────────────────────
// const usePaginatedFetch = (getUrl, deps, enabled = true) => {
//   const [items,          setItems]          = useState([]);
//   const [cursor,         setCursor]         = useState(null);
//   const [hasMore,        setHasMore]        = useState(false);
//   const [loading,        setLoading]        = useState(false);
//   const [initialLoading, setInitialLoading] = useState(true);

//   const fetchingRef = useRef(false);
//   const [isFetching, setIsFetching] = useState(false);

//   const setFetching = (val) => {
//     fetchingRef.current = val;
//     setIsFetching(val);
//   };

//   const abortRef = useRef(null);

//   useEffect(() => {
//     if (!enabled) return;

//     if (abortRef.current) abortRef.current.abort();
//     const ctrl = new AbortController();
//     abortRef.current = ctrl;

//     setItems([]);
//     setCursor(null);
//     setHasMore(false);
//     setInitialLoading(true);
//     setFetching(true);

//     fetch(getUrl(null), { signal: ctrl.signal })
//       .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
//       .then(json => {
//         setItems((json.data || []).map(i => parseProperty(i)));
//         setCursor(json.next_cursor ?? null);
//         setHasMore(json.has_more ?? false);
//       })
//       .catch(err => { if (err.name !== 'AbortError') console.error('fetch error:', err); })
//       .finally(() => {
//         setInitialLoading(false);
//         setFetching(false);
//       });

//     return () => ctrl.abort();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [...deps, enabled]);

//   const loadMore = useCallback(() => {
//     if (loading || !hasMore || !cursor) return;

//     if (abortRef.current) abortRef.current.abort();
//     const ctrl = new AbortController();
//     abortRef.current = ctrl;

//     setLoading(true);

//     fetch(getUrl(cursor), { signal: ctrl.signal })
//       .then(r => r.json())
//       .then(json => {
//         setItems(prev => [...prev, ...(json.data || []).map(i => parseProperty(i))]);
//         setCursor(json.next_cursor ?? null);
//         setHasMore(json.has_more ?? false);
//       })
//       .catch(err => { if (err.name !== 'AbortError') console.error('loadMore error:', err); })
//       .finally(() => setLoading(false));
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [loading, hasMore, cursor, ...deps]);

//   return { items, hasMore, loading, initialLoading, isFetching, fetchingRef, loadMore };
// };

// // ─── Hook: all lease properties ─────────────────────────────────────────────────
// const useAllLeaseProperties = ({ searchQuery, priceFilter, enabled }) => {
//   const getUrl = useCallback((cursorVal) => {
//     const p = new URLSearchParams({ limit: PAGE_SIZE });
//     if (cursorVal)                p.set('cursor',    cursorVal);
//     if (searchQuery.trim())       p.set('search',    searchQuery.trim());
//     if (priceFilter?.min != null) p.set('min_price', priceFilter.min);
//     if (priceFilter?.max != null) p.set('max_price', priceFilter.max);
//     return `${NODE_API}/api/lease/non-admin/?${p}`;
//   }, [searchQuery, priceFilter]);

//   return usePaginatedFetch(getUrl, [searchQuery, JSON.stringify(priceFilter)], enabled);
// };

// // ─── Hook: lease properties filtered by category_id ───────────────────────────
// const useLeaseByCategory = ({ selectedCategoryId, searchQuery, priceFilter, enabled }) => {
//   const getUrl = useCallback((cursorVal) => {
//     const p = new URLSearchParams({ limit: PAGE_SIZE });
//     if (cursorVal)                p.set('cursor',    cursorVal);
//     if (searchQuery?.trim())      p.set('search',    searchQuery.trim());
//     if (priceFilter?.min != null) p.set('min_price', priceFilter.min);
//     if (priceFilter?.max != null) p.set('max_price', priceFilter.max);
//     return `${NODE_API}/api/lease/by-category/${selectedCategoryId}?${p}`;
//   }, [selectedCategoryId, searchQuery, priceFilter]);

//   return usePaginatedFetch(
//     getUrl,
//     [selectedCategoryId, searchQuery, JSON.stringify(priceFilter)],
//     enabled && selectedCategoryId != null
//   );
// };

// // ─── Main Component ─────────────────────────────────────────────────────────────
// const LeasePropertyCard = () => {
//   const navigate            = useNavigate();
//   const { userId, isGuest } = useContext(AuthContext);

//   // ── UI state ─────────────────────────────────────────────────────────────────
//   const [activeTab,         setActiveTab]         = useState('lease');
//   const [searchQuery,       setSearchQuery]       = useState('');
//   const [selectedCategory,  setSelectedCategory]  = useState(null);
//   const [priceFilter,       setPriceFilter]       = useState(null);
//   const [currentImageIndex, setCurrentImageIndex] = useState({});

//   const debouncedSearch = useDebounce(searchQuery, 400);
//   const isTyping = searchQuery !== debouncedSearch;

//   // ── Data state ────────────────────────────────────────────────────────────────
//   const [categories,        setCategories]        = useState([]);
//   const [categoriesLoading, setCategoriesLoading] = useState(true);
//   const [allFetchedProperties, setAllFetchedProperties] = useState([]);

//   // ── Auth / subscription ───────────────────────────────────────────────────────
//   const [savedProperties, setSavedProperties] = useState([]);
//   const [cartItems,       setCartItems]       = useState([]);
//   const [saving,          setSaving]          = useState({});
//   const [locationLoading, setLocationLoading] = useState({});
//   const [isSubscribed,    setIsSubscribed]    = useState(false);
//   const [userPlan,        setUserPlan]        = useState(null);
//   const [userActivities,  setUserActivities]  = useState([]);

//   // ── Modals ────────────────────────────────────────────────────────────────────
//   const [showLimitModal,     setShowLimitModal]     = useState(false);
//   const [showSubscribeModal, setShowSubscribeModal] = useState(false);
//   const [featureRequested,   setFeatureRequested]   = useState('');
//   const [showAlertModal,     setShowAlertModal]     = useState(false);
//   const [pendingAction,      setPendingAction]      = useState(null);
//   const [currentPropertyId,  setCurrentPropertyId]  = useState(null);
//   const [showGuestModal,     setShowGuestModal]     = useState(false);
//   const [showSuccess,        setShowSuccess]        = useState(false);
//   const [showFailure,        setShowFailure]        = useState(false);
//   const [alertMessage,       setAlertMessage]       = useState('');

//   // ── Two fetch hooks ───────────────────────────────────────────────────────────
//   const allProps = useAllLeaseProperties({
//     searchQuery: debouncedSearch,
//     priceFilter,
//     enabled: activeTab === 'lease' && !selectedCategory,
//   });

//   const categoryProps = useLeaseByCategory({
//     selectedCategoryId: selectedCategory?.category_id ?? null,
//     searchQuery: debouncedSearch,
//     priceFilter,
//     enabled: activeTab === 'lease' && !!selectedCategory,
//   });

//   const {
//     items:          leaseProperties,
//     hasMore:        leaseHasMore,
//     loading:        leaseListLoading,
//     initialLoading: leaseInitialLoading,
//     isFetching:     leaseIsFetching,
//     fetchingRef:    leaseFetchingRef,
//     loadMore:       leaseLoadMore,
//   } = selectedCategory ? categoryProps : allProps;

//   const showSkeleton = isTyping || leaseIsFetching || leaseFetchingRef?.current;

//   useEffect(() => {
//     if (!leaseProperties.length) return;
//     setAllFetchedProperties(prev => {
//       const existingIds = new Set(prev.map(p => p.id));
//       const newOnes = leaseProperties.filter(p => !existingIds.has(p.id));
//       return newOnes.length ? [...prev, ...newOnes] : prev;
//     });
//   }, [leaseProperties]);

//   // ─── MEMOIZED VALUES ──────────────────────────────────────────────────────────
//   const accessedProperties = useMemo(() => {
//     return allFetchedProperties.filter(property =>
//       userActivities.some(
//         a => String(a.property_id) === String(property.id) && a.activity_as === 'Tenant'
//       )
//     );
//   }, [allFetchedProperties, userActivities]);

//   const properties = useMemo(() => {
//     return activeTab === 'accessed' ? accessedProperties : leaseProperties;
//   }, [activeTab, accessedProperties, leaseProperties]);

//   const hasMore = useMemo(() => {
//     return activeTab === 'accessed' ? false : leaseHasMore;
//   }, [activeTab, leaseHasMore]);

//   const listLoading = useMemo(() => {
//     return activeTab === 'accessed' ? false : leaseListLoading;
//   }, [activeTab, leaseListLoading]);

//   const initialLoading = useMemo(() => {
//     return activeTab === 'accessed' ? false : leaseInitialLoading;
//   }, [activeTab, leaseInitialLoading]);

//   const loadMore = useMemo(() => {
//     return activeTab === 'accessed' ? () => {} : leaseLoadMore;
//   }, [activeTab, leaseLoadMore]);

//   // ── Bootstrap ─────────────────────────────────────────────────────────────────
//   useEffect(() => {
//     setCategoriesLoading(true);
//     fetch(`${NODE_API}/api/lease/categories/`)
//       .then(r => r.json())
//       .then(data => { setCategories(data); setCategoriesLoading(false); })
//       .catch(() => setCategoriesLoading(false));
//   }, []);

//   useEffect(() => {
//     if (!userId) return;

//     axios.get(`${BASE_URL}/Get-user-plan/${userId}/`)
//       .then(r => {
//         const subs      = r.data;
//         const tenantSub = Array.isArray(subs) ? subs.find(s => s.user_type === 'Tenant') : null;
//         setIsSubscribed(!!tenantSub);
//         setUserPlan(tenantSub || null);
//       })
//       .catch(() => { setIsSubscribed(false); setUserPlan(null); });

//     axios.get(`${BASE_URL}/get-user-cart/${userId}/`)
//       .then(r => { setCartItems(r.data); setSavedProperties(r.data.map(i => String(i.property_id))); })
//       .catch(e => console.error('Cart error:', e));

//     fetchUserActivities();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [userId]);

//   // ─── FIX: Optimize image index update ────────────────────────────────────────
//   useEffect(() => {
//     setCurrentImageIndex(prev => {
//       let changed = false;
//       const next = { ...prev };
//       properties.forEach(p => { 
//         if (!(p.id in next)) {
//           next[p.id] = 0;
//           changed = true;
//         }
//       });
//       return changed ? next : prev;
//     });
//   }, [properties]);

//   // ── Helpers ───────────────────────────────────────────────────────────────────
//   const requireLogin = useCallback((e, cb) => {
//     e.stopPropagation();
//     if (isGuest) { setShowGuestModal(true); return; }
//     cb();
//   }, [isGuest]);

//   const fetchUserActivities = useCallback(async () => {
//     if (!userId) return;
//     try {
//       const res = await fetch(`${BASE_URL}/activities/`);
//       if (!res.ok) throw new Error(`HTTP ${res.status}`);
//       const all = await res.json();
//       setUserActivities(all.filter(a => String(a.user_id) === String(userId)));
//     } catch (e) {
//       console.error('Activities error:', e);
//       setUserActivities([]);
//     }
//   }, [userId]);

//   const isSaved = useCallback((property) => {
//     return savedProperties.includes(property.id);
//   }, [savedProperties]);

//   const addToCart = useCallback(async (propertyId) => {
//     const r = await axios.post(`${BASE_URL}/user-cart/`, { user_id: userId, property_id: propertyId });
//     return r.data;
//   }, [userId]);

//   const removeFromCart = useCallback(async (cartId) => {
//     return axios.delete(`${BASE_URL}/user-cart/${cartId}/`);
//   }, []);

//   const toggleSave = useCallback(async (property) => {
//     const pid = property.id;
//     setSaving(prev => ({ ...prev, [pid]: true }));
//     try {
//       if (isSaved(property)) {
//         const item = cartItems.find(i => i.property_id === pid);
//         await removeFromCart(item.cart_id);
//         setSavedProperties(prev => prev.filter(id => id !== pid));
//         setCartItems(prev => prev.filter(i => i.property_id !== pid));
//       } else {
//         const newItem = await addToCart(pid);
//         setSavedProperties(prev => [...prev, pid]);
//         setCartItems(prev => [...prev, newItem.data]);
//       }
//     } catch (e) { console.error('Save error:', e); }
//     finally { setSaving(prev => ({ ...prev, [pid]: false })); }
//   }, [isSaved, cartItems, addToCart, removeFromCart]);

//   const findProperty = useCallback((propertyId) => {
//     return properties.find(p => p.id === propertyId) ||
//            allFetchedProperties.find(p => p.id === propertyId);
//   }, [properties, allFetchedProperties]);

//   const checkPropertyLimit = useCallback((propertyId) => {
//     if (!isSubscribed) {
//       setFeatureRequested('Property Access');
//       setShowSubscribeModal(true);
//       return false;
//     }
//     if (userPlan?.no_of_properties_unlimited) return true;

//     const alreadyAccessed = userActivities.some(
//       a => a.property_id === propertyId && a.activity_as === 'Tenant'
//     );
//     if (alreadyAccessed) return true;

//     const uniqueProps = new Set(
//       userActivities.filter(a => a.activity_as === 'Tenant').map(a => a.property_id)
//     );
//     if (uniqueProps.size >= (userPlan?.no_of_properties || 10)) {
//       setShowLimitModal(true);
//       return false;
//     }
//     return true;
//   }, [isSubscribed, userPlan, userActivities]);

//   const logActivity = useCallback(async (propertyId, activityType) => {
//     const exists = userActivities.find(
//       a => a.property_id === propertyId && a.activity_as === 'Tenant'
//     );
//     if (exists) return false;

//     const property = findProperty(propertyId);
//     if (!property) return false;

//     try {
//       const res = await fetch(`${BASE_URL}/activities/`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           user_id:       userId,
//           property_id:   propertyId,
//           activity_type: activityType,
//           property_by:   property.owner,
//           activity_as:   'Tenant',
//         }),
//       });
//       if (!res.ok) throw new Error('Failed to log activity');
//       return await res.json();
//     } catch (e) { console.error('logActivity error:', e); return false; }
//   }, [userId, userActivities, findProperty]);

//   const handleAction = useCallback(async (e, propertyId, actionName, actionCallback, activityType) => {
//     e.stopPropagation();
//     if (!isSubscribed) { setFeatureRequested(actionName); setShowSubscribeModal(true); return; }

//     const alreadyAccessed = userActivities.some(
//       a => a.property_id === propertyId && a.activity_as === 'Tenant'
//     );
//     if (!alreadyAccessed) {
//       const ok = checkPropertyLimit(propertyId);
//       if (!ok) return;
//     }

//     setPendingAction(() => async () => {
//       try {
//         await actionCallback();
//         if (activityType && !alreadyAccessed) {
//           const result = await logActivity(propertyId, activityType);
//           if (result) {
//             setUserActivities(prev => [...prev, {
//               user_id:       userId,
//               property_id:   propertyId,
//               activity_type: activityType,
//               property_by:   findProperty(propertyId)?.owner,
//               activity_as:   'Tenant',
//               created_at:    new Date().toISOString(),
//             }]);
//           }
//         }
//       } catch (err) {
//         console.error(`${actionName} error:`, err);
//         alert(`Failed to complete ${actionName} action`);
//       }
//     });
//     setCurrentPropertyId(propertyId);
//     setShowAlertModal(true);
//   }, [isSubscribed, userActivities, checkPropertyLimit, logActivity, userId, findProperty]);

//   // ── Action handlers ───────────────────────────────────────────────────────────
//   const handleCallClick = useCallback((e, property) => {
//     return handleAction(e, property.id, 'Call', async () => {
//       try {
//         await navigator.clipboard.writeText(property.mobile_no);
//         setAlertMessage(`Copied: ${property.mobile_no}`);
//         setShowSuccess(true); setShowFailure(false);
//       } catch {
//         setAlertMessage('Failed to copy number');
//         setShowFailure(true); setShowSuccess(false);
//       }
//     }, 'Call');
//   }, [handleAction]);

//   const handleMessageClick = useCallback((e, property) => {
//     return handleAction(e, property.id, 'Message', async () => {
//       navigate('/chat', { state: { property: property.id } });
//     }, 'Call');
//   }, [handleAction, navigate]);

//   const handleShareClick = useCallback(async (e, property) => {
//     e.stopPropagation();
//     const url = `${window.location.origin}/lease-description/${property.id}`;
//     try {
//       await navigator.clipboard.writeText(url);
//       setAlertMessage('Property link copied to clipboard!');
//       setShowSuccess(true);
//       setTimeout(() => setShowSuccess(false), 3000);
//     } catch {
//       try {
//         const ta = document.createElement('textarea');
//         ta.value = url; document.body.appendChild(ta); ta.select();
//         document.execCommand('copy'); document.body.removeChild(ta);
//         setAlertMessage('Property link copied to clipboard!');
//         setShowSuccess(true);
//         setTimeout(() => setShowSuccess(false), 3000);
//       } catch {
//         setAlertMessage('Failed to copy property link');
//         setShowFailure(true);
//         setTimeout(() => setShowFailure(false), 3000);
//       }
//     }
//   }, []);

//   const handleLocationClick = useCallback((e, property) => {
//     return handleAction(e, property.id, 'Location', async () => {
//       setLocationLoading(prev => ({ ...prev, [property.id]: true }));
//       const fallback = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(property.location)}`;
//       const open = (url) => {
//         setLocationLoading(prev => ({ ...prev, [property.id]: false }));
//         window.open(url, '_blank', 'noopener,noreferrer');
//       };
//       if (navigator.geolocation) {
//         navigator.geolocation.getCurrentPosition(
//           ({ coords }) => {
//             const dest = property.lat && property.long
//               ? `https://www.google.com/maps/dir/?api=1&origin=${coords.latitude},${coords.longitude}&destination=${property.lat},${property.long}&travelmode=driving`
//               : fallback;
//             open(dest);
//           },
//           () => open(fallback),
//           { timeout: 10000 }
//         );
//       } else { open(fallback); }
//     }, 'Location');
//   }, [handleAction]);

//   const handleWishlistClick = useCallback((e, property) => {
//     e.stopPropagation();
//     return handleAction(e, property.id, 'Liked', async () => { await toggleSave(property); }, 'Liked');
//   }, [handleAction, toggleSave]);

//   const handleNextImage = useCallback((propertyId, e) => {
//     e.stopPropagation();
//     setCurrentImageIndex(prev => {
//       const p = findProperty(propertyId);
//       return { ...prev, [propertyId]: (prev[propertyId] + 1) % p.images.length };
//     });
//   }, [findProperty]);

//   const handlePrevImage = useCallback((propertyId, e) => {
//     e.stopPropagation();
//     setCurrentImageIndex(prev => {
//       const p = findProperty(propertyId);
//       return { ...prev, [propertyId]: (prev[propertyId] - 1 + p.images.length) % p.images.length };
//     });
//   }, [findProperty]);

//   // ── Card renderer ─────────────────────────────────────────────────────────────
//   const renderCard = useCallback((property) => {
//     const isAccessed = userActivities.some(
//       a => String(a.property_id) === String(property.id) && a.activity_as === 'Tenant'
//     );
//     const imgIdx = currentImageIndex[property.id] || 0;

//     return (
//       <Card
//         key={property.id}
//         sx={{
//           mb: 1.2, mx: 2, borderRadius: 3, boxShadow: 2,
//           transition: 'transform 0.2s ease-in-out',
//           '&:hover': { transform: 'scale(1.015)', boxShadow: 4 },
//         }}
//         onClick={async (e) => {
//           if (e.target.closest('button') || e.target.closest('svg')) return;
//           if (!isSubscribed) { setFeatureRequested('View Details'); setShowSubscribeModal(true); return; }
//           const alreadyAccessed = userActivities.some(
//             a => a.property_id === property.id && a.activity_as === 'Tenant'
//           );
//           if (!alreadyAccessed) {
//             const ok = checkPropertyLimit(property.id);
//             if (!ok) return;
//             try { await logActivity(property.id, 'Description'); } catch {}
//           }
//           navigate(`/lease-description/${property.id}`, {
//             state: { propertyId: property.id, property: property.propertyData },
//           });
//         }}
//       >
//         <Box sx={{ position: 'relative', width: '100%', height: 140 }}>
//           <CardMedia
//             component="img"
//             image={property.images[imgIdx]}
//             alt="Property"
//             sx={{ width: '100%', height: 140, objectFit: 'cover',
//               borderTopLeftRadius: 12, borderTopRightRadius: 12 }}
//           />

//           {property.images.length > 1 && (
//             <>
//               <IconButton
//                 sx={{ position: 'absolute', top: '50%', left: 8, opacity: 0,
//                   transform: 'translateY(-50%)', backgroundColor: 'rgba(255,255,255,0.3)',
//                   backdropFilter: 'blur(2px)',
//                   '&:hover': { opacity: 1, backgroundColor: 'rgba(255,255,255,0.5)' } }}
//                 onClick={e => handlePrevImage(property.id, e)}
//               >
//                 <ChevronLeft fontSize="small" />
//               </IconButton>
//               <IconButton
//                 sx={{ position: 'absolute', top: '50%', right: 8, opacity: 0,
//                   transform: 'translateY(-50%)', backgroundColor: 'rgba(255,255,255,0.3)',
//                   backdropFilter: 'blur(2px)',
//                   '&:hover': { opacity: 1, backgroundColor: 'rgba(255,255,255,0.5)' } }}
//                 onClick={e => handleNextImage(property.id, e)}
//               >
//                 <ChevronRight fontSize="small" />
//               </IconButton>
//             </>
//           )}

//           {property.images.length > 1 && (
//             <Box sx={{ position: 'absolute', bottom: 10, left: '50%',
//               transform: 'translateX(-50%)', display: 'flex', gap: 1 }}>
//               {property.images.map((_, i) => (
//                 <Box key={i}
//                   onClick={e => { e.stopPropagation();
//                     setCurrentImageIndex(prev => ({ ...prev, [property.id]: i })); }}
//                   sx={{ width: 8, height: 8, borderRadius: '50%', cursor: 'pointer',
//                     transition: 'background-color 0.3s',
//                     backgroundColor: imgIdx === i ? '#1976d2' : '#ccc' }}
//                 />
//               ))}
//             </Box>
//           )}

//           <Box sx={{ position: 'absolute', top: 6, right: 6, display: 'flex', gap: 0.8 }}>
//             <Tooltip title="Add to Wishlist">
//               <IconButton
//                 sx={{ bgcolor: 'white', boxShadow: 1, p: 0.8 }}
//                 onClick={e => requireLogin(e, () => handleWishlistClick(e, property))}
//                 disabled={saving[property.id]}
//               >
//                 {isSaved(property) ? <Favorite color="error" /> : <FavoriteBorder />}
//                 {saving[property.id] && <CircularProgress size={24} sx={{ position: 'absolute' }} />}
//               </IconButton>
//             </Tooltip>
//             <Tooltip title="Share Property">
//               <IconButton
//                 sx={{ bgcolor: 'white', boxShadow: 1, p: 0.8 }}
//                 onClick={e => requireLogin(e, () => handleShareClick(e, property))}
//               >
//                 <Share />
//               </IconButton>
//             </Tooltip>
//           </Box>

//           {isAccessed && (
//             <Box sx={{ position: 'absolute', bottom: 6, right: 6 }}>
//               <Tooltip title="Already Accessed">
//                 <IconButton
//                   sx={{ bgcolor: 'white', boxShadow: 1, p: 0.8, color: 'green' }}
//                   onClick={e => e.stopPropagation()}
//                 >
//                   <CheckCircle />
//                 </IconButton>
//               </Tooltip>
//             </Box>
//           )}
//         </Box>

//         <CardContent sx={{ px: 2, py: 0.2, pb: '7px !important' }}>
//           <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={0.5}>
//             <Typography variant="subtitle1" fontWeight="bold" noWrap
//               sx={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', pr: 1 }}>
//               {property.title} - {property.property_name}
//             </Typography>
//             <Typography variant="body2" fontWeight="bold" color="primary" noWrap>
//               ₹{Number(String(property.price).replace(/[^0-9]/g, '')).toLocaleString('en-IN')}
//             </Typography>
//           </Box>

//           <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
//             <Typography variant="caption" color="text.secondary" noWrap
//               sx={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', pr: 1 }}>
//               {property.location}
//             </Typography>
//             <Typography variant="caption" color="text.secondary" noWrap>
//               {new Date(property.date).toLocaleDateString('en-IN',
//                 { day: '2-digit', month: '2-digit', year: 'numeric' })}
//             </Typography>
//           </Box>

//           <Box display="flex" alignItems="center" mb={1}>
//             <IconButton
//               onClick={e => requireLogin(e, () => handleLocationClick(e, property))}
//               size="small" sx={{ p: 0.5 }}
//               disabled={locationLoading[property.id]}
//             >
//               {locationLoading[property.id]
//                 ? <CircularProgress size={16} />
//                 : <>
//                     <LocationOn fontSize="small" sx={{ color: 'primary.main' }} />
//                     <Typography variant="caption" color="text.primary" ml={0.5}>Location</Typography>
//                   </>}
//             </IconButton>

//             <Tooltip title="Send Message">
//               <IconButton size="small"
//                 onClick={e => requireLogin(e, () => handleMessageClick(e, property))}
//                 sx={{ p: 0, color: 'primary.main', ml: 1 }}>
//                 <Chat fontSize="small" />
//               </IconButton>
//             </Tooltip>

//             <Box sx={{ flexGrow: 1 }} />

//             <Button
//               size="small" variant="outlined" color="success"
//               startIcon={<Call fontSize="small" />}
//               sx={{ textTransform: 'none', px: 1, py: 0.2, fontSize: '0.7rem', minWidth: 'auto' }}
//               onClick={e => requireLogin(e, () => handleCallClick(e, property))}
//             >
//               Call
//             </Button>
//           </Box>

//           <Box sx={{ display: 'flex', border: '1px solid #e0e0e0', borderRadius: 1, overflow: 'hidden' }}>
//             {[
//               { label: 'Facing', value: property.facing || 'N/A' },
//               {
//                 label: 'Area',
//                 value: (
//                   <Box>
//                     <Box component="span">{property.area || property.max_acres || 'N/A'}</Box>
//                     {property.length && property.width && (
//                       <Typography component="span" variant="caption" color="text.secondary"
//                         sx={{ display: ['none', 'inline'], ml: 0.5 }}>
//                         ({property.length} × {property.width})
//                       </Typography>
//                     )}
//                   </Box>
//                 ),
//               },
//               { label: 'Posted By', value: property.posted_by || 'N/A' },
//             ].map((item, index) => (
//               <Box key={index} sx={{
//                 flex: 1, px: 0.5, py: 0.2, textAlign: 'center', minWidth: 0,
//                 borderRight: index < 2 ? '1px solid #e0e0e0' : 'none',
//               }}>
//                 <Typography variant="caption" color="text.secondary" noWrap>{item.label}</Typography>
//                 <Typography variant="body2" fontWeight="bold" noWrap={index !== 1}
//                   sx={{ fontSize: '0.8rem', lineHeight: 1.2 }}>
//                   {item.value}
//                 </Typography>
//               </Box>
//             ))}
//           </Box>
//         </CardContent>
//       </Card>
//     );
//   }, [
//     userActivities, currentImageIndex, isSubscribed, checkPropertyLimit, 
//     logActivity, navigate, requireLogin, handleWishlistClick, handleShareClick,
//     handleLocationClick, handleMessageClick, handleCallClick, saving, 
//     isSaved, handlePrevImage, handleNextImage
//   ]);

//   // ── Properties list ───────────────────────────────────────────────────────────
//   const renderPropertiesSection = useMemo(() => {
//     if (initialLoading) {
//       return <Box sx={{ mt: 1 }}>{[1, 2, 3].map(i => <SkeletonCard key={i} />)}</Box>;
//     }

//     if (activeTab === 'lease' && showSkeleton) {
//       return (
//         <Box>
//           {isTyping && (
//             <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center',
//               gap: 1, py: 1.5 }}>
//               <CircularProgress size={16} sx={{ color: '#8B7355' }} />
//               <Typography variant="caption" sx={{ color: '#888' }}>Searching...</Typography>
//             </Box>
//           )}
//           <Box sx={{ mt: isTyping ? 0.5 : 1 }}>
//             {[1, 2, 3].map(i => <SkeletonCard key={i} />)}
//           </Box>
//         </Box>
//       );
//     }

//     if (properties.length === 0) {
//       return (
//         <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center',
//           alignItems: 'center', height: 200, gap: 1, px: 2 }}>
//           <Typography variant="body2" color="text.secondary">
//             {activeTab === 'accessed'
//               ? "You haven't accessed any properties yet"
//               : selectedCategory
//               ? `No properties found for "${selectedCategory.category}"`
//               : debouncedSearch
//               ? `No results for "${debouncedSearch}"`
//               : 'No properties available right now.'}
//           </Typography>
//         </Box>
//       );
//     }

//     return (
//       <>
//         {properties.map(renderCard)}
//         <ScrollSentinel onVisible={loadMore} hasMore={hasMore} loading={listLoading} />
//       </>
//     );
//   }, [
//     initialLoading, activeTab, showSkeleton, isTyping, properties, 
//     selectedCategory, debouncedSearch, renderCard, loadMore, 
//     hasMore, listLoading
//   ]);

//   // ── JSX ───────────────────────────────────────────────────────────────────────
//   return (
//     <Box sx={{ backgroundColor: 'rgb(239, 231, 221)', minHeight: '120vh' }}>

//       <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1200,
//         backgroundColor: 'rgb(239, 231, 221)' }}>

//         <Box sx={{ px: 1, py: 1 }}>
//           <CustomSearchBar
//             value={searchQuery}
//             onChange={e => setSearchQuery(e.target.value)}
//             onPriceFilterChange={setPriceFilter}
//           />
//         </Box>

//         <Box sx={{ px: 2, pb: 1 }}>
//           <Tabs
//             value={activeTab}
//             onChange={(e, newValue) => {
//               setActiveTab(newValue);
//               if (newValue === 'accessed') setSelectedCategory(null);
//             }}
//             sx={{ '& .MuiTabs-indicator': { backgroundColor: 'black', height: 3 } }}
//           >
//             <Tab label="Lease Properties" value="lease"
//               sx={{ textTransform: 'none', fontWeight: 'bold',
//                 color: activeTab === 'lease' ? 'black' : 'text.secondary', minWidth: 0, mr: 2 }} />
//             <Tab label="Accessed Properties" value="accessed"
//               sx={{ textTransform: 'none', fontWeight: 'bold',
//                 color: activeTab === 'accessed' ? 'black' : 'text.secondary', minWidth: 0 }} />
//           </Tabs>
//         </Box>

//         {/* Category chips — only on Lease tab */}
//         {activeTab === 'lease' && (
//           <Box sx={{ px: 2, pb: 1 }}>
//             {categoriesLoading ? (
//               <ChipRowSkeleton />
//             ) : (
//               <Box sx={{
//                 display: 'flex', gap: 1, overflowX: 'auto', whiteSpace: 'nowrap', pb: 0.5,
//                 '&::-webkit-scrollbar': { height: 3 },
//                 '&::-webkit-scrollbar-thumb': { background: '#ccc', borderRadius: 2 },
//               }}>
//                 {categories.map((cat) => (
//                   <Chip
//                     key={cat.category_id}
//                     label={cat.category}
//                     variant="filled"
//                     onClick={() =>
//                       setSelectedCategory(prev =>
//                         prev?.category_id === cat.category_id ? null : cat
//                       )
//                     }
//                     sx={{
//                       flexShrink: 0,
//                       bgcolor:    selectedCategory?.category_id === cat.category_id ? '#000000' : 'transparent',
//                       color:      selectedCategory?.category_id === cat.category_id ? '#ffffff' : '#000000',
//                       border:     '1px solid black',
//                       fontWeight: 'bold',
//                       cursor:     'pointer',
//                       '&:hover':  {
//                         bgcolor: selectedCategory?.category_id === cat.category_id
//                           ? '#000000'
//                           : 'rgba(0,0,0,0.1)',
//                       },
//                     }}
//                   />
//                 ))}
//               </Box>
//             )}
//           </Box>
//         )}
//       </Box>

//       <Box sx={{
//         pb: 8,
//         pt: activeTab === 'lease'
//           ? { xs: '175px', sm: '180px' }
//           : { xs: '130px', sm: '115px' },
//       }}>
//         {renderPropertiesSection}
//       </Box>

//       <GuestLoginModal open={showGuestModal} onClose={() => setShowGuestModal(false)} />
//       <AlertModal
//         open={showAlertModal}
//         onClose={() => setShowAlertModal(false)}
//         onConfirm={async () => { setShowAlertModal(false); if (pendingAction) await pendingAction(); }}
//         title="Confirm Action"
//         message="Are you sure you want to perform this action on this property?"
//       />
//       <SubscriptionModal
//         open={showSubscribeModal}
//         onClose={() => setShowSubscribeModal(false)}
//         onSubscribe={() => { setShowSubscribeModal(false); navigate('/user-subscription'); }}
//         featureRequested={featureRequested}
//       />
//       <LimitModal open={showLimitModal} onClose={() => setShowLimitModal(false)} userPlan={userPlan} />

//       {showSuccess && (
//         <CopySuccessAlert
//           message={alertMessage}
//           onClose={() => { setShowSuccess(false); setAlertMessage(''); }}
//         />
//       )}
//       {showFailure && (
//         <CopyFailureAlert
//           message={alertMessage}
//           onClose={() => { setShowFailure(false); setAlertMessage(''); }}
//         />
//       )}

//       <BottomNavbar />
//     </Box>
//   );
// };

// export default LeasePropertyCard;



// import React, { useState, useEffect, useRef, useCallback, useContext, useMemo } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { AuthContext } from './../../AuthContext/AuthContext';
// import {
//   Box, Card, CardContent, CardMedia, Typography, IconButton,
//   Button, Tooltip, Chip, CircularProgress, Tabs, Tab,
// } from '@mui/material';
// import { CheckCircle, ExploreOutlined, SquareFootOutlined, PersonOutlineOutlined } from '@mui/icons-material';
// import {
//   FavoriteBorder, Favorite, Share, Call, Chat,
//   LocationOn, ChevronLeft, ChevronRight,
// } from '@mui/icons-material';
// import axios from 'axios';
// import buildingImage from './../../../Images/house.jpeg';
// import CustomSearchBar from './CustomSearch';
// import BottomNavbar from './CustomBottomNav';
// import { BASE_URL } from './../../Api/ApiUrls';
// import LimitModal from '../Buy Module/LimitModal';
// import SubscriptionModal from '../Buy Module/SubscriptionModal';
// import AlertModal from '../Buy Module/AlertModal';
// import GuestLoginModal from '../../GuestLoginModal';
// import CopyFailureAlert from '../Alertpage/CopyAlert/CopyFailureAlert';
// import CopySuccessAlert from '../Alertpage/CopyAlert/CopySuccessAlert';
// import { NODE_API } from '../Buy Module/NodeApi';
// // Add this import
// import AddPropertyCards from '../AddsProducts/AddPropertyCards';

// const PAGE_SIZE = 20;

// // ─── Skeleton card ──────────────────────────────────────────────────────────────
// const SkeletonCard = () => (
//   <Box sx={{
//     mb: 1.2, mx: 2, borderRadius: 3, overflow: 'hidden', boxShadow: 2,
//     backgroundColor: '#fff',
//     animation: 'skeletonPulse 1.5s ease-in-out infinite',
//     '@keyframes skeletonPulse': { '0%,100%': { opacity: 1 }, '50%': { opacity: 0.45 } },
//   }}>
//     <Box sx={{ display: 'flex', height: 140 }}>
//       <Box sx={{ width: '40%', backgroundColor: '#ddd' }} />
//       <Box sx={{ width: '60%', p: 1.5 }}>
//         <Box sx={{ height: 14, backgroundColor: '#e0e0e0', borderRadius: 1, mb: 1, width: '65%' }} />
//         <Box sx={{ height: 12, backgroundColor: '#e0e0e0', borderRadius: 1, mb: 1, width: '45%' }} />
//         <Box sx={{ height: 12, backgroundColor: '#e0e0e0', borderRadius: 1, mb: 1.5, width: '55%' }} />
//         <Box sx={{ display: 'flex', gap: 1 }}>
//           <Box sx={{ flex: 1, height: 32, backgroundColor: '#e0e0e0', borderRadius: 1 }} />
//           <Box sx={{ flex: 1, height: 32, backgroundColor: '#e0e0e0', borderRadius: 1 }} />
//           <Box sx={{ flex: 1, height: 32, backgroundColor: '#e0e0e0', borderRadius: 1 }} />
//         </Box>
//       </Box>
//     </Box>
//   </Box>
// );

// // ─── Chip skeleton row ──────────────────────────────────────────────────────────
// const ChipRowSkeleton = () => (
//   <Box sx={{ display: 'flex', gap: 1, px: 2, pb: 1, overflowX: 'hidden' }}>
//     {[80, 60, 100, 70, 90].map((w, i) => (
//       <Box key={i} sx={{
//         width: w, height: 32, borderRadius: 16, flexShrink: 0,
//         backgroundColor: '#d0d0d0',
//         animation: 'skeletonPulse 1.5s ease-in-out infinite',
//         '@keyframes skeletonPulse': { '0%,100%': { opacity: 1 }, '50%': { opacity: 0.45 } },
//       }} />
//     ))}
//   </Box>
// );

// // ─── Scroll sentinel ────────────────────────────────────────────────────────────
// const ScrollSentinel = ({ onVisible, hasMore, loading }) => {
//   const ref = useRef(null);
//   useEffect(() => {
//     const el = ref.current;
//     if (!el) return;
//     const observer = new IntersectionObserver(
//       ([entry]) => { if (entry.isIntersecting && hasMore && !loading) onVisible(); },
//       { threshold: 0.1, rootMargin: '200px' }
//     );
//     observer.observe(el);
//     return () => observer.disconnect();
//   }, [onVisible, hasMore, loading]);

//   return (
//     <Box ref={ref} sx={{ py: 3, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//       {loading && <CircularProgress size={28} sx={{ color: '#8B7355' }} />}
//       {!loading && !hasMore && (
//         <Typography variant="caption" sx={{ color: '#999', fontStyle: 'italic' }}>
//           ✓ All properties loaded
//         </Typography>
//       )}
//     </Box>
//   );
// };

// // ─── Parse raw API row → card shape ────────────────────────────────────────────
// const parseProperty = (item) => {
//   const parseCoord = (coord) => {
//     if (!coord) return null;
//     return parseFloat(String(coord).replace(/"/g, '').replace(':', '.'));
//   };

//   let images = [buildingImage];
//   if (item.property_images?.length > 0) {
//     images = item.property_images.map(img => {
//       if (typeof img === 'string') return img.startsWith('http') ? img : `${BASE_URL}${img}`;
//       if (img.image)
//         return img.image.startsWith('http')
//           ? img.image
//           : `${BASE_URL}/${img.image.replace(/^\/+/, '')}`;
//       if (img.url) return img.url.startsWith('http') ? img.url : `${BASE_URL}${img.url}`;
//       if (img.path) return img.path.startsWith('http') ? img.path : `${BASE_URL}${img.path}`;
//       return buildingImage;
//     });
//   } else if (item.images?.length > 0) {
//     images = item.images.map(img =>
//       typeof img === 'string' && img.startsWith('http') ? img : `${BASE_URL}${img}`
//     );
//   }

//   return {
//     id: String(item.property_id),
//     title: item.category_name || item.property_type || 'Property',
//     property_name: item.property_name,
//     location: item.location || 'Not specified',
//     date: item.created_at?.split('T')[0],
//     facing: item.facing?.replace(/"/g, '') || 'N/A',
//     city_town: item.city_town || 'Unknown',
//     price: Number(item.price) || 0,
//     possession: item.possession || 'Not specified',
//     createdAt: item.created_at,
//     fullData: item,
//     length: item.length,
//     width: item.width,
//     listedBy: item.posted_by?.replace(/"/g, '') || 'Agent',
//     mobile_no: item.mobile_no,
//     bank_pro_doc: item.bank_pro_doc || [],
//     bank_contact_details: item.bank_contact_details || 'Not available',
//     units: item.units || '',
//     auction_start_datetime: item.auction_start_datetime,
//     auction_end_datetime: item.auction_end_datetime,
//     emd_amount: item.emd_amount || 0,
//     bid_increment: item.bid_increment || 0,
//     category_id: item.category_id,
//     category_name: item.category_name || '',
//     images,
//     site_area: item.site_area,
//     area: item.site_area
//       ? `${item.site_area} ${['ft', 'm', 'cm', 'in'].includes(item.units) ? `Sq ${item.units}` : item.units || 'Sq ft'}`
//       : 0,
//     max_acres: item.max_acres ? `${item.max_acres} ${item.units || 'acres'}` : 'N/A',
//     dimensions: item.roadwidth ? `${item.roadwidth} ft road` : 'N/A',
//     posted_by: item.posted_by?.replace(/"/g, '') || 'Agent',
//     lat: parseCoord(item.lat),
//     long: parseCoord(item.long),
//     owner: item.user_id,
//     propertyData: item,
//     property_images: item.property_images,
//     property_type: item.property_type || '',
//   };
// };

// // ─── Debounce hook ──────────────────────────────────────────────────────────────
// const useDebounce = (value, delay) => {
//   const [debounced, setDebounced] = useState(value);
//   useEffect(() => {
//     const t = setTimeout(() => setDebounced(value), delay);
//     return () => clearTimeout(t);
//   }, [value, delay]);
//   return debounced;
// };

// // ─── Generic paginated fetch hook ──────────────────────────────────────────────
// const usePaginatedFetch = (getUrl, deps, enabled = true) => {
//   const [items, setItems] = useState([]);
//   const [cursor, setCursor] = useState(null);
//   const [hasMore, setHasMore] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [initialLoading, setInitialLoading] = useState(true);

//   const fetchingRef = useRef(false);
//   const [isFetching, setIsFetching] = useState(false);

//   const setFetching = (val) => {
//     fetchingRef.current = val;
//     setIsFetching(val);
//   };

//   const abortRef = useRef(null);

//   useEffect(() => {
//     if (!enabled) return;

//     if (abortRef.current) abortRef.current.abort();
//     const ctrl = new AbortController();
//     abortRef.current = ctrl;

//     setItems([]);
//     setCursor(null);
//     setHasMore(false);
//     setInitialLoading(true);
//     setFetching(true);

//     fetch(getUrl(null), { signal: ctrl.signal })
//       .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
//       .then(json => {
//         setItems((json.data || []).map(i => parseProperty(i)));
//         setCursor(json.next_cursor ?? null);
//         setHasMore(json.has_more ?? false);
//       })
//       .catch(err => { if (err.name !== 'AbortError') console.error('fetch error:', err); })
//       .finally(() => {
//         setInitialLoading(false);
//         setFetching(false);
//       });

//     return () => ctrl.abort();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [...deps, enabled]);

//   const loadMore = useCallback(() => {
//     if (loading || !hasMore || !cursor) return;

//     if (abortRef.current) abortRef.current.abort();
//     const ctrl = new AbortController();
//     abortRef.current = ctrl;

//     setLoading(true);

//     fetch(getUrl(cursor), { signal: ctrl.signal })
//       .then(r => r.json())
//       .then(json => {
//         setItems(prev => [...prev, ...(json.data || []).map(i => parseProperty(i))]);
//         setCursor(json.next_cursor ?? null);
//         setHasMore(json.has_more ?? false);
//       })
//       .catch(err => { if (err.name !== 'AbortError') console.error('loadMore error:', err); })
//       .finally(() => setLoading(false));
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [loading, hasMore, cursor, ...deps]);

//   return { items, hasMore, loading, initialLoading, isFetching, fetchingRef, loadMore };
// };

// // ─── Hook: all lease properties ─────────────────────────────────────────────────
// const useAllLeaseProperties = ({ searchQuery, priceFilter, enabled }) => {
//   const getUrl = useCallback((cursorVal) => {
//     const p = new URLSearchParams({ limit: PAGE_SIZE });
//     if (cursorVal) p.set('cursor', cursorVal);
//     if (searchQuery.trim()) p.set('search', searchQuery.trim());
//     if (priceFilter?.min != null) p.set('min_price', priceFilter.min);
//     if (priceFilter?.max != null) p.set('max_price', priceFilter.max);
//     return `${NODE_API}/api/lease/non-admin/?${p}`;
//   }, [searchQuery, priceFilter]);

//   return usePaginatedFetch(getUrl, [searchQuery, JSON.stringify(priceFilter)], enabled);
// };

// // ─── Hook: lease properties filtered by category_id ───────────────────────────
// const useLeaseByCategory = ({ selectedCategoryId, searchQuery, priceFilter, enabled }) => {
//   const getUrl = useCallback((cursorVal) => {
//     const p = new URLSearchParams({ limit: PAGE_SIZE });
//     if (cursorVal) p.set('cursor', cursorVal);
//     if (searchQuery?.trim()) p.set('search', searchQuery.trim());
//     if (priceFilter?.min != null) p.set('min_price', priceFilter.min);
//     if (priceFilter?.max != null) p.set('max_price', priceFilter.max);
//     return `${NODE_API}/api/lease/by-category/${selectedCategoryId}?${p}`;
//   }, [selectedCategoryId, searchQuery, priceFilter]);

//   return usePaginatedFetch(
//     getUrl,
//     [selectedCategoryId, searchQuery, JSON.stringify(priceFilter)],
//     enabled && selectedCategoryId != null
//   );
// };

// // ─── Main Component ─────────────────────────────────────────────────────────────
// const LeasePropertyCard = () => {
//   const navigate = useNavigate();
//   const { userId, isGuest } = useContext(AuthContext);

//   // ── UI state ─────────────────────────────────────────────────────────────────
//   const [activeTab, setActiveTab] = useState('lease');
//   const [searchQuery, setSearchQuery] = useState('');
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [priceFilter, setPriceFilter] = useState(null);
//   const [currentImageIndex, setCurrentImageIndex] = useState({});

//   const debouncedSearch = useDebounce(searchQuery, 400);
//   const isTyping = searchQuery !== debouncedSearch;

//   // ── Data state ────────────────────────────────────────────────────────────────
//   const [categories, setCategories] = useState([]);
//   const [categoriesLoading, setCategoriesLoading] = useState(true);
//   const [allFetchedProperties, setAllFetchedProperties] = useState([]);

//   // ── Auth / subscription ───────────────────────────────────────────────────────
//   const [savedProperties, setSavedProperties] = useState([]);
//   const [cartItems, setCartItems] = useState([]);
//   const [saving, setSaving] = useState({});
//   const [locationLoading, setLocationLoading] = useState({});
//   const [isSubscribed, setIsSubscribed] = useState(false);
//   const [userPlan, setUserPlan] = useState(null);
//   const [userActivities, setUserActivities] = useState([]);

//   // ── Modals ────────────────────────────────────────────────────────────────────
//   const [showLimitModal, setShowLimitModal] = useState(false);
//   const [showSubscribeModal, setShowSubscribeModal] = useState(false);
//   const [featureRequested, setFeatureRequested] = useState('');
//   const [showAlertModal, setShowAlertModal] = useState(false);
//   const [pendingAction, setPendingAction] = useState(null);
//   const [currentPropertyId, setCurrentPropertyId] = useState(null);
//   const [showGuestModal, setShowGuestModal] = useState(false);
//   const [showSuccess, setShowSuccess] = useState(false);
//   const [showFailure, setShowFailure] = useState(false);
//   const [alertMessage, setAlertMessage] = useState('');

//   // ── Two fetch hooks ───────────────────────────────────────────────────────────
//   const allProps = useAllLeaseProperties({
//     searchQuery: debouncedSearch,
//     priceFilter,
//     enabled: activeTab === 'lease' && !selectedCategory,
//   });

//   const categoryProps = useLeaseByCategory({
//     selectedCategoryId: selectedCategory?.category_id ?? null,
//     searchQuery: debouncedSearch,
//     priceFilter,
//     enabled: activeTab === 'lease' && !!selectedCategory,
//   });

//   const {
//     items: leaseProperties,
//     hasMore: leaseHasMore,
//     loading: leaseListLoading,
//     initialLoading: leaseInitialLoading,
//     isFetching: leaseIsFetching,
//     fetchingRef: leaseFetchingRef,
//     loadMore: leaseLoadMore,
//   } = selectedCategory ? categoryProps : allProps;

//   const showSkeleton = isTyping || leaseIsFetching || leaseFetchingRef?.current;

//   useEffect(() => {
//     if (!leaseProperties.length) return;
//     setAllFetchedProperties(prev => {
//       const existingIds = new Set(prev.map(p => p.id));
//       const newOnes = leaseProperties.filter(p => !existingIds.has(p.id));
//       return newOnes.length ? [...prev, ...newOnes] : prev;
//     });
//   }, [leaseProperties]);

//   // ─── MEMOIZED VALUES ──────────────────────────────────────────────────────────
//   const accessedProperties = useMemo(() => {
//     return allFetchedProperties.filter(property =>
//       userActivities.some(
//         a => String(a.property_id) === String(property.id) && a.activity_as === 'Tenant'
//       )
//     );
//   }, [allFetchedProperties, userActivities]);

//   const properties = useMemo(() => {
//     return activeTab === 'accessed' ? accessedProperties : leaseProperties;
//   }, [activeTab, accessedProperties, leaseProperties]);

//   const hasMore = useMemo(() => {
//     return activeTab === 'accessed' ? false : leaseHasMore;
//   }, [activeTab, leaseHasMore]);

//   const listLoading = useMemo(() => {
//     return activeTab === 'accessed' ? false : leaseListLoading;
//   }, [activeTab, leaseListLoading]);

//   const initialLoading = useMemo(() => {
//     return activeTab === 'accessed' ? false : leaseInitialLoading;
//   }, [activeTab, leaseInitialLoading]);

//   const loadMore = useMemo(() => {
//     return activeTab === 'accessed' ? () => { } : leaseLoadMore;
//   }, [activeTab, leaseLoadMore]);

//   // ── Bootstrap ─────────────────────────────────────────────────────────────────
//   useEffect(() => {
//     setCategoriesLoading(true);
//     fetch(`${NODE_API}/api/lease/categories/`)
//       .then(r => r.json())
//       .then(data => { setCategories(data); setCategoriesLoading(false); })
//       .catch(() => setCategoriesLoading(false));
//   }, []);

//   useEffect(() => {
//     if (!userId) return;

//     axios.get(`${BASE_URL}/Get-user-plan/${userId}/`)
//       .then(r => {
//         const subs = r.data;
//         const tenantSub = Array.isArray(subs) ? subs.find(s => s.user_type === 'Tenant') : null;
//         setIsSubscribed(!!tenantSub);
//         setUserPlan(tenantSub || null);
//       })
//       .catch(() => { setIsSubscribed(false); setUserPlan(null); });

//     axios.get(`${BASE_URL}/get-user-cart/${userId}/`)
//       .then(r => { setCartItems(r.data); setSavedProperties(r.data.map(i => String(i.property_id))); })
//       .catch(e => console.error('Cart error:', e));

//     fetchUserActivities();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [userId]);

//   // ─── FIX: Optimize image index update ────────────────────────────────────────
//   useEffect(() => {
//     setCurrentImageIndex(prev => {
//       let changed = false;
//       const next = { ...prev };
//       properties.forEach(p => {
//         if (!(p.id in next)) {
//           next[p.id] = 0;
//           changed = true;
//         }
//       });
//       return changed ? next : prev;
//     });
//   }, [properties]);

//   // ── Helpers ───────────────────────────────────────────────────────────────────
//   const requireLogin = useCallback((e, cb) => {
//     e.stopPropagation();
//     if (isGuest) { setShowGuestModal(true); return; }
//     cb();
//   }, [isGuest]);

//   const fetchUserActivities = useCallback(async () => {
//     if (!userId) return;
//     try {
//       const res = await fetch(`${BASE_URL}/activities/`);
//       if (!res.ok) throw new Error(`HTTP ${res.status}`);
//       const all = await res.json();
//       setUserActivities(all.filter(a => String(a.user_id) === String(userId)));
//     } catch (e) {
//       console.error('Activities error:', e);
//       setUserActivities([]);
//     }
//   }, [userId]);

//   const isSaved = useCallback((property) => {
//     return savedProperties.includes(property.id);
//   }, [savedProperties]);

//   const addToCart = useCallback(async (propertyId) => {
//     const r = await axios.post(`${BASE_URL}/user-cart/`, { user_id: userId, property_id: propertyId });
//     return r.data;
//   }, [userId]);

//   const removeFromCart = useCallback(async (cartId) => {
//     return axios.delete(`${BASE_URL}/user-cart/${cartId}/`);
//   }, []);

//   const toggleSave = useCallback(async (property) => {
//     const pid = property.id;
//     setSaving(prev => ({ ...prev, [pid]: true }));
//     try {
//       if (isSaved(property)) {
//         const item = cartItems.find(i => i.property_id === pid);
//         await removeFromCart(item.cart_id);
//         setSavedProperties(prev => prev.filter(id => id !== pid));
//         setCartItems(prev => prev.filter(i => i.property_id !== pid));
//       } else {
//         const newItem = await addToCart(pid);
//         setSavedProperties(prev => [...prev, pid]);
//         setCartItems(prev => [...prev, newItem.data]);
//       }
//     } catch (e) { console.error('Save error:', e); }
//     finally { setSaving(prev => ({ ...prev, [pid]: false })); }
//   }, [isSaved, cartItems, addToCart, removeFromCart]);

//   const findProperty = useCallback((propertyId) => {
//     return properties.find(p => p.id === propertyId) ||
//       allFetchedProperties.find(p => p.id === propertyId);
//   }, [properties, allFetchedProperties]);

//   const checkPropertyLimit = useCallback((propertyId) => {
//     if (!isSubscribed) {
//       setFeatureRequested('Property Access');
//       setShowSubscribeModal(true);
//       return false;
//     }
//     if (userPlan?.no_of_properties_unlimited) return true;

//     const alreadyAccessed = userActivities.some(
//       a => a.property_id === propertyId && a.activity_as === 'Tenant'
//     );
//     if (alreadyAccessed) return true;

//     const uniqueProps = new Set(
//       userActivities.filter(a => a.activity_as === 'Tenant').map(a => a.property_id)
//     );
//     if (uniqueProps.size >= (userPlan?.no_of_properties || 10)) {
//       setShowLimitModal(true);
//       return false;
//     }
//     return true;
//   }, [isSubscribed, userPlan, userActivities]);

//   const logActivity = useCallback(async (propertyId, activityType) => {
//     const exists = userActivities.find(
//       a => a.property_id === propertyId && a.activity_as === 'Tenant'
//     );
//     if (exists) return false;

//     const property = findProperty(propertyId);
//     if (!property) return false;

//     try {
//       const res = await fetch(`${BASE_URL}/activities/`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           user_id: userId,
//           property_id: propertyId,
//           activity_type: activityType,
//           property_by: property.owner,
//           activity_as: 'Tenant',
//         }),
//       });
//       if (!res.ok) throw new Error('Failed to log activity');
//       return await res.json();
//     } catch (e) { console.error('logActivity error:', e); return false; }
//   }, [userId, userActivities, findProperty]);

//   const handleAction = useCallback(async (e, propertyId, actionName, actionCallback, activityType) => {
//     e.stopPropagation();
//     if (!isSubscribed) { setFeatureRequested(actionName); setShowSubscribeModal(true); return; }

//     const alreadyAccessed = userActivities.some(
//       a => a.property_id === propertyId && a.activity_as === 'Tenant'
//     );
//     if (!alreadyAccessed) {
//       const ok = checkPropertyLimit(propertyId);
//       if (!ok) return;
//     }

//     setPendingAction(() => async () => {
//       try {
//         await actionCallback();
//         if (activityType && !alreadyAccessed) {
//           const result = await logActivity(propertyId, activityType);
//           if (result) {
//             setUserActivities(prev => [...prev, {
//               user_id: userId,
//               property_id: propertyId,
//               activity_type: activityType,
//               property_by: findProperty(propertyId)?.owner,
//               activity_as: 'Tenant',
//               created_at: new Date().toISOString(),
//             }]);
//           }
//         }
//       } catch (err) {
//         console.error(`${actionName} error:`, err);
//         alert(`Failed to complete ${actionName} action`);
//       }
//     });
//     setCurrentPropertyId(propertyId);
//     setShowAlertModal(true);
//   }, [isSubscribed, userActivities, checkPropertyLimit, logActivity, userId, findProperty]);

//   // ── Action handlers ───────────────────────────────────────────────────────────
//   const handleCallClick = useCallback((e, property) => {
//     return handleAction(e, property.id, 'Call', async () => {
//       try {
//         await navigator.clipboard.writeText(property.mobile_no);
//         setAlertMessage(`Copied: ${property.mobile_no}`);
//         setShowSuccess(true); setShowFailure(false);
//       } catch {
//         setAlertMessage('Failed to copy number');
//         setShowFailure(true); setShowSuccess(false);
//       }
//     }, 'Call');
//   }, [handleAction]);

//   const handleMessageClick = useCallback((e, property) => {
//     return handleAction(e, property.id, 'Message', async () => {
//       navigate('/chat', { state: { property: property.id } });
//     }, 'Call');
//   }, [handleAction, navigate]);

//   const handleShareClick = useCallback(async (e, property) => {
//     e.stopPropagation();
//     const url = `${window.location.origin}/lease-description/${property.id}`;
//     try {
//       await navigator.clipboard.writeText(url);
//       setAlertMessage('Property link copied to clipboard!');
//       setShowSuccess(true);
//       setTimeout(() => setShowSuccess(false), 3000);
//     } catch {
//       try {
//         const ta = document.createElement('textarea');
//         ta.value = url; document.body.appendChild(ta); ta.select();
//         document.execCommand('copy'); document.body.removeChild(ta);
//         setAlertMessage('Property link copied to clipboard!');
//         setShowSuccess(true);
//         setTimeout(() => setShowSuccess(false), 3000);
//       } catch {
//         setAlertMessage('Failed to copy property link');
//         setShowFailure(true);
//         setTimeout(() => setShowFailure(false), 3000);
//       }
//     }
//   }, []);

//   const handleLocationClick = useCallback((e, property) => {
//     return handleAction(e, property.id, 'Location', async () => {
//       setLocationLoading(prev => ({ ...prev, [property.id]: true }));
//       const fallback = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(property.location)}`;
//       const open = (url) => {
//         setLocationLoading(prev => ({ ...prev, [property.id]: false }));
//         window.open(url, '_blank', 'noopener,noreferrer');
//       };
//       if (navigator.geolocation) {
//         navigator.geolocation.getCurrentPosition(
//           ({ coords }) => {
//             const dest = property.lat && property.long
//               ? `https://www.google.com/maps/dir/?api=1&origin=${coords.latitude},${coords.longitude}&destination=${property.lat},${property.long}&travelmode=driving`
//               : fallback;
//             open(dest);
//           },
//           () => open(fallback),
//           { timeout: 10000 }
//         );
//       } else { open(fallback); }
//     }, 'Location');
//   }, [handleAction]);

//   const handleWishlistClick = useCallback((e, property) => {
//     e.stopPropagation();
//     return handleAction(e, property.id, 'Liked', async () => { await toggleSave(property); }, 'Liked');
//   }, [handleAction, toggleSave]);

//   const handleNextImage = useCallback((propertyId, e) => {
//     e.stopPropagation();
//     setCurrentImageIndex(prev => {
//       const p = findProperty(propertyId);
//       return { ...prev, [propertyId]: (prev[propertyId] + 1) % p.images.length };
//     });
//   }, [findProperty]);

//   const handlePrevImage = useCallback((propertyId, e) => {
//     e.stopPropagation();
//     setCurrentImageIndex(prev => {
//       const p = findProperty(propertyId);
//       return { ...prev, [propertyId]: (prev[propertyId] - 1 + p.images.length) % p.images.length };
//     });
//   }, [findProperty]);

//   // ── Card renderer ─────────────────────────────────────────────────────────────
//   const renderCard = useCallback((property, index) => {
//     const isAccessed = userActivities.some(
//       a => String(a.property_id) === String(property.id) && a.activity_as === 'Tenant'
//     );
//     const imgIdx = currentImageIndex[property.id] || 0;

//     // Show AddPropertyCards after every 2 cards
//     const showAddPropertyCards = (index + 1) % 2 === 0;

//     return (
//       <React.Fragment key={property.id}>
//         <Card
//           sx={{
//             mb: 1.2, mx: 2, borderRadius: 3, boxShadow: 2,
//             display: 'flex', // Horizontal layout
//             height: { xs: 140, sm: 170 },
//             transition: 'transform 0.2s ease-in-out',
//             '&:hover': { transform: 'scale(1.015)', boxShadow: 4 },
//           }}
//           onClick={async (e) => {
//             if (e.target.closest('button') || e.target.closest('svg')) return;
//             if (!isSubscribed) { setFeatureRequested('View Details'); setShowSubscribeModal(true); return; }
//             const alreadyAccessed = userActivities.some(
//               a => a.property_id === property.id && a.activity_as === 'Tenant'
//             );
//             if (!alreadyAccessed) {
//               const ok = checkPropertyLimit(property.id);
//               if (!ok) return;
//               try { await logActivity(property.id, 'Description'); } catch { }
//             }
//             navigate(`/lease-description/${property.id}`, {
//               state: { propertyId: property.id, property: property.propertyData },
//             });
//           }}
//         >
//           {/* Left: Image - 40% */}
//           <Box sx={{
//             position: 'relative',
//             width: '40%',
//             minWidth: '40%',
//             height: '100%',
//             overflow: 'hidden',
//           }}>
//             <CardMedia
//               component="img"
//               image={property.images[imgIdx]}
//               alt="Property"
//               sx={{
//                 width: '100%',
//                 height: '100%',
//                 objectFit: 'cover',
//                 borderTopLeftRadius: 12,
//                 borderBottomLeftRadius: 12,
//               }}
//             />

//             {property.images.length > 1 && (
//               <>
//                 <IconButton
//                   sx={{
//                     position: 'absolute',
//                     top: '50%',
//                     left: 4,
//                     transform: 'translateY(-50%)',
//                     backgroundColor: 'rgba(255,255,255,0.7)',
//                     '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' },
//                     padding: '4px',
//                     width: '24px',
//                     height: '24px',
//                   }}
//                   onClick={e => handlePrevImage(property.id, e)}
//                 >
//                   <ChevronLeft fontSize="small" />
//                 </IconButton>
//                 <IconButton
//                   sx={{
//                     position: 'absolute',
//                     top: '50%',
//                     right: 4,
//                     transform: 'translateY(-50%)',
//                     backgroundColor: 'rgba(255,255,255,0.7)',
//                     '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' },
//                     padding: '4px',
//                     width: '24px',
//                     height: '24px',
//                   }}
//                   onClick={e => handleNextImage(property.id, e)}
//                 >
//                   <ChevronRight fontSize="small" />
//                 </IconButton>
//               </>
//             )}

//             {/* Image indicators - dots */}
//             {property.images.length > 1 && (
//               <Box sx={{
//                 position: 'absolute',
//                 bottom: 4,
//                 left: '50%',
//                 transform: 'translateX(-50%)',
//                 display: 'flex',
//                 gap: 0.5
//               }}>
//                 {property.images.map((_, i) => (
//                   <Box key={i}
//                     onClick={e => {
//                       e.stopPropagation();
//                       setCurrentImageIndex(prev => ({ ...prev, [property.id]: i }));
//                     }}
//                     sx={{
//                       width: 5,
//                       height: 5,
//                       borderRadius: '50%',
//                       cursor: 'pointer',
//                       transition: 'background-color 0.3s',
//                       backgroundColor: imgIdx === i ? '#1976d2' : 'rgba(255,255,255,0.6)'
//                     }}
//                   />
//                 ))}
//               </Box>
//             )}

//             {/* Accessed badge */}
//             {isAccessed && (
//               <Box sx={{
//                 position: 'absolute',
//                 top: 6,
//                 left: 6,
//                 bgcolor: 'rgba(46, 125, 50, 0.9)',
//                 borderRadius: '50%',
//                 p: 0.3,
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//               }}>
//                 <CheckCircle sx={{ fontSize: 16, color: 'white' }} />
//               </Box>
//             )}
//           </Box>

//           {/* Right: Content - 60% */}
//           <Box
//             sx={{
//               width: '60%',
//               display: 'flex',
//               flexDirection: 'column',
//               minWidth: 0,
//               height: '100%',
//               p: { xs: 0.45, sm: 0.6 },
//               boxSizing: 'border-box',
//               justifyContent: 'space-between',
//             }}
//           >
//             {/* TOP SECTION - Title, Location, Price */}
//             <Box>
//               {/* TITLE + ACTIONS */}
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'space-between',
//                   width: '100%',
//                   minWidth: 0,
//                   mb: 0.1,
//                 }}
//               >
//                 <Typography
//                   noWrap
//                   sx={{
//                     flex: 1,
//                     minWidth: 0,
//                     overflow: 'hidden',
//                     textOverflow: 'ellipsis',
//                     color: '#2C1810',
//                     fontWeight: 700,
//                     fontSize: { xs: '0.74rem', sm: '0.75rem' },
//                     lineHeight: 1.20,
//                     mr: 0.3,
//                   }}
//                 >
//                   {property.title}
//                   {property.property_name ? ` - ${property.property_name}` : ''}
//                 </Typography>

//                 <Box
//                   sx={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: 0.1,
//                     flexShrink: 0,
//                   }}
//                 >
//                   <IconButton
//                     onClick={(e) => requireLogin(e, () => handleWishlistClick(e, property))}
//                     disabled={saving[property.id]}
//                     size="small"
//                     sx={{
//                       width: 25,
//                       height: 25,
//                       p: 0,
//                       bgcolor: '#FFFFFF',
//                       boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
//                       '&:hover': { bgcolor: '#F5EDE4' },
//                     }}
//                   >
//                     {isSaved(property) ? (
//                       <Favorite sx={{ fontSize: 17, color: '#D92D20' }} />
//                     ) : (
//                       <FavoriteBorder sx={{ fontSize: 18, color: '#8D6E63' }} />
//                     )}
//                   </IconButton>

//                   <IconButton
//                     onClick={(e) => requireLogin(e, () => handleShareClick(e, property))}
//                     size="small"
//                     sx={{
//                       width: 25,
//                       height: 25,
//                       p: 0,
//                       bgcolor: '#FFFFFF',
//                       boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
//                       '&:hover': { bgcolor: '#F5EDE4' },
//                     }}
//                   >
//                     <Share sx={{ fontSize: 14, color: '#8D6E63' }} />
//                   </IconButton>
//                 </Box>
//               </Box>

//               {/* LOCATION */}
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   minWidth: 0,
//                   mb: 0.05,
//                   mt: 1
//                 }}
//               >
//                 <IconButton
//                   onClick={e => requireLogin(e, () => handleLocationClick(e, property))}
//                   size="small" sx={{ p: 0.5 }}
//                   disabled={locationLoading[property.id]}
//                 >
//                   {locationLoading[property.id]
//                     ? <CircularProgress size={14} />
//                     : <>
//                       <LocationOn
//                         sx={{
//                           color: '#B66A18',
//                           fontSize: '16px',
//                         }}
//                       />
//                     </>}
//                 </IconButton>

//                 <Typography
//                   noWrap
//                   sx={{
//                     minWidth: 0,
//                     overflow: 'hidden',
//                     textOverflow: 'ellipsis',
//                     color: '#5D4037',
//                     fontSize: { xs: '0.68rem', sm: '0.8rem' },
//                     lineHeight: 1.1,
//                     fontWeight: 500,
//                   }}
//                 >
//                   {property.location || 'Location not available'}
//                 </Typography>
//               </Box>

//               {/* PRICE + DATE */}
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'space-between',
//                   width: '100%',
//                   mb: 0.15,
//                   mt: 1
//                 }}
//               >
//                 <Typography
//                   noWrap
//                   sx={{
//                     color: "#c98a2c",
//                     fontWeight: 700,
//                     fontSize: { xs: '0.90rem', sm: '0.95rem' },
//                     lineHeight: 1.15,
//                     letterSpacing: '0.3px',
//                   }}
//                 >
//                   ₹{Number(String(property.price || '').replace(/[^0-9]/g, '')).toLocaleString('en-IN')}
//                 </Typography>

//                 <Box
//                   sx={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     flexShrink: 0,
//                     bgcolor: 'rgba(255,255,255,0.6)',
//                     px: 0.4,
//                     py: 0.1,
//                     borderRadius: '4px',
//                   }}
//                 >
//                   <Typography
//                     noWrap
//                     sx={{
//                       color: '#121212',
//                       fontSize: { xs: '0.60rem', sm: '0.58rem' },
//                       fontWeight: 500,
//                     }}
//                   >
//                     {property.date
//                       ? new Date(property.date).toLocaleDateString('en-IN', {
//                           day: '2-digit',
//                           month: '2-digit',
//                           year: 'numeric',
//                         })
//                       : '--'}
//                   </Typography>
//                 </Box>
//               </Box>
//             </Box>

//             {/* BOTTOM SECTION - Property Details */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 width: '100%',
//                 minWidth: 0,
//                 borderRadius: '6px',
//                 overflow: 'hidden',
//                 height: { xs: 35, sm: 32 },
//                 backgroundColor: '#FFFFFF',
//                 bgcolor: '#f1ce9943',
//                 boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
//                 mt: 0,
//               }}
//             >
//               {/* FACING */}
//               <Box
//                 sx={{
//                   flex: 1,
//                   minWidth: 0,
//                   py: 0.25,
//                   px: 0.2,
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   gap: 0.2,
//                   borderRight: '1px solid #E8DDD0',
//                 }}
//               >
//                 <ExploreOutlined sx={{ fontSize: 13, color: '#8D6E63' }} />
//                 <Box sx={{ minWidth: 0 }}>
//                   <Typography
//                     sx={{
//                       color: '#121212',
//                       fontSize: { xs: '0.4rem', sm: '0.46rem' },
//                       lineHeight: 2,
//                       fontWeight: 500,
//                     }}
//                   >
//                     Facing
//                   </Typography>
//                   <Typography
//                     noWrap
//                     sx={{
//                       color: '#2C1810',
//                       fontWeight: 700,
//                       fontSize: { xs: '0.45rem', sm: '0.52rem' },
//                       lineHeight: 1.15,
//                     }}
//                   >
//                     {property.facing || 'N/A'}
//                   </Typography>
//                 </Box>
//               </Box>

//               {/* AREA */}
//               <Box
//                 sx={{
//                   flex: 1,
//                   minWidth: 0,
//                   py: 0.25,
//                   px: 0.2,
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   gap: 0.2,
//                   borderRight: '1px solid #E8DDD0',
//                 }}
//               >
//                 <SquareFootOutlined sx={{ fontSize: 13, color: '#B66A18' }} />
//                 <Box sx={{ minWidth: 0 }}>
//                   <Typography
//                     sx={{
//                       color: '#121212',
//                       fontSize: { xs: '0.4rem', sm: '0.46rem' },
//                       lineHeight: 2,
//                       fontWeight: 500,
//                     }}
//                   >
//                     Area
//                   </Typography>
//                   <Typography
//                     noWrap
//                     sx={{
//                       color: '#2C1810',
//                       fontWeight: 700,
//                       fontSize: { xs: '0.45rem', sm: '0.52rem' },
//                       lineHeight: 1.15,
//                     }}
//                   >
//                     {property.area || property.max_acres || 'N/A'}
//                   </Typography>
//                 </Box>
//               </Box>

//               {/* POSTED BY */}
//               <Box
//                 sx={{
//                   flex: 1,
//                   minWidth: 0,
//                   py: 0.25,
//                   px: 0.2,
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   gap: 0.2,
//                 }}
//               >
//                 <PersonOutlineOutlined sx={{ fontSize: 13, color: '#8D6E63' }} />
//                 <Box sx={{ minWidth: 0 }}>
//                   <Typography
//                     sx={{
//                       color: '#121212',
//                       fontSize: { xs: '0.4rem', sm: '0.46rem' },
//                       lineHeight: 2,
//                       fontWeight: 500,
//                     }}
//                   >
//                     Posted By
//                   </Typography>
//                   <Typography
//                     noWrap
//                     sx={{
//                       color: '#2C1810',
//                       fontWeight: 700,
//                       fontSize: { xs: '0.45rem', sm: '0.52rem' },
//                       lineHeight: 1.15,
//                     }}
//                   >
//                     {property.posted_by || 'N/A'}
//                   </Typography>
//                 </Box>
//               </Box>
//             </Box>
//           </Box>
//         </Card>

//         {/* Show AddPropertyCards after every 2 cards */}
//         {showAddPropertyCards && <AddPropertyCards panel="lease" />}
//       </React.Fragment>
//     );
//   }, [
//     userActivities, currentImageIndex, isSubscribed, checkPropertyLimit,
//     logActivity, navigate, requireLogin, handleWishlistClick, handleShareClick,
//     handleLocationClick, handleMessageClick, handleCallClick, saving,
//     isSaved, handlePrevImage, handleNextImage
//   ]);

//   // ── Properties list ───────────────────────────────────────────────────────────
//   const renderPropertiesSection = useMemo(() => {
//     if (initialLoading) {
//       return (
//         <Box sx={{ mt: 1 }}>
//           {[1, 2, 3].map(i => <SkeletonCard key={i} />)}
//         </Box>
//       );
//     }

//     if (activeTab === 'lease' && showSkeleton) {
//       return (
//         <Box>
//           {isTyping && (
//             <Box sx={{
//               display: 'flex', alignItems: 'center', justifyContent: 'center',
//               gap: 1, py: 1.5
//             }}>
//               <CircularProgress size={16} sx={{ color: '#8B7355' }} />
//               <Typography variant="caption" sx={{ color: '#888' }}>Searching...</Typography>
//             </Box>
//           )}
//           <Box sx={{ mt: isTyping ? 0.5 : 1 }}>
//             {[1, 2, 3].map(i => <SkeletonCard key={i} />)}
//           </Box>
//         </Box>
//       );
//     }

//     if (properties.length === 0) {
//       return (
//         <Box sx={{
//           display: 'flex', flexDirection: 'column', justifyContent: 'center',
//           alignItems: 'center', height: 200, gap: 1, px: 2
//         }}>
//           <Typography variant="body2" color="text.secondary">
//             {activeTab === 'accessed'
//               ? "You haven't accessed any properties yet"
//               : selectedCategory
//                 ? `No properties found for "${selectedCategory.category}"`
//                 : debouncedSearch
//                   ? `No results for "${debouncedSearch}"`
//                   : 'No properties available right now.'}
//           </Typography>
//         </Box>
//       );
//     }

//     return (
//       <>
//         {properties.map((property, index) => renderCard(property, index))}
//         <ScrollSentinel onVisible={loadMore} hasMore={hasMore} loading={listLoading} />
//       </>
//     );
//   }, [
//     initialLoading, activeTab, showSkeleton, isTyping, properties,
//     selectedCategory, debouncedSearch, renderCard, loadMore,
//     hasMore, listLoading
//   ]);

//   // ── JSX ───────────────────────────────────────────────────────────────────────
//   return (
//     <Box sx={{ backgroundColor: 'rgb(239, 231, 221)', minHeight: '120vh' }}>

//       {/* Fixed header */}
//       <Box sx={{
//         position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1200,
//         backgroundColor: 'rgb(239, 231, 221)'
//       }}>

//         {/* Search bar */}
//         <Box sx={{ px: 1, py: 1 }}>
//           <CustomSearchBar
//             value={searchQuery}
//             onChange={e => setSearchQuery(e.target.value)}
//             onPriceFilterChange={setPriceFilter}
//           />
//         </Box>

//         {/* Tabs — Lease | Accessed */}
//         <Box sx={{ px: 2, pb: 1 }}>
//           <Tabs
//             value={activeTab}
//             onChange={(e, newValue) => {
//               setActiveTab(newValue);
//               if (newValue === 'accessed') setSelectedCategory(null);
//             }}
//             sx={{ '& .MuiTabs-indicator': { backgroundColor: 'black', height: 3 } }}
//           >
//             <Tab
//               label="Lease Properties"
//               value="lease"
//               sx={{
//                 textTransform: 'none', fontWeight: 'bold',
//                 color: activeTab === 'lease' ? 'black' : 'text.secondary',
//                 minWidth: 0, mr: 2,
//               }}
//             />
//             <Tab
//               label="Accessed Properties"
//               value="accessed"
//               sx={{
//                 textTransform: 'none', fontWeight: 'bold',
//                 color: activeTab === 'accessed' ? 'black' : 'text.secondary',
//                 minWidth: 0,
//               }}
//             />
//           </Tabs>
//         </Box>

//         {/* Category chips — only on Lease tab */}
//         {activeTab === 'lease' && (
//           <Box sx={{ px: 2, pb: 1 }}>
//             {categoriesLoading ? (
//               <ChipRowSkeleton />
//             ) : (
//               <Box sx={{
//                 display: 'flex', gap: 1, overflowX: 'auto', whiteSpace: 'nowrap', pb: 0.5,
//                 '&::-webkit-scrollbar': { height: 3 },
//                 '&::-webkit-scrollbar-thumb': { background: '#ccc', borderRadius: 2 },
//               }}>
//                 {categories.map((cat) => (
//                   <Chip
//                     key={cat.category_id}
//                     label={cat.category}
//                     variant="filled"
//                     onClick={() =>
//                       setSelectedCategory(prev =>
//                         prev?.category_id === cat.category_id ? null : cat
//                       )
//                     }
//                     sx={{
//                       flexShrink: 0,
//                       bgcolor: selectedCategory?.category_id === cat.category_id ? '#000000' : 'transparent',
//                       color: selectedCategory?.category_id === cat.category_id ? '#ffffff' : '#000000',
//                       border: '1px solid black',
//                       fontWeight: 'bold',
//                       cursor: 'pointer',
//                       '&:hover': {
//                         bgcolor: selectedCategory?.category_id === cat.category_id
//                           ? '#000000'
//                           : 'rgba(0,0,0,0.1)',
//                       },
//                     }}
//                   />
//                 ))}
//               </Box>
//             )}
//           </Box>
//         )}
//       </Box>

//       {/* Scrollable list - adjusted padding for horizontal cards */}
//       <Box sx={{
//         pb: 8,
//         pt: activeTab === 'lease'
//           ? { xs: '175px', sm: '180px' }
//           : { xs: '130px', sm: '115px' },
//       }}>
//         {renderPropertiesSection}
//       </Box>

//       {/* Modals */}
//       <GuestLoginModal open={showGuestModal} onClose={() => setShowGuestModal(false)} />

//       <AlertModal
//         open={showAlertModal}
//         onClose={() => setShowAlertModal(false)}
//         onConfirm={async () => { setShowAlertModal(false); if (pendingAction) await pendingAction(); }}
//         title="Confirm Action"
//         message="Are you sure you want to perform this action on this property?"
//       />

//       <SubscriptionModal
//         open={showSubscribeModal}
//         onClose={() => setShowSubscribeModal(false)}
//         onSubscribe={() => { setShowSubscribeModal(false); navigate('/user-subscription'); }}
//         featureRequested={featureRequested}
//       />

//       <LimitModal open={showLimitModal} onClose={() => setShowLimitModal(false)} userPlan={userPlan} />

//       {showSuccess && (
//         <CopySuccessAlert
//           message={alertMessage}
//           onClose={() => { setShowSuccess(false); setAlertMessage(''); }}
//         />
//       )}
//       {showFailure && (
//         <CopyFailureAlert
//           message={alertMessage}
//           onClose={() => { setShowFailure(false); setAlertMessage(''); }}
//         />
//       )}

//       <BottomNavbar />
//     </Box>
//   );
// };

// export default LeasePropertyCard;

// import React, { useState, useEffect, useRef, useCallback, useContext, useMemo } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { AuthContext } from './../../AuthContext/AuthContext';
// import {
//   Box, Card, CardContent, CardMedia, Typography, IconButton,
//   Button, Tooltip, Chip, CircularProgress, Tabs, Tab,
// } from '@mui/material';
// import { CheckCircle, ExploreOutlined, SquareFootOutlined, PersonOutlineOutlined } from '@mui/icons-material';
// import {
//   FavoriteBorder, Favorite, Share, Call, Chat,
//   LocationOn, ChevronLeft, ChevronRight,
// } from '@mui/icons-material';
// import axios from 'axios';
// import buildingImage from './../../../Images/house.jpeg';
// import CustomSearchBar from './CustomSearch';
// import BottomNavbar from './CustomBottomNav';
// import { BASE_URL } from './../../Api/ApiUrls';
// import LimitModal from '../Buy Module/LimitModal';
// import SubscriptionModal from '../Buy Module/SubscriptionModal';
// import AlertModal from '../Buy Module/AlertModal';
// import GuestLoginModal from '../../GuestLoginModal';
// import CopyFailureAlert from '../Alertpage/CopyAlert/CopyFailureAlert';
// import CopySuccessAlert from '../Alertpage/CopyAlert/CopySuccessAlert';
// import { NODE_API } from '../Buy Module/NodeApi';
// // Add this import
// import AddPropertyCards from '../AddsProducts/AddPropertyCards';

// const PAGE_SIZE = 20;

// // ─── Skeleton card ──────────────────────────────────────────────────────────────
// const SkeletonCard = () => (
//   <Box sx={{
//     mb: 1.2, mx: 2, borderRadius: 3, overflow: 'hidden', boxShadow: 2,
//     backgroundColor: '#fff',
//     animation: 'skeletonPulse 1.5s ease-in-out infinite',
//     '@keyframes skeletonPulse': { '0%,100%': { opacity: 1 }, '50%': { opacity: 0.45 } },
//   }}>
//     <Box sx={{ display: 'flex', height: 140 }}>
//       <Box sx={{ width: '40%', backgroundColor: '#ddd' }} />
//       <Box sx={{ width: '60%', p: 1.5 }}>
//         <Box sx={{ height: 14, backgroundColor: '#e0e0e0', borderRadius: 1, mb: 1, width: '65%' }} />
//         <Box sx={{ height: 12, backgroundColor: '#e0e0e0', borderRadius: 1, mb: 1, width: '45%' }} />
//         <Box sx={{ height: 12, backgroundColor: '#e0e0e0', borderRadius: 1, mb: 1.5, width: '55%' }} />
//         <Box sx={{ display: 'flex', gap: 1 }}>
//           <Box sx={{ flex: 1, height: 32, backgroundColor: '#e0e0e0', borderRadius: 1 }} />
//           <Box sx={{ flex: 1, height: 32, backgroundColor: '#e0e0e0', borderRadius: 1 }} />
//           <Box sx={{ flex: 1, height: 32, backgroundColor: '#e0e0e0', borderRadius: 1 }} />
//         </Box>
//       </Box>
//     </Box>
//   </Box>
// );

// // ─── Chip skeleton row ──────────────────────────────────────────────────────────
// // ✅ MATCHED to PropertyCard.js (gap 0.6, height 24, borderRadius 20px, px 0)
// const ChipRowSkeleton = () => (
//   <Box sx={{ display: 'flex', gap: 0.6, px: 0, pb: 1, overflowX: 'hidden' }}>
//     {[80, 60, 100, 70, 90].map((w, i) => (
//       <Box
//         key={i}
//         sx={{
//           width: w,
//           height: 24,
//           borderRadius: '20px',
//           flexShrink: 0,
//           backgroundColor: '#d0d0d0',
//           animation: 'skeletonPulse 1.5s ease-in-out infinite',
//           '@keyframes skeletonPulse': {
//             '0%,100%': { opacity: 1 },
//             '50%': { opacity: 0.45 },
//           },
//         }}
//       />
//     ))}
//   </Box>
// );

// // ─── Scroll sentinel ────────────────────────────────────────────────────────────
// const ScrollSentinel = ({ onVisible, hasMore, loading }) => {
//   const ref = useRef(null);
//   useEffect(() => {
//     const el = ref.current;
//     if (!el) return;
//     const observer = new IntersectionObserver(
//       ([entry]) => { if (entry.isIntersecting && hasMore && !loading) onVisible(); },
//       { threshold: 0.1, rootMargin: '200px' }
//     );
//     observer.observe(el);
//     return () => observer.disconnect();
//   }, [onVisible, hasMore, loading]);

//   return (
//     <Box ref={ref} sx={{ py: 3, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//       {loading && <CircularProgress size={28} sx={{ color: '#8B7355' }} />}
//       {!loading && !hasMore && (
//         <Typography variant="caption" sx={{ color: '#999', fontStyle: 'italic' }}>
//           ✓ All properties loaded
//         </Typography>
//       )}
//     </Box>
//   );
// };

// // ─── Parse raw API row → card shape ────────────────────────────────────────────
// const parseProperty = (item) => {
//   const parseCoord = (coord) => {
//     if (!coord) return null;
//     return parseFloat(String(coord).replace(/"/g, '').replace(':', '.'));
//   };

//   let images = [buildingImage];
//   if (item.property_images?.length > 0) {
//     images = item.property_images.map(img => {
//       if (typeof img === 'string') return img.startsWith('http') ? img : `${BASE_URL}${img}`;
//       if (img.image)
//         return img.image.startsWith('http')
//           ? img.image
//           : `${BASE_URL}/${img.image.replace(/^\/+/, '')}`;
//       if (img.url) return img.url.startsWith('http') ? img.url : `${BASE_URL}${img.url}`;
//       if (img.path) return img.path.startsWith('http') ? img.path : `${BASE_URL}${img.path}`;
//       return buildingImage;
//     });
//   } else if (item.images?.length > 0) {
//     images = item.images.map(img =>
//       typeof img === 'string' && img.startsWith('http') ? img : `${BASE_URL}${img}`
//     );
//   }

//   return {
//     id: String(item.property_id),
//     title: item.category_name || item.property_type || 'Property',
//     property_name: item.property_name,
//     location: item.location || 'Not specified',
//     date: item.created_at?.split('T')[0],
//     facing: item.facing?.replace(/"/g, '') || 'N/A',
//     city_town: item.city_town || 'Unknown',
//     price: Number(item.price) || 0,
//     possession: item.possession || 'Not specified',
//     createdAt: item.created_at,
//     fullData: item,
//     length: item.length,
//     width: item.width,
//     listedBy: item.posted_by?.replace(/"/g, '') || 'Agent',
//     mobile_no: item.mobile_no,
//     bank_pro_doc: item.bank_pro_doc || [],
//     bank_contact_details: item.bank_contact_details || 'Not available',
//     units: item.units || '',
//     auction_start_datetime: item.auction_start_datetime,
//     auction_end_datetime: item.auction_end_datetime,
//     emd_amount: item.emd_amount || 0,
//     bid_increment: item.bid_increment || 0,
//     category_id: item.category_id,
//     category_name: item.category_name || '',
//     images,
//     site_area: item.site_area,
//     area: item.site_area
//       ? `${item.site_area} ${['ft', 'm', 'cm', 'in'].includes(item.units) ? `Sq ${item.units}` : item.units || 'Sq ft'}`
//       : 0,
//     max_acres: item.max_acres ? `${item.max_acres} ${item.units || 'acres'}` : 'N/A',
//     dimensions: item.roadwidth ? `${item.roadwidth} ft road` : 'N/A',
//     posted_by: item.posted_by?.replace(/"/g, '') || 'Agent',
//     lat: parseCoord(item.lat),
//     long: parseCoord(item.long),
//     owner: item.user_id,
//     propertyData: item,
//     property_images: item.property_images,
//     property_type: item.property_type || '',
//   };
// };

// // ─── Debounce hook ──────────────────────────────────────────────────────────────
// const useDebounce = (value, delay) => {
//   const [debounced, setDebounced] = useState(value);
//   useEffect(() => {
//     const t = setTimeout(() => setDebounced(value), delay);
//     return () => clearTimeout(t);
//   }, [value, delay]);
//   return debounced;
// };

// // ─── Generic paginated fetch hook ──────────────────────────────────────────────
// const usePaginatedFetch = (getUrl, deps, enabled = true) => {
//   const [items, setItems] = useState([]);
//   const [cursor, setCursor] = useState(null);
//   const [hasMore, setHasMore] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [initialLoading, setInitialLoading] = useState(true);

//   const fetchingRef = useRef(false);
//   const [isFetching, setIsFetching] = useState(false);

//   const setFetching = (val) => {
//     fetchingRef.current = val;
//     setIsFetching(val);
//   };

//   const abortRef = useRef(null);

//   useEffect(() => {
//     if (!enabled) return;

//     if (abortRef.current) abortRef.current.abort();
//     const ctrl = new AbortController();
//     abortRef.current = ctrl;

//     setItems([]);
//     setCursor(null);
//     setHasMore(false);
//     setInitialLoading(true);
//     setFetching(true);

//     fetch(getUrl(null), { signal: ctrl.signal })
//       .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
//       .then(json => {
//         setItems((json.data || []).map(i => parseProperty(i)));
//         setCursor(json.next_cursor ?? null);
//         setHasMore(json.has_more ?? false);
//       })
//       .catch(err => { if (err.name !== 'AbortError') console.error('fetch error:', err); })
//       .finally(() => {
//         setInitialLoading(false);
//         setFetching(false);
//       });

//     return () => ctrl.abort();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [...deps, enabled]);

//   const loadMore = useCallback(() => {
//     if (loading || !hasMore || !cursor) return;

//     if (abortRef.current) abortRef.current.abort();
//     const ctrl = new AbortController();
//     abortRef.current = ctrl;

//     setLoading(true);

//     fetch(getUrl(cursor), { signal: ctrl.signal })
//       .then(r => r.json())
//       .then(json => {
//         setItems(prev => [...prev, ...(json.data || []).map(i => parseProperty(i))]);
//         setCursor(json.next_cursor ?? null);
//         setHasMore(json.has_more ?? false);
//       })
//       .catch(err => { if (err.name !== 'AbortError') console.error('loadMore error:', err); })
//       .finally(() => setLoading(false));
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [loading, hasMore, cursor, ...deps]);

//   return { items, hasMore, loading, initialLoading, isFetching, fetchingRef, loadMore };
// };

// // ─── Hook: all lease properties ─────────────────────────────────────────────────
// const useAllLeaseProperties = ({ searchQuery, priceFilter, enabled }) => {
//   const getUrl = useCallback((cursorVal) => {
//     const p = new URLSearchParams({ limit: PAGE_SIZE });
//     if (cursorVal) p.set('cursor', cursorVal);
//     if (searchQuery.trim()) p.set('search', searchQuery.trim());
//     if (priceFilter?.min != null) p.set('min_price', priceFilter.min);
//     if (priceFilter?.max != null) p.set('max_price', priceFilter.max);
//     return `${NODE_API}/api/lease/non-admin/?${p}`;
//   }, [searchQuery, priceFilter]);

//   return usePaginatedFetch(getUrl, [searchQuery, JSON.stringify(priceFilter)], enabled);
// };

// // ─── Hook: lease properties filtered by category_id ───────────────────────────
// const useLeaseByCategory = ({ selectedCategoryId, searchQuery, priceFilter, enabled }) => {
//   const getUrl = useCallback((cursorVal) => {
//     const p = new URLSearchParams({ limit: PAGE_SIZE });
//     if (cursorVal) p.set('cursor', cursorVal);
//     if (searchQuery?.trim()) p.set('search', searchQuery.trim());
//     if (priceFilter?.min != null) p.set('min_price', priceFilter.min);
//     if (priceFilter?.max != null) p.set('max_price', priceFilter.max);
//     return `${NODE_API}/api/lease/by-category/${selectedCategoryId}?${p}`;
//   }, [selectedCategoryId, searchQuery, priceFilter]);

//   return usePaginatedFetch(
//     getUrl,
//     [selectedCategoryId, searchQuery, JSON.stringify(priceFilter)],
//     enabled && selectedCategoryId != null
//   );
// };

// // ─── Main Component ─────────────────────────────────────────────────────────────
// const LeasePropertyCard = () => {
//   const navigate = useNavigate();
//   const { userId, isGuest } = useContext(AuthContext);

//   // ── UI state ─────────────────────────────────────────────────────────────────
//   const [activeTab, setActiveTab] = useState('lease');
//   const [searchQuery, setSearchQuery] = useState('');
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [priceFilter, setPriceFilter] = useState(null);
//   const [currentImageIndex, setCurrentImageIndex] = useState({});

//   const debouncedSearch = useDebounce(searchQuery, 400);
//   const isTyping = searchQuery !== debouncedSearch;

//   // ── Data state ────────────────────────────────────────────────────────────────
//   const [categories, setCategories] = useState([]);
//   const [categoriesLoading, setCategoriesLoading] = useState(true);
//   const [allFetchedProperties, setAllFetchedProperties] = useState([]);

//   // ── Auth / subscription ───────────────────────────────────────────────────────
//   const [savedProperties, setSavedProperties] = useState([]);
//   const [cartItems, setCartItems] = useState([]);
//   const [saving, setSaving] = useState({});
//   const [locationLoading, setLocationLoading] = useState({});
//   const [isSubscribed, setIsSubscribed] = useState(false);
//   const [userPlan, setUserPlan] = useState(null);
//   const [userActivities, setUserActivities] = useState([]);

//   // ── Modals ────────────────────────────────────────────────────────────────────
//   const [showLimitModal, setShowLimitModal] = useState(false);
//   const [showSubscribeModal, setShowSubscribeModal] = useState(false);
//   const [featureRequested, setFeatureRequested] = useState('');
//   const [showAlertModal, setShowAlertModal] = useState(false);
//   const [pendingAction, setPendingAction] = useState(null);
//   const [currentPropertyId, setCurrentPropertyId] = useState(null);
//   const [showGuestModal, setShowGuestModal] = useState(false);
//   const [showSuccess, setShowSuccess] = useState(false);
//   const [showFailure, setShowFailure] = useState(false);
//   const [alertMessage, setAlertMessage] = useState('');

//   // ── Two fetch hooks ───────────────────────────────────────────────────────────
//   const allProps = useAllLeaseProperties({
//     searchQuery: debouncedSearch,
//     priceFilter,
//     enabled: activeTab === 'lease' && !selectedCategory,
//   });

//   const categoryProps = useLeaseByCategory({
//     selectedCategoryId: selectedCategory?.category_id ?? null,
//     searchQuery: debouncedSearch,
//     priceFilter,
//     enabled: activeTab === 'lease' && !!selectedCategory,
//   });

//   const {
//     items: leaseProperties,
//     hasMore: leaseHasMore,
//     loading: leaseListLoading,
//     initialLoading: leaseInitialLoading,
//     isFetching: leaseIsFetching,
//     fetchingRef: leaseFetchingRef,
//     loadMore: leaseLoadMore,
//   } = selectedCategory ? categoryProps : allProps;

//   const showSkeleton = isTyping || leaseIsFetching || leaseFetchingRef?.current;

//   useEffect(() => {
//     if (!leaseProperties.length) return;
//     setAllFetchedProperties(prev => {
//       const existingIds = new Set(prev.map(p => p.id));
//       const newOnes = leaseProperties.filter(p => !existingIds.has(p.id));
//       return newOnes.length ? [...prev, ...newOnes] : prev;
//     });
//   }, [leaseProperties]);

//   // ─── MEMOIZED VALUES ──────────────────────────────────────────────────────────
//   const accessedProperties = useMemo(() => {
//     return allFetchedProperties.filter(property =>
//       userActivities.some(
//         a => String(a.property_id) === String(property.id) && a.activity_as === 'Tenant'
//       )
//     );
//   }, [allFetchedProperties, userActivities]);

//   const properties = useMemo(() => {
//     return activeTab === 'accessed' ? accessedProperties : leaseProperties;
//   }, [activeTab, accessedProperties, leaseProperties]);

//   const hasMore = useMemo(() => {
//     return activeTab === 'accessed' ? false : leaseHasMore;
//   }, [activeTab, leaseHasMore]);

//   const listLoading = useMemo(() => {
//     return activeTab === 'accessed' ? false : leaseListLoading;
//   }, [activeTab, leaseListLoading]);

//   const initialLoading = useMemo(() => {
//     return activeTab === 'accessed' ? false : leaseInitialLoading;
//   }, [activeTab, leaseInitialLoading]);

//   const loadMore = useMemo(() => {
//     return activeTab === 'accessed' ? () => { } : leaseLoadMore;
//   }, [activeTab, leaseLoadMore]);

//   // ── Bootstrap ─────────────────────────────────────────────────────────────────
//   useEffect(() => {
//     setCategoriesLoading(true);
//     fetch(`${NODE_API}/api/lease/categories/`)
//       .then(r => r.json())
//       .then(data => { setCategories(data); setCategoriesLoading(false); })
//       .catch(() => setCategoriesLoading(false));
//   }, []);

//   useEffect(() => {
//     if (!userId) return;

//     axios.get(`${BASE_URL}/Get-user-plan/${userId}/`)
//       .then(r => {
//         const subs = r.data;
//         const tenantSub = Array.isArray(subs) ? subs.find(s => s.user_type === 'Tenant') : null;
//         setIsSubscribed(!!tenantSub);
//         setUserPlan(tenantSub || null);
//       })
//       .catch(() => { setIsSubscribed(false); setUserPlan(null); });

//     axios.get(`${BASE_URL}/get-user-cart/${userId}/`)
//       .then(r => { setCartItems(r.data); setSavedProperties(r.data.map(i => String(i.property_id))); })
//       .catch(e => console.error('Cart error:', e));

//     fetchUserActivities();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [userId]);

//   // ─── FIX: Optimize image index update ────────────────────────────────────────
//   useEffect(() => {
//     setCurrentImageIndex(prev => {
//       let changed = false;
//       const next = { ...prev };
//       properties.forEach(p => {
//         if (!(p.id in next)) {
//           next[p.id] = 0;
//           changed = true;
//         }
//       });
//       return changed ? next : prev;
//     });
//   }, [properties]);

//   // ── Helpers ───────────────────────────────────────────────────────────────────
//   const requireLogin = useCallback((e, cb) => {
//     e.stopPropagation();
//     if (isGuest) { setShowGuestModal(true); return; }
//     cb();
//   }, [isGuest]);

//   const fetchUserActivities = useCallback(async () => {
//     if (!userId) return;
//     try {
//       const res = await fetch(`${BASE_URL}/activities/`);
//       if (!res.ok) throw new Error(`HTTP ${res.status}`);
//       const all = await res.json();
//       setUserActivities(all.filter(a => String(a.user_id) === String(userId)));
//     } catch (e) {
//       console.error('Activities error:', e);
//       setUserActivities([]);
//     }
//   }, [userId]);

//   const isSaved = useCallback((property) => {
//     return savedProperties.includes(property.id);
//   }, [savedProperties]);

//   const addToCart = useCallback(async (propertyId) => {
//     const r = await axios.post(`${BASE_URL}/user-cart/`, { user_id: userId, property_id: propertyId });
//     return r.data;
//   }, [userId]);

//   const removeFromCart = useCallback(async (cartId) => {
//     return axios.delete(`${BASE_URL}/user-cart/${cartId}/`);
//   }, []);

//   const toggleSave = useCallback(async (property) => {
//     const pid = property.id;
//     setSaving(prev => ({ ...prev, [pid]: true }));
//     try {
//       if (isSaved(property)) {
//         const item = cartItems.find(i => i.property_id === pid);
//         await removeFromCart(item.cart_id);
//         setSavedProperties(prev => prev.filter(id => id !== pid));
//         setCartItems(prev => prev.filter(i => i.property_id !== pid));
//       } else {
//         const newItem = await addToCart(pid);
//         setSavedProperties(prev => [...prev, pid]);
//         setCartItems(prev => [...prev, newItem.data]);
//       }
//     } catch (e) { console.error('Save error:', e); }
//     finally { setSaving(prev => ({ ...prev, [pid]: false })); }
//   }, [isSaved, cartItems, addToCart, removeFromCart]);

//   const findProperty = useCallback((propertyId) => {
//     return properties.find(p => p.id === propertyId) ||
//       allFetchedProperties.find(p => p.id === propertyId);
//   }, [properties, allFetchedProperties]);

//   const checkPropertyLimit = useCallback((propertyId) => {
//     if (!isSubscribed) {
//       setFeatureRequested('Property Access');
//       setShowSubscribeModal(true);
//       return false;
//     }
//     if (userPlan?.no_of_properties_unlimited) return true;

//     const alreadyAccessed = userActivities.some(
//       a => a.property_id === propertyId && a.activity_as === 'Tenant'
//     );
//     if (alreadyAccessed) return true;

//     const uniqueProps = new Set(
//       userActivities.filter(a => a.activity_as === 'Tenant').map(a => a.property_id)
//     );
//     if (uniqueProps.size >= (userPlan?.no_of_properties || 10)) {
//       setShowLimitModal(true);
//       return false;
//     }
//     return true;
//   }, [isSubscribed, userPlan, userActivities]);

//   const logActivity = useCallback(async (propertyId, activityType) => {
//     const exists = userActivities.find(
//       a => a.property_id === propertyId && a.activity_as === 'Tenant'
//     );
//     if (exists) return false;

//     const property = findProperty(propertyId);
//     if (!property) return false;

//     try {
//       const res = await fetch(`${BASE_URL}/activities/`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           user_id: userId,
//           property_id: propertyId,
//           activity_type: activityType,
//           property_by: property.owner,
//           activity_as: 'Tenant',
//         }),
//       });
//       if (!res.ok) throw new Error('Failed to log activity');
//       return await res.json();
//     } catch (e) { console.error('logActivity error:', e); return false; }
//   }, [userId, userActivities, findProperty]);

//   const handleAction = useCallback(async (e, propertyId, actionName, actionCallback, activityType) => {
//     e.stopPropagation();
//     if (!isSubscribed) { setFeatureRequested(actionName); setShowSubscribeModal(true); return; }

//     const alreadyAccessed = userActivities.some(
//       a => a.property_id === propertyId && a.activity_as === 'Tenant'
//     );
//     if (!alreadyAccessed) {
//       const ok = checkPropertyLimit(propertyId);
//       if (!ok) return;
//     }

//     setPendingAction(() => async () => {
//       try {
//         await actionCallback();
//         if (activityType && !alreadyAccessed) {
//           const result = await logActivity(propertyId, activityType);
//           if (result) {
//             setUserActivities(prev => [...prev, {
//               user_id: userId,
//               property_id: propertyId,
//               activity_type: activityType,
//               property_by: findProperty(propertyId)?.owner,
//               activity_as: 'Tenant',
//               created_at: new Date().toISOString(),
//             }]);
//           }
//         }
//       } catch (err) {
//         console.error(`${actionName} error:`, err);
//         alert(`Failed to complete ${actionName} action`);
//       }
//     });
//     setCurrentPropertyId(propertyId);
//     setShowAlertModal(true);
//   }, [isSubscribed, userActivities, checkPropertyLimit, logActivity, userId, findProperty]);

//   // ── Action handlers ───────────────────────────────────────────────────────────
//   const handleCallClick = useCallback((e, property) => {
//     return handleAction(e, property.id, 'Call', async () => {
//       try {
//         await navigator.clipboard.writeText(property.mobile_no);
//         setAlertMessage(`Copied: ${property.mobile_no}`);
//         setShowSuccess(true); setShowFailure(false);
//       } catch {
//         setAlertMessage('Failed to copy number');
//         setShowFailure(true); setShowSuccess(false);
//       }
//     }, 'Call');
//   }, [handleAction]);

//   const handleMessageClick = useCallback((e, property) => {
//     return handleAction(e, property.id, 'Message', async () => {
//       navigate('/chat', { state: { property: property.id } });
//     }, 'Call');
//   }, [handleAction, navigate]);

//   const handleShareClick = useCallback(async (e, property) => {
//     e.stopPropagation();
//     const url = `${window.location.origin}/lease-description/${property.id}`;
//     try {
//       await navigator.clipboard.writeText(url);
//       setAlertMessage('Property link copied to clipboard!');
//       setShowSuccess(true);
//       setTimeout(() => setShowSuccess(false), 3000);
//     } catch {
//       try {
//         const ta = document.createElement('textarea');
//         ta.value = url; document.body.appendChild(ta); ta.select();
//         document.execCommand('copy'); document.body.removeChild(ta);
//         setAlertMessage('Property link copied to clipboard!');
//         setShowSuccess(true);
//         setTimeout(() => setShowSuccess(false), 3000);
//       } catch {
//         setAlertMessage('Failed to copy property link');
//         setShowFailure(true);
//         setTimeout(() => setShowFailure(false), 3000);
//       }
//     }
//   }, []);

//   const handleLocationClick = useCallback((e, property) => {
//     return handleAction(e, property.id, 'Location', async () => {
//       setLocationLoading(prev => ({ ...prev, [property.id]: true }));
//       const fallback = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(property.location)}`;
//       const open = (url) => {
//         setLocationLoading(prev => ({ ...prev, [property.id]: false }));
//         window.open(url, '_blank', 'noopener,noreferrer');
//       };
//       if (navigator.geolocation) {
//         navigator.geolocation.getCurrentPosition(
//           ({ coords }) => {
//             const dest = property.lat && property.long
//               ? `https://www.google.com/maps/dir/?api=1&origin=${coords.latitude},${coords.longitude}&destination=${property.lat},${property.long}&travelmode=driving`
//               : fallback;
//             open(dest);
//           },
//           () => open(fallback),
//           { timeout: 10000 }
//         );
//       } else { open(fallback); }
//     }, 'Location');
//   }, [handleAction]);

//   const handleWishlistClick = useCallback((e, property) => {
//     e.stopPropagation();
//     return handleAction(e, property.id, 'Liked', async () => { await toggleSave(property); }, 'Liked');
//   }, [handleAction, toggleSave]);

//   const handleNextImage = useCallback((propertyId, e) => {
//     e.stopPropagation();
//     setCurrentImageIndex(prev => {
//       const p = findProperty(propertyId);
//       return { ...prev, [propertyId]: (prev[propertyId] + 1) % p.images.length };
//     });
//   }, [findProperty]);

//   const handlePrevImage = useCallback((propertyId, e) => {
//     e.stopPropagation();
//     setCurrentImageIndex(prev => {
//       const p = findProperty(propertyId);
//       return { ...prev, [propertyId]: (prev[propertyId] - 1 + p.images.length) % p.images.length };
//     });
//   }, [findProperty]);

//   // ── Card renderer ─────────────────────────────────────────────────────────────
//   const renderCard = useCallback((property) => {
//     const isAccessed = userActivities.some(
//       a => String(a.property_id) === String(property.id) && a.activity_as === 'Tenant'
//     );
//     const imgIdx = currentImageIndex[property.id] || 0;

//     return (
//       <Card
//         key={property.id}
//         sx={{
//           mb: 1, mx: 2, borderRadius: 3, boxShadow: 2, // ✅ matched PropertyCard (mb: 1)
//           display: 'flex', // Horizontal layout
//           height: { xs: 140, sm: 170 },
//           transition: 'transform 0.2s ease-in-out',
//           '&:hover': { transform: 'scale(1.015)', boxShadow: 4 },
//         }}
//         onClick={async (e) => {
//           if (e.target.closest('button') || e.target.closest('svg')) return;
//           if (!isSubscribed) { setFeatureRequested('View Details'); setShowSubscribeModal(true); return; }
//           const alreadyAccessed = userActivities.some(
//             a => a.property_id === property.id && a.activity_as === 'Tenant'
//           );
//           if (!alreadyAccessed) {
//             const ok = checkPropertyLimit(property.id);
//             if (!ok) return;
//             try { await logActivity(property.id, 'Description'); } catch { }
//           }
//           navigate(`/lease-description/${property.id}`, {
//             state: { propertyId: property.id, property: property.propertyData },
//           });
//         }}
//       >
//         {/* Left: Image - 40% */}
//         <Box sx={{
//           position: 'relative',
//           width: '40%',
//           minWidth: '40%',
//           height: '100%',
//           overflow: 'hidden',
//         }}>
//           <CardMedia
//             component="img"
//             image={property.images[imgIdx]}
//             alt="Property"
//             sx={{
//               width: '100%',
//               height: '100%',
//               objectFit: 'cover',
//               borderTopLeftRadius: 12,
//               borderBottomLeftRadius: 12,
//             }}
//           />

//           {property.images.length > 1 && (
//             <>
//               <IconButton
//                 sx={{
//                   position: 'absolute',
//                   top: '50%',
//                   left: 4,
//                   transform: 'translateY(-50%)',
//                   backgroundColor: 'rgba(255,255,255,0.7)',
//                   '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' },
//                   padding: '4px',
//                   width: '24px',
//                   height: '24px',
//                 }}
//                 onClick={e => handlePrevImage(property.id, e)}
//               >
//                 <ChevronLeft fontSize="small" />
//               </IconButton>
//               <IconButton
//                 sx={{
//                   position: 'absolute',
//                   top: '50%',
//                   right: 4,
//                   transform: 'translateY(-50%)',
//                   backgroundColor: 'rgba(255,255,255,0.7)',
//                   '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' },
//                   padding: '4px',
//                   width: '24px',
//                   height: '24px',
//                 }}
//                 onClick={e => handleNextImage(property.id, e)}
//               >
//                 <ChevronRight fontSize="small" />
//               </IconButton>
//             </>
//           )}

//           {/* Image indicators - dots */}
//           {property.images.length > 1 && (
//             <Box sx={{
//               position: 'absolute',
//               bottom: 4,
//               left: '50%',
//               transform: 'translateX(-50%)',
//               display: 'flex',
//               gap: 0.5
//             }}>
//               {property.images.map((_, i) => (
//                 <Box key={i}
//                   onClick={e => {
//                     e.stopPropagation();
//                     setCurrentImageIndex(prev => ({ ...prev, [property.id]: i }));
//                   }}
//                   sx={{
//                     width: 5,
//                     height: 5,
//                     borderRadius: '50%',
//                     cursor: 'pointer',
//                     transition: 'background-color 0.3s',
//                     backgroundColor: imgIdx === i ? '#1976d2' : 'rgba(255,255,255,0.6)'
//                   }}
//                 />
//               ))}
//             </Box>
//           )}

//           {/* Accessed badge */}
//           {isAccessed && (
//             <Box sx={{
//               position: 'absolute',
//               top: 6,
//               left: 6,
//               bgcolor: 'rgba(46, 125, 50, 0.9)',
//               borderRadius: '50%',
//               p: 0.3,
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//             }}>
//               <CheckCircle sx={{ fontSize: 16, color: 'white' }} />
//             </Box>
//           )}
//         </Box>

//         {/* Right: Content - 60% */}
//         <Box
//           sx={{
//             width: '60%',
//             display: 'flex',
//             flexDirection: 'column',
//             minWidth: 0,
//             height: '100%',
//             p: { xs: 0.45, sm: 0.6 },
//             boxSizing: 'border-box',
//             justifyContent: 'space-between',
//           }}
//         >
//           {/* TOP SECTION - Title, Location, Price */}
//           <Box>
//             {/* TITLE + ACTIONS */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'space-between',
//                 width: '100%',
//                 minWidth: 0,
//                 mb: 0.1,
//               }}
//             >
//               <Typography
//                 noWrap
//                 sx={{
//                   flex: 1,
//                   minWidth: 0,
//                   overflow: 'hidden',
//                   textOverflow: 'ellipsis',
//                   color: '#2C1810',
//                   fontWeight: 700,
//                   fontSize: { xs: '0.74rem', sm: '0.75rem' },
//                   lineHeight: 1.20,
//                   mr: 0.3,
//                 }}
//               >
//                 {property.title}
//                 {property.property_name ? ` - ${property.property_name}` : ''}
//               </Typography>

//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: 0.1,
//                   flexShrink: 0,
//                 }}
//               >
//                 <IconButton
//                   onClick={(e) => requireLogin(e, () => handleWishlistClick(e, property))}
//                   disabled={saving[property.id]}
//                   size="small"
//                   sx={{
//                     width: 25,
//                     height: 25,
//                     p: 0,
//                     bgcolor: '#FFFFFF',
//                     boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
//                     '&:hover': { bgcolor: '#F5EDE4' },
//                   }}
//                 >
//                   {isSaved(property) ? (
//                     <Favorite sx={{ fontSize: 17, color: '#D92D20' }} />
//                   ) : (
//                     <FavoriteBorder sx={{ fontSize: 18, color: '#8D6E63' }} />
//                   )}
//                 </IconButton>

//                 <IconButton
//                   onClick={(e) => requireLogin(e, () => handleShareClick(e, property))}
//                   size="small"
//                   sx={{
//                     width: 25,
//                     height: 25,
//                     p: 0,
//                     bgcolor: '#FFFFFF',
//                     boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
//                     '&:hover': { bgcolor: '#F5EDE4' },
//                   }}
//                 >
//                   <Share sx={{ fontSize: 14, color: '#8D6E63' }} />
//                 </IconButton>
//               </Box>
//             </Box>
//               {/* PRICE + DATE */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'space-between',
//                 width: '100%',
//                 mb: 0.15,
//                 mt: 1
//               }}
//             >
//               <Typography
//                 noWrap
//                 sx={{
//                   color: "#c98a2c",
//                   fontWeight: 700,
//                   fontSize: { xs: '0.90rem', sm: '0.95rem' },
//                   lineHeight: 1.15,
//                   letterSpacing: '0.3px',
//                 }}
//               >
//                 ₹{Number(String(property.price || '').replace(/[^0-9]/g, '')).toLocaleString('en-IN')}
//               </Typography>

//               {/* <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   flexShrink: 0,
//                   bgcolor: 'rgba(255,255,255,0.6)',
//                   px: 0.4,
//                   py: 0.1,
//                   borderRadius: '4px',
//                 }}
//               >
//                 <Typography
//                   noWrap
//                   sx={{
//                     color: '#121212',
//                     fontSize: { xs: '0.60rem', sm: '0.58rem' },
//                     fontWeight: 500,
//                   }}
//                 >
//                   {property.date
//                     ? new Date(property.date).toLocaleDateString('en-IN', {
//                         day: '2-digit',
//                         month: '2-digit',
//                         year: 'numeric',
//                       })
//                     : '--'}
//                 </Typography>
//               </Box> */}
//             </Box>

//             {/* LOCATION */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 minWidth: 0,
//                 mb: 0.05,
//                 mt: 1
//               }}
//             >
//               <IconButton
//                 onClick={e => requireLogin(e, () => handleLocationClick(e, property))}
//                 size="small" sx={{ p: 0.5 }}
//                 disabled={locationLoading[property.id]}
//               >
//                 {locationLoading[property.id]
//                   ? <CircularProgress size={14} />
//                   : <>
//                     <LocationOn
//                       sx={{
//                         color: '#B66A18',
//                         fontSize: '16px',
//                       }}
//                     />
//                   </>}
//               </IconButton>

//               <Typography
//                 noWrap
//                 sx={{
//                   minWidth: 0,
//                   overflow: 'hidden',
//                   textOverflow: 'ellipsis',
//                   whiteSpace: "wrap",
//                   color: '#5D4037',
//                   fontSize: { xs: '0.68rem', sm: '0.8rem' },
//                   lineHeight: 1.1,
//                   fontWeight: 500,
//                 }}
//               >
//                 {property.location || 'Location not available'}
//               </Typography>
//             </Box>

          
//           </Box>

//           {/* BOTTOM SECTION - Property Details */}
//           <Box
//             sx={{
//               display: 'flex',
//               width: '100%',
//               minWidth: 0,
//               borderRadius: '6px',
//               overflow: 'hidden',
//               height: { xs: 35, sm: 32 },
//               backgroundColor: '#FFFFFF',
//               bgcolor: '#f1ce9943',
//               boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
//               mt: 0,
//             }}
//           >
//             {/* FACING */}
//             <Box
//               sx={{
//                 flex: 1,
//                 minWidth: 0,
//                 py: 0.25,
//                 px: 0.2,
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 gap: 0.2,
//                 borderRight: '1px solid #E8DDD0',
//               }}
//             >
//               <ExploreOutlined sx={{ fontSize: 13, color: '#8D6E63' }} />
//               <Box sx={{ minWidth: 0 }}>
//                 <Typography
//                   sx={{
//                     color: '#121212',
//                     fontSize: { xs: '0.4rem', sm: '0.46rem' },
//                     lineHeight: 2,
//                     fontWeight: 500,
//                   }}
//                 >
//                   Facing
//                 </Typography>
//                 <Typography
//                   noWrap
//                   sx={{
//                     color: '#2C1810',
//                     fontWeight: 700,
//                     fontSize: { xs: '0.45rem', sm: '0.52rem' },
//                     lineHeight: 1.15,
//                   }}
//                 >
//                   {property.facing || 'N/A'}
//                 </Typography>
//               </Box>
//             </Box>

//             {/* AREA */}
//             <Box
//               sx={{
//                 flex: 1,
//                 minWidth: 0,
//                 py: 0.25,
//                 px: 0.2,
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 gap: 0.2,
//                 borderRight: '1px solid #E8DDD0',
//               }}
//             >
//               <SquareFootOutlined sx={{ fontSize: 13, color: '#B66A18' }} />
//               <Box sx={{ minWidth: 0 }}>
//                 <Typography
//                   sx={{
//                     color: '#121212',
//                     fontSize: { xs: '0.4rem', sm: '0.46rem' },
//                     lineHeight: 2,
//                     fontWeight: 500,
//                   }}
//                 >
//                   Area
//                 </Typography>
//                 <Typography
//                   noWrap
//                   sx={{
//                     color: '#2C1810',
//                     fontWeight: 700,
//                     fontSize: { xs: '0.45rem', sm: '0.52rem' },
//                     lineHeight: 1.15,
//                   }}
//                 >
//                   {property.area || property.max_acres || 'N/A'}
//                 </Typography>
//               </Box>
//             </Box>

//             {/* POSTED BY */}
//             <Box
//               sx={{
//                 flex: 1,
//                 minWidth: 0,
//                 py: 0.25,
//                 px: 0.2,
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 gap: 0.2,
//               }}
//             >
//               <PersonOutlineOutlined sx={{ fontSize: 13, color: '#8D6E63' }} />
//               <Box sx={{ minWidth: 0 }}>
//                 <Typography
//                   sx={{
//                     color: '#121212',
//                     fontSize: { xs: '0.4rem', sm: '0.46rem' },
//                     lineHeight: 2,
//                     fontWeight: 500,
//                   }}
//                 >
//                   Posted By
//                 </Typography>
//                 <Typography
//                   noWrap
//                   sx={{
//                     color: '#2C1810',
//                     fontWeight: 700,
//                     fontSize: { xs: '0.45rem', sm: '0.52rem' },
//                     lineHeight: 1.15,
//                   }}
//                 >
//                   {property.posted_by || 'N/A'}
//                 </Typography>
//               </Box>
//             </Box>
//           </Box>
//         </Box>
//       </Card>
//     );
//   }, [
//     userActivities, currentImageIndex, isSubscribed, checkPropertyLimit,
//     logActivity, navigate, requireLogin, handleWishlistClick, handleShareClick,
//     handleLocationClick, handleMessageClick, handleCallClick, saving,
//     isSaved, handlePrevImage, handleNextImage
//   ]);

//   // ── Properties list ───────────────────────────────────────────────────────────
//   const renderPropertiesSection = useMemo(() => {
//     if (initialLoading) {
//       return (
//         <Box sx={{ mt: 1 }}>
//           {[1, 2, 3].map(i => <SkeletonCard key={i} />)}
//         </Box>
//       );
//     }

//     if (activeTab === 'lease' && showSkeleton) {
//       return (
//         <Box>
//           {isTyping && (
//             <Box sx={{
//               display: 'flex', alignItems: 'center', justifyContent: 'center',
//               gap: 1, py: 1.5
//             }}>
//               <CircularProgress size={16} sx={{ color: '#8B7355' }} />
//               <Typography variant="caption" sx={{ color: '#888' }}>Searching...</Typography>
//             </Box>
//           )}
//           <Box sx={{ mt: isTyping ? 0.5 : 1 }}>
//             {[1, 2, 3].map(i => <SkeletonCard key={i} />)}
//           </Box>
//         </Box>
//       );
//     }

//     if (properties.length === 0) {
//       return (
//         <Box sx={{
//           display: 'flex', flexDirection: 'column', justifyContent: 'center',
//           alignItems: 'center', height: 200, gap: 1, px: 2
//         }}>
//           <Typography variant="body2" color="text.secondary">
//             {activeTab === 'accessed'
//               ? "You haven't accessed any properties yet"
//               : selectedCategory
//                 ? `No properties found for "${selectedCategory.category}"`
//                 : debouncedSearch
//                   ? `No results for "${debouncedSearch}"`
//                   : 'No properties available right now.'}
//           </Typography>
//         </Box>
//       );
//     }

//     return (
//       <>
//         {properties.map((property, index) => (
//           <React.Fragment key={property.id}>
//             {renderCard(property)}
//             {index === 1 && <AddPropertyCards panel="lease" />}
//           </React.Fragment>
//         ))}
//         <ScrollSentinel onVisible={loadMore} hasMore={hasMore} loading={listLoading} />
//       </>
//     );
//   }, [
//     initialLoading, activeTab, showSkeleton, isTyping, properties,
//     selectedCategory, debouncedSearch, renderCard, loadMore,
//     hasMore, listLoading
//   ]);

//   // ── JSX ───────────────────────────────────────────────────────────────────────
//   return (
//     <Box sx={{ backgroundColor: 'rgb(239, 231, 221)', minHeight: '120vh' }}>

//       {/* Fixed header */}
//       <Box sx={{
//         position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1200,
//         backgroundColor: 'rgb(239, 231, 221)'
//       }}>

//         {/* Search bar — ✅ matched PropertyCard padding */}
//         <Box sx={{ px: 1, pt: 1, pb: 0.25 }}>
//           <CustomSearchBar
//             value={searchQuery}
//             onChange={e => setSearchQuery(e.target.value)}
//             onPriceFilterChange={setPriceFilter}
//           />
//         </Box>

//         {/* Tabs — Lease | Accessed — ✅ matched PropertyCard padding & Tab sx */}
//         <Box sx={{ px: 2, pt: 0, pb: 0.5 }}>
//           <Tabs
//             value={activeTab}
//             onChange={(e, newValue) => {
//               setActiveTab(newValue);
//               if (newValue === 'accessed') setSelectedCategory(null);
//             }}
//             sx={{
//               minHeight: 36,
//               '& .MuiTabs-indicator': { backgroundColor: '#B66A18', height: 3 }
//             }}
//           >
//             <Tab
//               label="Lease Properties"
//               value="lease"
//               sx={{
//                 textTransform: 'none',
//                 fontWeight: 'bold',
//                 minWidth: 0,
//                 mr: 2,
//                 minHeight: 36,
//                 py: 0.5,
//                 color: 'text.secondary',
//                 '&.Mui-selected': {
//                   color: '#B66A18',
//                 },
//               }}
//             />
//             <Tab
//               label="Accessed Properties"
//               value="accessed"
//               sx={{
//                 textTransform: 'none',
//                 fontWeight: 'bold',
//                 minWidth: 0,
//                 minHeight: 36,
//                 py: 0.5,
//                 color: 'text.secondary',
//                 '&.Mui-selected': {
//                   color: '#B66A18',
//                 },
//               }}
//             />
//           </Tabs>
//         </Box>

//         {/* Category chips — only on Lease tab — ✅ matched PropertyCard spacing & chip styling */}
//         {activeTab === 'lease' && (
//           <Box sx={{ px: 2, pt: 0, pb: 0.5 }}>
//             {categoriesLoading ? (
//               <ChipRowSkeleton />
//             ) : (
//               <Box
//                 sx={{
//                   display: 'flex',
//                   gap: 0.6,
//                   overflowX: 'auto',
//                   flexWrap: 'nowrap',
//                   pb: 0.5,

//                   // hide scrollbar (Chrome / Safari / Edge)
//                   '&::-webkit-scrollbar': { display: 'none' },
//                   // hide scrollbar (Firefox)
//                   scrollbarWidth: 'none',
//                   // hide scrollbar (IE / old Edge)
//                   msOverflowStyle: 'none',
//                 }}
//               >
//                 {categories.map((cat) => {
//                   const isActive = selectedCategory?.category_id === cat.category_id;
//                   return (
//                     <Chip
//                       key={cat.category_id}
//                       label={cat.category}
//                       onClick={() =>
//                         setSelectedCategory(prev =>
//                           prev?.category_id === cat.category_id ? null : cat
//                         )
//                       }
//                       sx={{
//                         flexShrink: 0,
//                         height: 24,
//                         borderRadius: '20px',
//                         fontWeight: 'bold',
//                         fontSize: '13px',
//                         bgcolor: isActive ? '#000' : 'transparent',
//                         color: isActive ? '#fff' : '#000',
//                         border: '1px solid black',
//                         transition: 'all 0.2s ease',
//                         cursor: 'pointer',
//                         '&:hover': {
//                           bgcolor: isActive ? '#333' : '#e0e0e0',
//                           transform: 'scale(1.02)',
//                         },
//                         '& .MuiChip-label': {
//                           paddingLeft: '6px',
//                           paddingRight: '6px',
//                           lineHeight: 1,
//                         },
//                       }}
//                     />
//                   );
//                 })}
//               </Box>
//             )}
//           </Box>
//         )}
//       </Box>

//       {/* Scrollable list — ✅ matched PropertyCard top padding */}
//       <Box
//         sx={{
//           pb: 8,
//           pt: activeTab === 'lease'
//             ? { xs: '115px', sm: '155px' }
//             : { xs: '100px', sm: '92px' },
//         }}
//       >
//         {renderPropertiesSection}
//       </Box>

//       {/* Modals */}
//       <GuestLoginModal open={showGuestModal} onClose={() => setShowGuestModal(false)} />

//       <AlertModal
//         open={showAlertModal}
//         onClose={() => setShowAlertModal(false)}
//         onConfirm={async () => { setShowAlertModal(false); if (pendingAction) await pendingAction(); }}
//         title="Confirm Action"
//         message="Are you sure you want to perform this action on this property?"
//       />

//       <SubscriptionModal
//         open={showSubscribeModal}
//         onClose={() => setShowSubscribeModal(false)}
//         onSubscribe={() => { setShowSubscribeModal(false); navigate('/user-subscription'); }}
//         featureRequested={featureRequested}
//       />

//       <LimitModal open={showLimitModal} onClose={() => setShowLimitModal(false)} userPlan={userPlan} />

//       {showSuccess && (
//         <CopySuccessAlert
//           message={alertMessage}
//           onClose={() => { setShowSuccess(false); setAlertMessage(''); }}
//         />
//       )}
//       {showFailure && (
//         <CopyFailureAlert
//           message={alertMessage}
//           onClose={() => { setShowFailure(false); setAlertMessage(''); }}
//         />
//       )}

//       <BottomNavbar />
//     </Box>
//   );
// };

// export default LeasePropertyCard;



// import React, { useState, useEffect, useRef, useCallback, useContext, useMemo } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { AuthContext } from './../../AuthContext/AuthContext';
// import {
//   Box, Card, CardContent, CardMedia, Typography, IconButton,
//   Button, Tooltip, Chip, CircularProgress, Tabs, Tab,
// } from '@mui/material';
// import {
//   FavoriteBorder, Favorite, Share, Call, Chat,
//   LocationOn, ChevronLeft, ChevronRight, ArrowForward,
//   CheckCircle,
// } from '@mui/icons-material';
// import axios from 'axios';
// import buildingImage from './../../../Images/house.jpeg';
// import CustomSearchBar from './CustomSearch';
// import BottomNavbar from './CustomBottomNav';
// import { BASE_URL } from './../../Api/ApiUrls';
// import LimitModal from '../Buy Module/LimitModal';
// import SubscriptionModal from '../Buy Module/SubscriptionModal';
// import AlertModal from '../Buy Module/AlertModal';
// import GuestLoginModal from '../../GuestLoginModal';
// import CopyFailureAlert from '../Alertpage/CopyAlert/CopyFailureAlert';
// import CopySuccessAlert from '../Alertpage/CopyAlert/CopySuccessAlert';
// import { NODE_API } from '../Buy Module/NodeApi';
// import AddPropertyCards from '../AddsProducts/AddPropertyCards';

// const PAGE_SIZE = 20;

// // ─── helpers ────────────────────────────────────────────────────────────────
// const formatPrice = (price) => {
//   const num = Number(String(price || '').replace(/[^0-9.]/g, ''));
//   if (!num || isNaN(num) || num <= 0) return '0';
//   return num.toLocaleString('en-IN');
// };

// const formatTotalPrice = (price) => {
//   const num = Number(String(price || '').replace(/[^0-9.]/g, ''));

//   if (isNaN(num) || num <= 0) return '0';

//   if (num >= 10000000) {
//     return `${(num / 10000000).toFixed(2).replace(/\.?0+$/, '')}CR`;
//   }

//   if (num >= 100000) {
//     return `${(num / 100000).toFixed(2).replace(/\.?0+$/, '')}L`;
//   }

//   if (num >= 1000) {
//     return `${(num / 1000).toFixed(2).replace(/\.?0+$/, '')}K`;
//   }

//   return num.toString();
// };


// const getAreaNumber = (property) => {
//   if (!property) return 0;
//   const raw =
//     property.site_area ||
//     property.buildupArea ||
//     property.buildup_area ||
//     property.max_acres ||
//     property.area;
//   if (raw == null) return 0;
//   const n = parseFloat(String(raw).replace(/[^0-9.]/g, ''));
//   return isNaN(n) ? 0 : n;
// };

// const getPricePerUnit = (property) => {
//   const price = Number(String(property?.price || '').replace(/[^0-9.]/g, ''));
//   if (!price || price <= 0) return null;

//   let area = 0;
//   let unit = 'sft';
//   const units = String(property?.units || '').toLowerCase();

//   if (property?.site_area) {
//     area = parseFloat(String(property.site_area).replace(/[^0-9.]/g, '')) || 0;
//   } else if (property?.max_acres) {
//     area = parseFloat(String(property.max_acres).replace(/[^0-9.]/g, '')) || 0;
//     if (['acre', 'acres', 'gunta', 'guntas'].includes(units)) unit = units;
//   } else if (property?.area) {
//     area = parseFloat(String(property.area).replace(/[^0-9.]/g, '')) || 0;
//   }

//   if (!area || area <= 0) return null;
//   return { value: Math.round(price / area), unit };
// };

// // ─── Skeleton card ──────────────────────────────────────────────────────────
// const SkeletonCard = () => (
//   <Box sx={{
//     mb: 1.2, mx: 2, borderRadius: 3, overflow: 'hidden', boxShadow: 2,
//     backgroundColor: '#fff',
//     animation: 'skeletonPulse 1.5s ease-in-out infinite',
//     '@keyframes skeletonPulse': { '0%,100%': { opacity: 1 }, '50%': { opacity: 0.45 } },
//   }}>
//     <Box sx={{ display: 'flex', height: 170 }}>
//       <Box sx={{ width: '38%', backgroundColor: '#ddd' }} />
//       <Box sx={{ width: '62%', p: 1.5 }}>
//         <Box sx={{ height: 14, backgroundColor: '#e0e0e0', borderRadius: 1, mb: 1, width: '65%' }} />
//         <Box sx={{ height: 12, backgroundColor: '#e0e0e0', borderRadius: 1, mb: 1, width: '45%' }} />
//         <Box sx={{ height: 12, backgroundColor: '#e0e0e0', borderRadius: 1, mb: 1.5, width: '55%' }} />
//         <Box sx={{ display: 'flex', gap: 1 }}>
//           <Box sx={{ flex: 1, height: 32, backgroundColor: '#e0e0e0', borderRadius: 1 }} />
//           <Box sx={{ flex: 1, height: 32, backgroundColor: '#e0e0e0', borderRadius: 1 }} />
//           <Box sx={{ flex: 1, height: 32, backgroundColor: '#e0e0e0', borderRadius: 1 }} />
//         </Box>
//       </Box>
//     </Box>
//   </Box>
// );

// const ChipRowSkeleton = () => (
//   <Box sx={{ display: 'flex', gap: 0.6, px: 0, pb: 1, overflowX: 'hidden' }}>
//     {[80, 60, 100, 70, 90].map((w, i) => (
//       <Box
//         key={i}
//         sx={{
//           width: w, height: 24, borderRadius: '20px', flexShrink: 0,
//           backgroundColor: '#d0d0d0',
//           animation: 'skeletonPulse 1.5s ease-in-out infinite',
//           '@keyframes skeletonPulse': { '0%,100%': { opacity: 1 }, '50%': { opacity: 0.45 } },
//         }}
//       />
//     ))}
//   </Box>
// );

// // ─── Scroll sentinel ────────────────────────────────────────────────────────
// const ScrollSentinel = ({ onVisible, hasMore, loading }) => {
//   const ref = useRef(null);
//   useEffect(() => {
//     const el = ref.current;
//     if (!el) return;
//     const observer = new IntersectionObserver(
//       ([entry]) => { if (entry.isIntersecting && hasMore && !loading) onVisible(); },
//       { threshold: 0.1, rootMargin: '200px' }
//     );
//     observer.observe(el);
//     return () => observer.disconnect();
//   }, [onVisible, hasMore, loading]);

//   return (
//     <Box ref={ref} sx={{ py: 3, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//       {loading && <CircularProgress size={28} sx={{ color: '#8B7355' }} />}
//       {!loading && !hasMore && (
//         <Typography variant="caption" sx={{ color: '#999', fontStyle: 'italic' }}>
//           ✓ All properties loaded
//         </Typography>
//       )}
//     </Box>
//   );
// };

// // ─── Parse raw API row → card shape ────────────────────────────────────────
// const parseProperty = (item) => {
//   const parseCoord = (coord) => {
//     if (!coord) return null;
//     return parseFloat(String(coord).replace(/"/g, '').replace(':', '.'));
//   };

//   let images = [buildingImage];
//   if (item.property_images?.length > 0) {
//     images = item.property_images.map(img => {
//       if (typeof img === 'string') return img.startsWith('http') ? img : `${BASE_URL}${img}`;
//       if (img.image)
//         return img.image.startsWith('http')
//           ? img.image
//           : `${BASE_URL}/${img.image.replace(/^\/+/, '')}`;
//       if (img.url) return img.url.startsWith('http') ? img.url : `${BASE_URL}${img.url}`;
//       if (img.path) return img.path.startsWith('http') ? img.path : `${BASE_URL}${img.path}`;
//       return buildingImage;
//     });
//   } else if (item.images?.length > 0) {
//     images = item.images.map(img =>
//       typeof img === 'string' && img.startsWith('http') ? img : `${BASE_URL}${img}`
//     );
//   }

//   return {
//     id: String(item.property_id),
//     title: item.category_name || item.property_type || 'Property',
//     property_name: item.property_name,
//     location: item.location || 'Not specified',
//     date: item.created_at?.split('T')[0],
//     facing: item.facing?.replace(/"/g, '') || 'N/A',
//     city_town: item.city_town || 'Unknown',
//     price: Number(item.price) || 0,
//     possession: item.possession || 'Not specified',
//     createdAt: item.created_at,
//     fullData: item,
//     length: item.length,
//     width: item.width,
//     listedBy: item.posted_by?.replace(/"/g, '') || 'Agent',
//     mobile_no: item.mobile_no,
//     bank_pro_doc: item.bank_pro_doc || [],
//     bank_contact_details: item.bank_contact_details || 'Not available',
//     units: item.units || '',
//     auction_start_datetime: item.auction_start_datetime,
//     auction_end_datetime: item.auction_end_datetime,
//     emd_amount: item.emd_amount || 0,
//     bid_increment: item.bid_increment || 0,
//     category_id: item.category_id,
//     category_name: item.category_name || '',
//     images,
//     site_area: item.site_area,
//     area: item.site_area
//       ? `${item.site_area} ${['ft', 'm', 'cm', 'in'].includes(item.units) ? `Sq ${item.units}` : item.units || 'Sq ft'}`
//       : 0,
//     max_acres: item.max_acres ? `${item.max_acres} ${item.units || 'acres'}` : 'N/A',
//     dimensions: item.roadwidth ? `${item.roadwidth} ft road` : 'N/A',
//     posted_by: item.posted_by?.replace(/"/g, '') || 'Agent',
//     lat: parseCoord(item.lat),
//     long: parseCoord(item.long),
//     owner: item.user_id,
//     propertyData: item,
//     property_images: item.property_images,
//     property_type: item.property_type || '',
//   };
// };

// // ─── Debounce hook ──────────────────────────────────────────────────────────
// const useDebounce = (value, delay) => {
//   const [debounced, setDebounced] = useState(value);
//   useEffect(() => {
//     const t = setTimeout(() => setDebounced(value), delay);
//     return () => clearTimeout(t);
//   }, [value, delay]);
//   return debounced;
// };

// // ─── Generic paginated fetch hook ───────────────────────────────────────────
// const usePaginatedFetch = (getUrl, deps, enabled = true) => {
//   const [items, setItems] = useState([]);
//   const [cursor, setCursor] = useState(null);
//   const [hasMore, setHasMore] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [initialLoading, setInitialLoading] = useState(true);

//   const fetchingRef = useRef(false);
//   const [isFetching, setIsFetching] = useState(false);

//   const setFetching = (val) => {
//     fetchingRef.current = val;
//     setIsFetching(val);
//   };

//   const abortRef = useRef(null);

//   useEffect(() => {
//     if (!enabled) return;

//     if (abortRef.current) abortRef.current.abort();
//     const ctrl = new AbortController();
//     abortRef.current = ctrl;

//     setItems([]);
//     setCursor(null);
//     setHasMore(false);
//     setInitialLoading(true);
//     setFetching(true);

//     fetch(getUrl(null), { signal: ctrl.signal })
//       .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
//       .then(json => {
//         setItems((json.data || []).map(i => parseProperty(i)));
//         setCursor(json.next_cursor ?? null);
//         setHasMore(json.has_more ?? false);
//       })
//       .catch(err => { if (err.name !== 'AbortError') console.error('fetch error:', err); })
//       .finally(() => {
//         setInitialLoading(false);
//         setFetching(false);
//       });

//     return () => ctrl.abort();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [...deps, enabled]);

//   const loadMore = useCallback(() => {
//     if (loading || !hasMore || !cursor) return;

//     if (abortRef.current) abortRef.current.abort();
//     const ctrl = new AbortController();
//     abortRef.current = ctrl;

//     setLoading(true);

//     fetch(getUrl(cursor), { signal: ctrl.signal })
//       .then(r => r.json())
//       .then(json => {
//         setItems(prev => [...prev, ...(json.data || []).map(i => parseProperty(i))]);
//         setCursor(json.next_cursor ?? null);
//         setHasMore(json.has_more ?? false);
//       })
//       .catch(err => { if (err.name !== 'AbortError') console.error('loadMore error:', err); })
//       .finally(() => setLoading(false));
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [loading, hasMore, cursor, ...deps]);

//   return { items, hasMore, loading, initialLoading, isFetching, fetchingRef, loadMore };
// };

// // ─── Hook: all lease properties ────────────────────────────────────────────
// const useAllLeaseProperties = ({ searchQuery, priceFilter, enabled }) => {
//   const getUrl = useCallback((cursorVal) => {
//     const p = new URLSearchParams({ limit: PAGE_SIZE });
//     if (cursorVal) p.set('cursor', cursorVal);
//     if (searchQuery.trim()) p.set('search', searchQuery.trim());
//     if (priceFilter?.min != null) p.set('min_price', priceFilter.min);
//     if (priceFilter?.max != null) p.set('max_price', priceFilter.max);
//     return `${NODE_API}/api/lease/non-admin/?${p}`;
//   }, [searchQuery, priceFilter]);

//   return usePaginatedFetch(getUrl, [searchQuery, JSON.stringify(priceFilter)], enabled);
// };

// // ─── Hook: lease by category ───────────────────────────────────────────────
// const useLeaseByCategory = ({ selectedCategoryId, searchQuery, priceFilter, enabled }) => {
//   const getUrl = useCallback((cursorVal) => {
//     const p = new URLSearchParams({ limit: PAGE_SIZE });
//     if (cursorVal) p.set('cursor', cursorVal);
//     if (searchQuery?.trim()) p.set('search', searchQuery.trim());
//     if (priceFilter?.min != null) p.set('min_price', priceFilter.min);
//     if (priceFilter?.max != null) p.set('max_price', priceFilter.max);
//     return `${NODE_API}/api/lease/by-category/${selectedCategoryId}?${p}`;
//   }, [selectedCategoryId, searchQuery, priceFilter]);

//   return usePaginatedFetch(
//     getUrl,
//     [selectedCategoryId, searchQuery, JSON.stringify(priceFilter)],
//     enabled && selectedCategoryId != null
//   );
// };

// // ─── Main Component ─────────────────────────────────────────────────────────
// const LeasePropertyCard = () => {
//   const navigate = useNavigate();
//   const { userId, isGuest } = useContext(AuthContext);  

//   // UI state
//   const [activeTab, setActiveTab] = useState('lease');
//   const [searchQuery, setSearchQuery] = useState('');
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [priceFilter, setPriceFilter] = useState(null);
//   const [currentImageIndex, setCurrentImageIndex] = useState({});

//   const debouncedSearch = useDebounce(searchQuery, 400);
//   const isTyping = searchQuery !== debouncedSearch;

//   // Data state
//   const [categories, setCategories] = useState([]);
//   const [categoriesLoading, setCategoriesLoading] = useState(true);
//   const [allFetchedProperties, setAllFetchedProperties] = useState([]);

//   // Auth / subscription
//   const [savedProperties, setSavedProperties] = useState([]);
//   const [cartItems, setCartItems] = useState([]);
//   const [saving, setSaving] = useState({});
//   const [locationLoading, setLocationLoading] = useState({});
//   const [isSubscribed, setIsSubscribed] = useState(false);
//   const [userPlan, setUserPlan] = useState(null);
//   const [userActivities, setUserActivities] = useState([]);

//   // Modals
//   const [showLimitModal, setShowLimitModal] = useState(false);
//   const [showSubscribeModal, setShowSubscribeModal] = useState(false);
//   const [featureRequested, setFeatureRequested] = useState('');
//   const [showAlertModal, setShowAlertModal] = useState(false);
//   const [pendingAction, setPendingAction] = useState(null);
//   const [currentPropertyId, setCurrentPropertyId] = useState(null);
//   const [showGuestModal, setShowGuestModal] = useState(false);
//   const [showSuccess, setShowSuccess] = useState(false);
//   const [showFailure, setShowFailure] = useState(false);
//   const [alertMessage, setAlertMessage] = useState('');

//   // Fetch hooks
//   const allProps = useAllLeaseProperties({
//     searchQuery: debouncedSearch,
//     priceFilter,
//     enabled: activeTab === 'lease' && !selectedCategory,
//   });

//   const categoryProps = useLeaseByCategory({
//     selectedCategoryId: selectedCategory?.category_id ?? null,
//     searchQuery: debouncedSearch,
//     priceFilter,
//     enabled: activeTab === 'lease' && !!selectedCategory,
//   });

//   const {
//     items: leaseProperties,
//     hasMore: leaseHasMore,
//     loading: leaseListLoading,
//     initialLoading: leaseInitialLoading,
//     isFetching: leaseIsFetching,
//     fetchingRef: leaseFetchingRef,
//     loadMore: leaseLoadMore,
//   } = selectedCategory ? categoryProps : allProps;

//   const showSkeleton = isTyping || leaseIsFetching || leaseFetchingRef?.current;

//   useEffect(() => {
//     if (!leaseProperties.length) return;
//     setAllFetchedProperties(prev => {
//       const existingIds = new Set(prev.map(p => p.id));
//       const newOnes = leaseProperties.filter(p => !existingIds.has(p.id));
//       return newOnes.length ? [...prev, ...newOnes] : prev;
//     });
//   }, [leaseProperties]);

//   // Memoized
//   const accessedProperties = useMemo(() => {
//     return allFetchedProperties.filter(property =>
//       userActivities.some(
//         a => String(a.property_id) === String(property.id) && a.activity_as === 'Tenant'
//       )
//     );
//   }, [allFetchedProperties, userActivities]);

//   const properties = useMemo(() => {
//     return activeTab === 'accessed' ? accessedProperties : leaseProperties;
//   }, [activeTab, accessedProperties, leaseProperties]);

//   const hasMore = useMemo(() => activeTab === 'accessed' ? false : leaseHasMore, [activeTab, leaseHasMore]);
//   const listLoading = useMemo(() => activeTab === 'accessed' ? false : leaseListLoading, [activeTab, leaseListLoading]);
//   const initialLoading = useMemo(() => activeTab === 'accessed' ? false : leaseInitialLoading, [activeTab, leaseInitialLoading]);
//   const loadMore = useMemo(() => activeTab === 'accessed' ? () => {} : leaseLoadMore, [activeTab, leaseLoadMore]);

//   // Bootstrap
//   useEffect(() => {
//     setCategoriesLoading(true);
//     fetch(`${NODE_API}/api/lease/categories/`)
//       .then(r => r.json())
//       .then(data => { setCategories(data); setCategoriesLoading(false); })
//       .catch(() => setCategoriesLoading(false));
//   }, []);

//   useEffect(() => {
//     if (!userId) return;

//     axios.get(`${BASE_URL}/Get-user-plan/${userId}/`)
//       .then(r => {
//         const subs = r.data;
//         const tenantSub = Array.isArray(subs) ? subs.find(s => s.user_type === 'Tenant') : null;
//         setIsSubscribed(!!tenantSub);
//         setUserPlan(tenantSub || null);
//       })
//       .catch(() => { setIsSubscribed(false); setUserPlan(null); });

//     axios.get(`${BASE_URL}/get-user-cart/${userId}/`)
//       .then(r => { setCartItems(r.data); setSavedProperties(r.data.map(i => String(i.property_id))); })
//       .catch(e => console.error('Cart error:', e));

//     fetchUserActivities();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [userId]);

//   useEffect(() => {
//     setCurrentImageIndex(prev => {
//       let changed = false;
//       const next = { ...prev };
//       properties.forEach(p => {
//         if (!(p.id in next)) { next[p.id] = 0; changed = true; }
//       });
//       return changed ? next : prev;
//     });
//   }, [properties]);

//   // Helpers
//   const requireLogin = useCallback((e, cb) => {
//     e.stopPropagation();
//     if (isGuest) { setShowGuestModal(true); return; }
//     cb();
//   }, [isGuest]);

//   const fetchUserActivities = useCallback(async () => {
//     if (!userId) return;
//     try {
//       const res = await fetch(`${BASE_URL}/activities/`);
//       if (!res.ok) throw new Error(`HTTP ${res.status}`);
//       const all = await res.json();
//       setUserActivities(all.filter(a => String(a.user_id) === String(userId)));
//     } catch (e) {
//       console.error('Activities error:', e);
//       setUserActivities([]);
//     }
//   }, [userId]);

//   const isSaved = useCallback((property) => savedProperties.includes(property.id), [savedProperties]);

//   const addToCart = useCallback(async (propertyId) => {
//     const r = await axios.post(`${BASE_URL}/user-cart/`, { user_id: userId, property_id: propertyId });
//     return r.data;
//   }, [userId]);

//   const removeFromCart = useCallback(async (cartId) => axios.delete(`${BASE_URL}/user-cart/${cartId}/`), []);

//   const toggleSave = useCallback(async (property) => {
//     const pid = property.id;
//     setSaving(prev => ({ ...prev, [pid]: true }));
//     try {
//       if (isSaved(property)) {
//         const item = cartItems.find(i => i.property_id === pid);
//         await removeFromCart(item.cart_id);
//         setSavedProperties(prev => prev.filter(id => id !== pid));
//         setCartItems(prev => prev.filter(i => i.property_id !== pid));
//       } else {
//         const newItem = await addToCart(pid);
//         setSavedProperties(prev => [...prev, pid]);
//         setCartItems(prev => [...prev, newItem.data]);
//       }
//     } catch (e) { console.error('Save error:', e); }
//     finally { setSaving(prev => ({ ...prev, [pid]: false })); }
//   }, [isSaved, cartItems, addToCart, removeFromCart]);

//   const findProperty = useCallback((propertyId) =>
//     properties.find(p => p.id === propertyId) ||
//     allFetchedProperties.find(p => p.id === propertyId),
//   [properties, allFetchedProperties]);

//   const checkPropertyLimit = useCallback((propertyId) => {
//     if (!isSubscribed) {
//       setFeatureRequested('Property Access');
//       setShowSubscribeModal(true);
//       return false;
//     }
//     if (userPlan?.no_of_properties_unlimited) return true;

//     const alreadyAccessed = userActivities.some(
//       a => a.property_id === propertyId && a.activity_as === 'Tenant'
//     );
//     if (alreadyAccessed) return true;

//     const uniqueProps = new Set(
//       userActivities.filter(a => a.activity_as === 'Tenant').map(a => a.property_id)
//     );
//     if (uniqueProps.size >= (userPlan?.no_of_properties || 10)) {
//       setShowLimitModal(true);
//       return false;
//     }
//     return true;
//   }, [isSubscribed, userPlan, userActivities]);

//   const logActivity = useCallback(async (propertyId, activityType) => {
//     const exists = userActivities.find(
//       a => a.property_id === propertyId && a.activity_as === 'Tenant'
//     );
//     if (exists) return false;

//     const property = findProperty(propertyId);
//     if (!property) return false;

//     try {
//       const res = await fetch(`${BASE_URL}/activities/`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           user_id: userId,
//           property_id: propertyId,
//           activity_type: activityType,
//           property_by: property.owner,
//           activity_as: 'Tenant',
//         }),
//       });
//       if (!res.ok) throw new Error('Failed to log activity');
//       return await res.json();
//     } catch (e) { console.error('logActivity error:', e); return false; }
//   }, [userId, userActivities, findProperty]);

//   const handleAction = useCallback(async (e, propertyId, actionName, actionCallback, activityType) => {
//     e.stopPropagation();
//     if (!isSubscribed) { setFeatureRequested(actionName); setShowSubscribeModal(true); return; }

//     const alreadyAccessed = userActivities.some(
//       a => a.property_id === propertyId && a.activity_as === 'Tenant'
//     );
//     if (!alreadyAccessed) {
//       const ok = checkPropertyLimit(propertyId);
//       if (!ok) return;
//     }

//     setPendingAction(() => async () => {
//       try {
//         await actionCallback();
//         if (activityType && !alreadyAccessed) {
//           const result = await logActivity(propertyId, activityType);
//           if (result) {
//             setUserActivities(prev => [...prev, {
//               user_id: userId,
//               property_id: propertyId,
//               activity_type: activityType,
//               property_by: findProperty(propertyId)?.owner,
//               activity_as: 'Tenant',
//               created_at: new Date().toISOString(),
//             }]);
//           }
//         }
//       } catch (err) {
//         console.error(`${actionName} error:`, err);
//       }
//     });
//     setCurrentPropertyId(propertyId);
//     setShowAlertModal(true);
//   }, [isSubscribed, userActivities, checkPropertyLimit, logActivity, userId, findProperty]);

//   // Action handlers
//   const handleCallClick = useCallback((e, property) => {
//     return handleAction(e, property.id, 'Call', async () => {
//       try {
//         await navigator.clipboard.writeText(property.mobile_no);
//         setAlertMessage(`Copied: ${property.mobile_no}`);
//         setShowSuccess(true); setShowFailure(false);
//       } catch {
//         setAlertMessage('Failed to copy number');
//         setShowFailure(true); setShowSuccess(false);
//       }
//     }, 'Call');
//   }, [handleAction]);

//   const handleMessageClick = useCallback((e, property) => {
//     return handleAction(e, property.id, 'Message', async () => {
//       navigate('/chat', { state: { property: property.id } });
//     }, 'Call');
//   }, [handleAction, navigate]);

//   // Share — preserved
//   const handleShareClick = useCallback(async (e, property) => {
//     e.stopPropagation();
//     const url = `${window.location.origin}/lease-description/${property.id}`;
//     try {
//       await navigator.clipboard.writeText(url);
//       setAlertMessage('Property link copied to clipboard!');
//       setShowSuccess(true);
//       setTimeout(() => setShowSuccess(false), 3000);
//     } catch {
//       try {
//         const ta = document.createElement('textarea');
//         ta.value = url; document.body.appendChild(ta); ta.select();
//         document.execCommand('copy'); document.body.removeChild(ta);
//         setAlertMessage('Property link copied to clipboard!');
//         setShowSuccess(true);
//         setTimeout(() => setShowSuccess(false), 3000);
//       } catch {
//         setAlertMessage('Failed to copy property link');
//         setShowFailure(true);
//         setTimeout(() => setShowFailure(false), 3000);
//       }
//     }
//   }, []);

//   const handleLocationClick = useCallback((e, property) => {
//     return handleAction(e, property.id, 'Location', async () => {
//       setLocationLoading(prev => ({ ...prev, [property.id]: true }));
//       const fallback = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(property.location)}`;
//       const open = (url) => {
//         setLocationLoading(prev => ({ ...prev, [property.id]: false }));
//         window.open(url, '_blank', 'noopener,noreferrer');
//       };
//       if (navigator.geolocation) {
//         navigator.geolocation.getCurrentPosition(
//           ({ coords }) => {
//             const dest = property.lat && property.long
//               ? `https://www.google.com/maps/dir/?api=1&origin=${coords.latitude},${coords.longitude}&destination=${property.lat},${property.long}&travelmode=driving`
//               : fallback;
//             open(dest);
//           },
//           () => open(fallback),
//           { timeout: 10000 }
//         );
//       } else { open(fallback); }
//     }, 'Location');
//   }, [handleAction]);

//   const handleWishlistClick = useCallback((e, property) => {
//     e.stopPropagation();
//     return handleAction(e, property.id, 'Liked', async () => { await toggleSave(property); }, 'Liked');
//   }, [handleAction, toggleSave]);

//   const handleNextImage = useCallback((propertyId, e) => {
//     e.stopPropagation();
//     setCurrentImageIndex(prev => {
//       const p = findProperty(propertyId);
//       return { ...prev, [propertyId]: (prev[propertyId] + 1) % p.images.length };
//     });
//   }, [findProperty]);

//   const handlePrevImage = useCallback((propertyId, e) => {
//     e.stopPropagation();
//     setCurrentImageIndex(prev => {
//       const p = findProperty(propertyId);
//       return { ...prev, [propertyId]: (prev[propertyId] - 1 + p.images.length) % p.images.length };
//     });
//   }, [findProperty]);

//   // ── Card renderer (matched to Buy card) ──────────────────────────────────
//   const renderCard = useCallback((property) => {
//     const isAccessed = userActivities.some(
//       a => String(a.property_id) === String(property.id) && a.activity_as === 'Tenant'
//     );
//     const imgIdx = currentImageIndex[property.id] || 0;

//     const pricePerUnit = getPricePerUnit(property);
//     const totalArea = getAreaNumber(property);

//     return (
//       <Card
//         key={property.id}
//         sx={{
//           mb: 1.2,
//           mx: 2,
//           borderRadius: 2,
//           boxShadow: 2,
//           display: 'flex',
//           flexDirection: 'row',
//           width: 'auto',
//           height: 170,
//           overflow: 'hidden',
//           transition: 'transform 0.2s ease-in-out',
//           '&:hover': { transform: 'scale(1.015)', boxShadow: 4 },
//           bgcolor: '#fff',
//           flexShrink: 0,
//         }}
//         onClick={async (e) => {
//           if (e.target.closest('button') || e.target.closest('svg')) return;
//           if (!isSubscribed) { setFeatureRequested('View Details'); setShowSubscribeModal(true); return; }
//           const alreadyAccessed = userActivities.some(
//             a => a.property_id === property.id && a.activity_as === 'Tenant'
//           );
//           if (!alreadyAccessed) {
//             const ok = checkPropertyLimit(property.id);
//             if (!ok) return;
//             try { await logActivity(property.id, 'Description'); } catch { }
//           }
//           navigate(`/lease-description/${property.id}`, {
//             state: { propertyId: property.id, property: property.propertyData },
//           });
//         }}
//       >
//         {/* ── LEFT: Image 38% ─────────────────────────────────────────── */}
//         <Box sx={{ position: 'relative', width: '38%', minWidth: '38%', height: '100%', overflow: 'hidden' }}>
//           <CardMedia
//             component="img"
//             image={property.images[imgIdx]}
//             alt="Property"
//             sx={{
//               width: '100%', height: '100%', objectFit: 'cover',
//               borderTopLeftRadius: 8, borderBottomLeftRadius: 8,
//             }}
//           />

//           {property.images.length > 1 && (
//             <>
//               <IconButton
//                 sx={{
//                   position: 'absolute', top: '50%', left: 4,
//                   transform: 'translateY(-50%)',
//                   backgroundColor: 'rgba(255,255,255,0.6)',
//                   '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' },
//                   p: 0.3, width: 22, height: 22,
//                 }}
//                 onClick={e => handlePrevImage(property.id, e)}
//               >
//                 <ChevronLeft fontSize="small" />
//               </IconButton>
//               <IconButton
//                 sx={{
//                   position: 'absolute', top: '50%', right: 4,
//                   transform: 'translateY(-50%)',
//                   backgroundColor: 'rgba(255,255,255,0.6)',
//                   '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' },
//                   p: 0.3, width: 22, height: 22,
//                 }}
//                 onClick={e => handleNextImage(property.id, e)}
//               >
//                 <ChevronRight fontSize="small" />
//               </IconButton>
//             </>
//           )}

//           {property.images.length > 1 && (
//             <Box sx={{
//               position: 'absolute', bottom: 6, left: '50%',
//               transform: 'translateX(-50%)', display: 'flex', gap: '4px',
//             }}>
//               {property.images.map((_, i) => (
//                 <Box
//                   key={i}
//                   onClick={(e) => { e.stopPropagation(); setCurrentImageIndex(prev => ({ ...prev, [property.id]: i })); }}
//                   sx={{
//                     width: 6, height: 6, borderRadius: '50%',
//                     backgroundColor: imgIdx === i ? '#1976d2' : '#ccc',
//                     cursor: 'pointer',
//                   }}
//                 />
//               ))}
//             </Box>
//           )}

//           {/* Wishlist button over image */}
//           <Tooltip title={isSaved(property) ? 'Remove from Wishlist' : 'Add to Wishlist'}>
//             <IconButton
//               onClick={(e) => requireLogin(e, () => handleWishlistClick(e, property))}
//               disabled={saving[property.id]}
//               sx={{
//                 position: 'absolute', top: 7, right: 3,
//                 bgcolor: 'white', boxShadow: 1, p: 0.5, width: 24, height: 24,
//                 '&:hover': { bgcolor: '#f5f5f5' },
//               }}
//             >
//               {saving[property.id] ? (
//                 <CircularProgress size={16} />
//               ) : isSaved(property) ? (
//                 <Favorite color="error" fontSize="small" />
//               ) : (
//                 <FavoriteBorder fontSize="small" />
//               )}
//             </IconButton>
//           </Tooltip>

//           {/* Accessed badge */}
//           {isAccessed && (
//             <Box sx={{
//               position: 'absolute', top: 6, left: 6,
//               bgcolor: 'rgba(46, 125, 50, 0.9)',
//               borderRadius: '50%', p: 0.3,
//               display: 'flex', alignItems: 'center', justifyContent: 'center',
//             }}>
//               <CheckCircle sx={{ fontSize: 16, color: 'white' }} />
//             </Box>
//           )}
//         </Box>

//         {/* ── RIGHT: Content 62% ──────────────────────────────────────── */}
//         <CardContent
//           sx={{
//             width: '62%', p: 1,
//             display: 'flex', flexDirection: 'column',
//             justifyContent: 'space-between',
//             height: 170, boxSizing: 'border-box',
//             '&:last-child': { pb: 1 },
//           }}
//         >
//           {/* Title + Share */}
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.2 }}>
//             <Typography
//               fontWeight="bold"
//               noWrap
//               sx={{
//                 flex: 1, minWidth: 0,
//                 overflow: 'hidden', textOverflow: 'ellipsis',
//                 fontSize: '0.75rem', lineHeight: 1.2, color: '#2C1810',
//                 mr: 0.3,
//               }}
//             >
//               {property.title}
//               {property.property_name ? ` - ${property.property_name}` : ''}
//             </Typography>

//             {/* Share — preserved */}
//             <IconButton
//               onClick={(e) => requireLogin(e, () => handleShareClick(e, property))}
//               size="small"
//               sx={{
//                 width: 25, height: 25, p: 0, flexShrink: 0,
//                 bgcolor: '#FFFFFF',
//                 boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
//                 '&:hover': { bgcolor: '#F5EDE4' },
//               }}
//             >
//               <Share sx={{ fontSize: 14, color: '#8D6E63' }} />
//             </IconButton>
//           </Box>

//           {/* Price / Per sft | Total Price */}
//           <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.1, mb: 0.2 }}>
//             <Box sx={{ flex: 1, minWidth: 0 }}>
//               <Typography sx={{ fontSize: '0.5rem', color: '#888', lineHeight: 1.1 }}>
//                 Price / Per {pricePerUnit?.unit || 'sft'}
//               </Typography>
//               <Typography
//                                 fontWeight="bold"
//                                 sx={{
//                                   fontSize: '0.68rem',
//                                   color: '#8B4F16',
//                                   lineHeight: 1.2,
//                                   fontWeight: 900
//                                 }}
//                               >
//                                             ₹{pricePerUnit ? formatPrice(pricePerUnit.value) : 'NA'}
//                                                <Typography
//                                                  component="span"
//                                                  sx={{ fontSize: '0.5rem', color: '#888', fontWeight: 400 }}
//                                                >
//                                                  {' '}/{pricePerUnit?.unit || 'sft'}
//                                                </Typography>
//               </Typography>
//             </Box>

//             <Box sx={{ width: '1px', height: 26, bgcolor: '#e0e0e0', mx: 0.6 }} />

//             <Box sx={{ flex: 1, minWidth: 0, textAlign: 'right' }}>
//               <Typography sx={{ fontSize: '0.5rem', color: '#888', lineHeight: 1.1 }}>
//                 Total Price
//               </Typography>
//               <Typography fontWeight="bold" sx={{ fontSize: '1rem', lineHeight: 1.2, color: '#1F1F1F' }}>
//                 ₹{formatTotalPrice(property.price)}
//               </Typography>
//             </Box>
//           </Box>

//           {/* Location row */}
//           <Box
//             onClick={(e) => requireLogin(e, () => handleLocationClick(e, property))}
//             role="button"
//             tabIndex={0}
//             sx={{
//               display: 'flex', alignItems: 'flex-start', gap: 0.5,
//               mt: 0.1, mb: 0.1, cursor: 'pointer',
//               borderRadius: 1, px: 0.3,
//               transition: 'background-color 0.15s',
//               '&:hover': { backgroundColor: 'rgba(201,138,44,0.10)' },
//               '&:active': { backgroundColor: 'rgba(201,138,44,0.18)' },
//             }}
//           >
//             {locationLoading[property.id] ? (
//               <CircularProgress size={14} sx={{ mt: 0.1, flexShrink: 0 }} />
//             ) : (
//               <LocationOn sx={{ fontSize: '0.9rem', color: '#8B4F16', mt: 0.1, flexShrink: 0 }} />
//             )}
//             <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 0, flex: 1 }}>
//               <Typography
//                 sx={{
//                   minWidth: 0, overflow: 'hidden',
//                   display: '-webkit-box',
//                   WebkitLineClamp: 2,
//                   WebkitBoxOrient: 'vertical',
//                   textOverflow: 'ellipsis',
//                   whiteSpace: 'normal',
//                   color: '#5D4037',
//                   fontSize: { xs: '0.62rem', sm: '0.72rem' },
//                   lineHeight: 1.2,
//                   fontWeight: 500,
//                 }}
//               >
//                 {property.location || 'Location not available'}
//               </Typography>
//             </Box>
//           </Box>

//           {/* Property Info Grid */}
//           <Box
//             sx={{
//               display: 'flex', justifyContent: 'space-between', alignItems: 'center',
//               mt: 0.2, mb: 0.2,
//               border: '1px solid #e0e0e0',
//               borderRadius: '8px', overflow: 'hidden', minHeight: 30,
//             }}
//           >
//             <Box sx={{ flex: 1.2, minWidth: 0, textAlign: 'center', p: 0.4, borderRight: '1px solid #e0e0e0' }}>
//               <Typography fontWeight="bold" noWrap sx={{ fontSize: '0.62rem', lineHeight: 1.1, fontWeight: 900 }}>
//                 {property.facing ? String(property.facing).split('-')[0] : 'N/A'}
//               </Typography>
//               <Typography noWrap sx={{ fontSize: '0.62rem', lineHeight: 1.1, color: '#666', fontWeight: 900 }}>
//                 {String(property.facing || '').split('-')[1] || ''}
//               </Typography>
//             </Box>

//             <Box sx={{ flex: 1.4, minWidth: 0, textAlign: 'center', p: 0.4, borderRight: '1px solid #e0e0e0' }}>
//               <Typography
//                 fontWeight="bold"
//                 noWrap
//                 sx={{ fontSize: '0.62rem', lineHeight: 1.1, maxWidth: '60px', mx: 'auto', fontWeight: 900 }}
//               >
//                 {totalArea > 0 ? totalArea : 'N/A'}
//               </Typography>
//               {property.units && (
//                 <Typography noWrap sx={{ fontSize: '0.5rem', lineHeight: 1.1, color: '#666' }}>
//                   {['ft', 'm', 'cm', 'in'].includes(String(property.units).toLowerCase()) &&
//                   !String(property.units).toLowerCase().startsWith('sq.')
//                     ? `sq.${property.units}`
//                     : property.units}
//                 </Typography>
//               )}
//             </Box>

//             <Box sx={{ flex: 1, minWidth: 0, textAlign: 'center', p: 0.3 }}>
//               <Typography fontWeight="bold" noWrap sx={{ fontSize: '0.62rem', lineHeight: 1.1, fontWeight: 900 }}>
//                 {property.posted_by || 'Agent'}
//               </Typography>
//             </Box>
//           </Box>

//           {/* View Details Button */}
//           <Button
//             variant="contained"
//             size="small"
//             fullWidth
//             onClick={(e) => {
//               e.stopPropagation();
//               (async () => {
//                 if (!isSubscribed) { setFeatureRequested('View Details'); setShowSubscribeModal(true); return; }
//                 const alreadyAccessed = userActivities.some(
//                   a => a.property_id === property.id && a.activity_as === 'Tenant'
//                 );
//                 if (!alreadyAccessed) {
//                   const ok = checkPropertyLimit(property.id);
//                   if (!ok) return;
//                   try { await logActivity(property.id, 'Description'); } catch { }
//                 }
//                 navigate(`/lease-description/${property.id}`, {
//                   state: { propertyId: property.id, property: property.propertyData },
//                 });
//               })();
//             }}
//             sx={{
//               mt: 0.2, py: 0.18,
//               fontSize: '0.7rem', fontWeight: 600,
//               bgcolor: '#8B4F16', color: '#fff',
//               borderRadius: '2px',
//               '&:hover': { bgcolor: '#f5f5f5' },
//               textTransform: 'none',
//               minHeight: 22,
//               display: 'flex', justifyContent: 'space-between',
//               alignItems: 'center', px: 1.5,
//             }}
//           >
//             View Details
//             <ArrowForward sx={{ fontSize: '0.9rem' }} />
//           </Button>
//         </CardContent>
//       </Card>
//     );
//   }, [
//     userActivities, currentImageIndex, isSubscribed, checkPropertyLimit,
//     logActivity, navigate, requireLogin, handleWishlistClick, handleShareClick,
//     handleLocationClick, handleMessageClick, handleCallClick, saving,
//     isSaved, handlePrevImage, handleNextImage,
//   ]);

//   // Properties list
//   const renderPropertiesSection = useMemo(() => {
//     if (initialLoading) {
//       return (
//         <Box sx={{ mt: 1 }}>
//           {[1, 2, 3].map(i => <SkeletonCard key={i} />)}
//         </Box>
//       );
//     }

//     if (activeTab === 'lease' && showSkeleton) {
//       return (
//         <Box>
//           {isTyping && (
//             <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, py: 1.5 }}>
//               <CircularProgress size={16} sx={{ color: '#8B7355' }} />
//               <Typography variant="caption" sx={{ color: '#888' }}>Searching...</Typography>
//             </Box>
//           )}
//           <Box sx={{ mt: isTyping ? 0.5 : 1 }}>
//             {[1, 2, 3].map(i => <SkeletonCard key={i} />)}
//           </Box>
//         </Box>
//       );
//     }

//     if (properties.length === 0) {
//       return (
//         <Box sx={{
//           display: 'flex', flexDirection: 'column', justifyContent: 'center',
//           alignItems: 'center', height: 200, gap: 1, px: 2,
//         }}>
//           <Typography variant="body2" color="text.secondary">
//             {activeTab === 'accessed'
//               ? "You haven't accessed any properties yet"
//               : selectedCategory
//                 ? `No properties found for "${selectedCategory.category}"`
//                 : debouncedSearch
//                   ? `No results for "${debouncedSearch}"`
//                   : 'No properties available right now.'}
//           </Typography>
//         </Box>
//       );
//     }

//     return (
//       <>
//         {properties.map((property, index) => (
//           <React.Fragment key={property.id}>
//             {renderCard(property)}
//             {index === 1 && <AddPropertyCards panel="lease" />}
//           </React.Fragment>
//         ))}
//         <ScrollSentinel onVisible={loadMore} hasMore={hasMore} loading={listLoading} />
//       </>
//     );
//   }, [
//     initialLoading, activeTab, showSkeleton, isTyping, properties,
//     selectedCategory, debouncedSearch, renderCard, loadMore,
//     hasMore, listLoading,
//   ]);

//   return (
//     <Box sx={{ backgroundColor: 'rgb(239, 231, 221)', minHeight: '120vh' }}>
//       {/* Fixed header */}
//       <Box sx={{
//         position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1200,
//         backgroundColor: 'rgb(239, 231, 221)',
//       }}>
//         <Box sx={{ px: 1, pt: 1, pb: 0.25 }}>
//           <CustomSearchBar
//             value={searchQuery}
//             onChange={e => setSearchQuery(e.target.value)}
//             onPriceFilterChange={setPriceFilter}
//           />
//         </Box>

//         <Box sx={{ px: 2, pt: 0, pb: 0.5 }}>
//           <Tabs
//             value={activeTab}
//             onChange={(e, newValue) => {
//               setActiveTab(newValue);
//               if (newValue === 'accessed') setSelectedCategory(null);
//             }}
//             sx={{ minHeight: 36, '& .MuiTabs-indicator': { backgroundColor: '#B66A18', height: 3 } }}
//           >
//             <Tab
//               label="Lease Properties" value="lease"
//               sx={{
//                 textTransform: 'none', fontWeight: 'bold',
//                 minWidth: 0, mr: 2, minHeight: 36, py: 0.5,
//                 color: 'text.secondary',
//                 '&.Mui-selected': { color: '#8B4F16' },
//               }}
//             />
//             <Tab
//               label="Accessed Properties" value="accessed"
//               sx={{
//                 textTransform: 'none', fontWeight: 'bold',
//                 minWidth: 0, minHeight: 36, py: 0.5,
//                 color: 'text.secondary',
//                 '&.Mui-selected': { color: '#8B4F16' },
//               }}
//             />
//           </Tabs>
//         </Box>

//         {activeTab === 'lease' && (
//           <Box sx={{ px: 2, pt: 0, pb: 0.5 }}>
//             {categoriesLoading ? (
//               <ChipRowSkeleton />
//             ) : (
//               <Box
//                 sx={{
//                   display: 'flex', gap: 0.6, overflowX: 'auto',
//                   flexWrap: 'nowrap', pb: 0.5,
//                   '&::-webkit-scrollbar': { display: 'none' },
//                   scrollbarWidth: 'none',
//                   msOverflowStyle: 'none',
//                 }}
//               >
//                 {categories.map((cat) => {
//                   const isActive = selectedCategory?.category_id === cat.category_id;
//                   return (
//                     <Chip
//                       key={cat.category_id}
//                       label={cat.category}
//                       onClick={() =>
//                         setSelectedCategory(prev =>
//                           prev?.category_id === cat.category_id ? null : cat
//                         )
//                       }
//                       sx={{
//                         flexShrink: 0, height: 24, borderRadius: '20px',
//                         fontWeight: 'bold', fontSize: '13px',
//                         bgcolor: isActive ? '#8B4F16' : 'transparent',
//                         color: isActive ? '#fff' : '#000',
//                         border: '1px solid black',
//                         transition: 'all 0.2s ease',
//                         cursor: 'pointer',
//                         '&:hover': {
//                           bgcolor: isActive ? '#333' : '#e0e0e0',
//                           transform: 'scale(1.02)',
//                         },
//                         '& .MuiChip-label': { paddingLeft: '6px', paddingRight: '6px', lineHeight: 1 },
//                       }}
//                     />
//                   );
//                 })}
//               </Box>
//             )}
//           </Box>
//         )}
//       </Box>

//       {/* Scrollable list */}
//       <Box
//         sx={{
//           pb: 8,
//           pt: activeTab === 'lease'
//             ? { xs: '115px', sm: '155px' }
//             : { xs: '100px', sm: '92px' },
//         }}
//       >
//         {renderPropertiesSection}
//       </Box>

//       {/* Modals */}
//       <GuestLoginModal open={showGuestModal} onClose={() => setShowGuestModal(false)} />

//       <AlertModal
//         open={showAlertModal}
//         onClose={() => setShowAlertModal(false)}
//         onConfirm={async () => { setShowAlertModal(false); if (pendingAction) await pendingAction(); }}
//         title="Confirm Action"
//         message="Are you sure you want to perform this action on this property?"
//       />

//       <SubscriptionModal
//         open={showSubscribeModal}
//         onClose={() => setShowSubscribeModal(false)}
//         onSubscribe={() => { setShowSubscribeModal(false); navigate('/user-subscription'); }}
//         featureRequested={featureRequested}
//       />

//       <LimitModal open={showLimitModal} onClose={() => setShowLimitModal(false)} userPlan={userPlan} />

//       {showSuccess && (
//         <CopySuccessAlert
//           message={alertMessage}
//           onClose={() => { setShowSuccess(false); setAlertMessage(''); }}
//         />
//       )}
//       {showFailure && (
//         <CopyFailureAlert
//           message={alertMessage}
//           onClose={() => { setShowFailure(false); setAlertMessage(''); }}
//         />
//       )}

//       <BottomNavbar />
//     </Box>
//   );
// };

// export default LeasePropertyCard;


import React, { useState, useEffect, useRef, useCallback, useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './../../AuthContext/AuthContext';
import {
  Box, Card, CardContent, CardMedia, Typography, IconButton,
  Button, Tooltip, Chip, CircularProgress, Tabs, Tab,
} from '@mui/material';
import {
  FavoriteBorder, Favorite, Share, Call, Chat,
  LocationOn, ChevronLeft, ChevronRight, ArrowForward,
  CheckCircle,
} from '@mui/icons-material';
import axios from 'axios';
import buildingImage from './../../../Images/house.jpeg';
import CustomSearchBar from './CustomSearch';
import BottomNavbar from './CustomBottomNav';
import { BASE_URL } from './../../Api/ApiUrls';
import LimitModal from '../Buy Module/LimitModal';
import SubscriptionModal from '../Buy Module/SubscriptionModal';
import AlertModal from '../Buy Module/AlertModal';
import GuestLoginModal from '../../GuestLoginModal';
import CopyFailureAlert from '../Alertpage/CopyAlert/CopyFailureAlert';
import CopySuccessAlert from '../Alertpage/CopyAlert/CopySuccessAlert';
import { NODE_API } from '../Buy Module/NodeApi';
import AddPropertyCards, { useAdsForPanel } from '../AddsProducts/AddPropertyCards';
import LocationModal from '../Buy Module/LocationModal';
import ShareModal from '../Buy Module/ShareModal';

const PAGE_SIZE = 20;

// ─── helpers ────────────────────────────────────────────────────────────────
const formatPrice = (price) => {
  const num = Number(String(price || '').replace(/[^0-9.]/g, ''));
  if (!num || isNaN(num) || num <= 0) return '0';
  return num.toLocaleString('en-IN');
};

const formatTotalPrice = (price) => {
  const num = Number(String(price || '').replace(/[^0-9.]/g, ''));
  if (isNaN(num) || num <= 0) return '0';
  if (num >= 10000000) return `${(num / 10000000).toFixed(2).replace(/\.?0+$/, '')}CR`;
  if (num >= 100000) return `${(num / 100000).toFixed(2).replace(/\.?0+$/, '')}L`;
  if (num >= 1000) return `${(num / 1000).toFixed(2).replace(/\.?0+$/, '')}K`;
  return num.toString();
};

const getAreaNumber = (property) => {
  if (!property) return 0;
  const raw = property.site_area || property.buildupArea || property.buildup_area || property.max_acres || property.area;
  if (raw == null) return 0;
  const n = parseFloat(String(raw).replace(/[^0-9.]/g, ''));
  return isNaN(n) ? 0 : n;
};

const getPricePerUnit = (property) => {
  const price = Number(String(property?.price || '').replace(/[^0-9.]/g, ''));
  if (!price || price <= 0) return null;

  let area = 0;
  let unit = 'sft';
  const units = String(property?.units || '').toLowerCase();

  if (property?.site_area) {
    area = parseFloat(String(property.site_area).replace(/[^0-9.]/g, '')) || 0;
  } else if (property?.max_acres) {
    area = parseFloat(String(property.max_acres).replace(/[^0-9.]/g, '')) || 0;
    if (['acre', 'acres', 'gunta', 'guntas'].includes(units)) unit = units;
  } else if (property?.area) {
    area = parseFloat(String(property.area).replace(/[^0-9.]/g, '')) || 0;
  }

  if (!area || area <= 0) return null;
  return { value: Math.round(price / area), unit };
};

// ─── Skeleton card ──────────────────────────────────────────────────────────
const SkeletonCard = () => (
  <Box sx={{
    mb: 1.2, mx: 2, borderRadius: 3, overflow: 'hidden', boxShadow: 2,
    backgroundColor: '#fff',
    animation: 'skeletonPulse 1.5s ease-in-out infinite',
    '@keyframes skeletonPulse': { '0%,100%': { opacity: 1 }, '50%': { opacity: 0.45 } },
  }}>
    <Box sx={{ display: 'flex', height: 170 }}>
      <Box sx={{ width: '38%', backgroundColor: '#ddd' }} />
      <Box sx={{ width: '62%', p: 1.5 }}>
        <Box sx={{ height: 14, backgroundColor: '#e0e0e0', borderRadius: 1, mb: 1, width: '65%' }} />
        <Box sx={{ height: 12, backgroundColor: '#e0e0e0', borderRadius: 1, mb: 1, width: '45%' }} />
        <Box sx={{ height: 12, backgroundColor: '#e0e0e0', borderRadius: 1, mb: 1.5, width: '55%' }} />
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Box sx={{ flex: 1, height: 32, backgroundColor: '#e0e0e0', borderRadius: 1 }} />
          <Box sx={{ flex: 1, height: 32, backgroundColor: '#e0e0e0', borderRadius: 1 }} />
          <Box sx={{ flex: 1, height: 32, backgroundColor: '#e0e0e0', borderRadius: 1 }} />
        </Box>
      </Box>
    </Box>
  </Box>
);

const ChipRowSkeleton = () => (
  <Box sx={{ display: 'flex', gap: 0.6, px: 0, pb: 1, overflowX: 'hidden' }}>
    {[80, 60, 100, 70, 90].map((w, i) => (
      <Box
        key={i}
        sx={{
          width: w, height: 24, borderRadius: '20px', flexShrink: 0,
          backgroundColor: '#d0d0d0',
          animation: 'skeletonPulse 1.5s ease-in-out infinite',
          '@keyframes skeletonPulse': { '0%,100%': { opacity: 1 }, '50%': { opacity: 0.45 } },
        }}
      />
    ))}
  </Box>
);

// ─── Scroll sentinel ────────────────────────────────────────────────────────
const ScrollSentinel = ({ onVisible, hasMore, loading }) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting && hasMore && !loading) onVisible(); },
      { threshold: 0.1, rootMargin: '200px' }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [onVisible, hasMore, loading]);

  return (
    <Box ref={ref} sx={{ py: 3, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      {loading && <CircularProgress size={28} sx={{ color: '#8B7355' }} />}
      {!loading && !hasMore && (
        <Typography variant="caption" sx={{ color: '#999', fontStyle: 'italic' }}>
          ✓ All properties loaded
        </Typography>
      )}
    </Box>
  );
};

// ─── Parse raw API row → card shape ────────────────────────────────────────
const parseProperty = (item) => {
  const parseCoord = (coord) => {
    if (!coord) return null;
    return parseFloat(String(coord).replace(/"/g, '').replace(':', '.'));
  };

  let images = [buildingImage];
  if (item.property_images?.length > 0) {
    images = item.property_images.map(img => {
      if (typeof img === 'string') return img.startsWith('http') ? img : `${BASE_URL}${img}`;
      if (img.image) return img.image.startsWith('http') ? img.image : `${BASE_URL}/${img.image.replace(/^\/+/, '')}`;
      if (img.url) return img.url.startsWith('http') ? img.url : `${BASE_URL}${img.url}`;
      if (img.path) return img.path.startsWith('http') ? img.path : `${BASE_URL}${img.path}`;
      return buildingImage;
    });
  } else if (item.images?.length > 0) {
    images = item.images.map(img => typeof img === 'string' && img.startsWith('http') ? img : `${BASE_URL}${img}`);
  }

  return {
    id: String(item.property_id),
    title: item.category_name || item.property_type || 'Property',
    property_name: item.property_name,
    location: item.location || 'Not specified',
    date: item.created_at?.split('T')[0],
    facing: item.facing?.replace(/"/g, '') || 'N/A',
    city_town: item.city_town || 'Unknown',
    price: Number(item.price) || 0,
    possession: item.possession || 'Not specified',
    createdAt: item.created_at,
    fullData: item,
    length: item.length,
    width: item.width,
    listedBy: item.posted_by?.replace(/"/g, '') || 'Agent',
    mobile_no: item.mobile_no,
    units: item.units || '',
    category_id: item.category_id,
    category_name: item.category_name || '',
    images,
    site_area: item.site_area,
    area: item.site_area ? `${item.site_area} ${['ft', 'm', 'cm', 'in'].includes(item.units) ? `Sq ${item.units}` : item.units || 'Sq ft'}` : 0,
    max_acres: item.max_acres ? `${item.max_acres} ${item.units || 'acres'}` : 'N/A',
    posted_by: item.posted_by?.replace(/"/g, '') || 'Agent',
    lat: parseCoord(item.lat),
    long: parseCoord(item.long),
    owner: item.user_id,
    distance_km: item.distance_km != null ? Number(item.distance_km) : null,   // ← add
    propertyData: item,
    property_images: item.property_images,
    property_type: item.property_type || '',
  };
};

// ─── Debounce hook ──────────────────────────────────────────────────────────
const useDebounce = (value, delay) => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
};
const readUserCoords = () => {
  const lat = parseFloat(localStorage.getItem('userLatitude'));
  const lng = parseFloat(localStorage.getItem('userLongitude'));
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return { lat: Math.round(lat * 1000) / 1000, lng: Math.round(lng * 1000) / 1000 };
};

const useUserCoords = () => {
  const [coords, setCoords] = useState(readUserCoords);
  useEffect(() => {
    const refresh = () =>
      setCoords(prev => {
        const next = readUserCoords();
        const same = prev?.lat === next?.lat && prev?.lng === next?.lng;
        return same ? prev : next; // keep reference stable → no needless refetch
      });
    window.addEventListener('storage', refresh);
    window.addEventListener('focus', refresh);
    return () => {
      window.removeEventListener('storage', refresh);
      window.removeEventListener('focus', refresh);
    };
  }, []);
  return coords;
};


// ─── Generic paginated fetch hook ───────────────────────────────────────────
const usePaginatedFetch = (getUrl, deps, enabled = true) => {
  const [items, setItems] = useState([]);
  const [cursor, setCursor] = useState(null);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);

  const fetchingRef = useRef(false);
  const [isFetching, setIsFetching] = useState(false);

  const setFetching = (val) => {
    fetchingRef.current = val;
    setIsFetching(val);
  };

  const abortRef = useRef(null);

  useEffect(() => {
    if (!enabled) return;
    if (abortRef.current) abortRef.current.abort();
    const ctrl = new AbortController();
    abortRef.current = ctrl;

    setItems([]);
    setCursor(null);
    setHasMore(false);
    setInitialLoading(true);
    setFetching(true);

    fetch(getUrl(null), { signal: ctrl.signal })
      .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
      .then(json => {
        setItems((json.data || []).map(i => parseProperty(i)));
        setCursor(json.next_cursor ?? null);
        setHasMore(json.has_more ?? false);
      })
      .catch(err => { if (err.name !== 'AbortError') console.error('fetch error:', err); })
      .finally(() => {
        setInitialLoading(false);
        setFetching(false);
      });

    return () => ctrl.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, enabled]);

  const loadMore = useCallback(() => {
    if (loading || !hasMore || !cursor) return;
    if (abortRef.current) abortRef.current.abort();
    const ctrl = new AbortController();
    abortRef.current = ctrl;

    setLoading(true);
    fetch(getUrl(cursor), { signal: ctrl.signal })
      .then(r => r.json())
      .then(json => {
        setItems(prev => [...prev, ...(json.data || []).map(i => parseProperty(i))]);
        setCursor(json.next_cursor ?? null);
        setHasMore(json.has_more ?? false);
      })
      .catch(err => { if (err.name !== 'AbortError') console.error('loadMore error:', err); })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, hasMore, cursor, ...deps]);

  return { items, hasMore, loading, initialLoading, isFetching, fetchingRef, loadMore };
};

// ─── Hook: all lease properties ────────────────────────────────────────────
const useAllLeaseProperties = ({ searchQuery, priceFilter, coords, enabled }) => {
  const getUrl = useCallback((cursorVal) => {
    const p = new URLSearchParams({ limit: PAGE_SIZE });
    if (cursorVal) p.set('cursor', cursorVal);
    if (coords) { p.set('lat', coords.lat); p.set('lng', coords.lng); }
    if (searchQuery.trim()) p.set('search', searchQuery.trim());
    if (priceFilter?.min != null) p.set('min_price', priceFilter.min);
    if (priceFilter?.max != null) p.set('max_price', priceFilter.max);
    return `${NODE_API}/api/lease/non-admin/?${p}`;
  }, [searchQuery, priceFilter, coords]);

  return usePaginatedFetch(
    getUrl,
    [searchQuery, JSON.stringify(priceFilter), coords?.lat, coords?.lng],
    enabled
  );
};

// ─── Hook: lease by category ───────────────────────────────────────────────
const useLeaseByCategory = ({ selectedCategoryId, searchQuery, priceFilter, coords, enabled }) => {
  const getUrl = useCallback((cursorVal) => {
    const p = new URLSearchParams({ limit: PAGE_SIZE });
    if (cursorVal) p.set('cursor', cursorVal);
    if (coords) { p.set('lat', coords.lat); p.set('lng', coords.lng); }
    if (searchQuery?.trim()) p.set('search', searchQuery.trim());
    if (priceFilter?.min != null) p.set('min_price', priceFilter.min);
    if (priceFilter?.max != null) p.set('max_price', priceFilter.max);
    return `${NODE_API}/api/lease/by-category/${selectedCategoryId}?${p}`;
  }, [selectedCategoryId, searchQuery, priceFilter, coords]);

  return usePaginatedFetch(
    getUrl,
    [selectedCategoryId, searchQuery, JSON.stringify(priceFilter), coords?.lat, coords?.lng],
    enabled && selectedCategoryId != null
  );
};

// ─── Main Component ─────────────────────────────────────────────────────────
const LeasePropertyCard = () => {
  const navigate = useNavigate();
  const { userId, isGuest } = useContext(AuthContext);
 
  // UI state
  const [activeTab, setActiveTab] = useState('lease');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [priceFilter, setPriceFilter] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState({});

  const debouncedSearch = useDebounce(searchQuery, 400);
  const isTyping = searchQuery !== debouncedSearch;

  // Data state
  const [categories, setCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(true);
  const [allFetchedProperties, setAllFetchedProperties] = useState([]);

  // Auth / subscription
  const [savedProperties, setSavedProperties] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [saving, setSaving] = useState({});
  const [locationLoading, setLocationLoading] = useState({});
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [userPlan, setUserPlan] = useState(null);
  const [userActivities, setUserActivities] = useState([]);

  // Modals
  const [showLimitModal, setShowLimitModal] = useState(false);
  const [showSubscribeModal, setShowSubscribeModal] = useState(false);
  const [featureRequested, setFeatureRequested] = useState('');
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [currentPropertyId, setCurrentPropertyId] = useState(null);
  const [showGuestModal, setShowGuestModal] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFailure, setShowFailure] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');

  // --- MODAL STATES ---
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [currentPropertyData, setCurrentPropertyData] = useState(null);

  // ─── Ads hook (panel="lease", shared, fetched once) ─────────────────────
  const { ads: leaseAds, loading: adsLoading } = useAdsForPanel('lease');

  // Fetch hooks
  const coords = useUserCoords();   // ← new

  // Fetch hooks
  const allProps = useAllLeaseProperties({
    searchQuery: debouncedSearch,
    priceFilter,
    coords,                          // ← new
    enabled: activeTab === 'lease' && !selectedCategory,
  });

  const categoryProps = useLeaseByCategory({
    selectedCategoryId: selectedCategory?.category_id ?? null,
    searchQuery: debouncedSearch,
    priceFilter,
    coords,                          // ← new
    enabled: activeTab === 'lease' && !!selectedCategory,
  });

  const {
    items: leaseProperties,
    hasMore: leaseHasMore,
    loading: leaseListLoading,
    initialLoading: leaseInitialLoading,
    isFetching: leaseIsFetching,
    fetchingRef: leaseFetchingRef,
    loadMore: leaseLoadMore,
  } = selectedCategory ? categoryProps : allProps;

  const showSkeleton = isTyping || leaseIsFetching || leaseFetchingRef?.current;

  useEffect(() => {
    if (!leaseProperties.length) return;
    setAllFetchedProperties(prev => {
      const existingIds = new Set(prev.map(p => p.id));
      const newOnes = leaseProperties.filter(p => !existingIds.has(p.id));
      return newOnes.length ? [...prev, ...newOnes] : prev;
    });
  }, [leaseProperties]);

  // Memoized
  const accessedProperties = useMemo(() => {
    return allFetchedProperties.filter(property =>
      userActivities.some(a => String(a.property_id) === String(property.id) && a.activity_as === 'Tenant')
    );
  }, [allFetchedProperties, userActivities]);

  const properties = useMemo(() => activeTab === 'accessed' ? accessedProperties : leaseProperties, [activeTab, accessedProperties, leaseProperties]);
  const hasMore = useMemo(() => activeTab === 'accessed' ? false : leaseHasMore, [activeTab, leaseHasMore]);
  const listLoading = useMemo(() => activeTab === 'accessed' ? false : leaseListLoading, [activeTab, leaseListLoading]);
  const initialLoading = useMemo(() => activeTab === 'accessed' ? false : leaseInitialLoading, [activeTab, leaseInitialLoading]);
  const loadMore = useMemo(() => activeTab === 'accessed' ? () => {} : leaseLoadMore, [activeTab, leaseLoadMore]);

  // Bootstrap
  useEffect(() => {
    setCategoriesLoading(true);
    fetch(`${NODE_API}/api/lease/categories/`)
      .then(r => r.json())
      .then(data => { setCategories(data); setCategoriesLoading(false); })
      .catch(() => setCategoriesLoading(false));
  }, []);

  useEffect(() => {
    if (!userId) return;

    axios.get(`${BASE_URL}/Get-user-plan/${userId}/`)
      .then(r => {
        const subs = r.data;
        const tenantSub = Array.isArray(subs) ? subs.find(s => s.user_type === 'Tenant') : null;
        setIsSubscribed(!!tenantSub);
        setUserPlan(tenantSub || null);
      })
      .catch(() => { setIsSubscribed(false); setUserPlan(null); });

    axios.get(`${BASE_URL}/get-user-cart/${userId}/`)
      .then(r => { setCartItems(r.data); setSavedProperties(r.data.map(i => String(i.property_id))); })
      .catch(e => console.error('Cart error:', e));

    fetchUserActivities();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  useEffect(() => {
    setCurrentImageIndex(prev => {
      let changed = false;
      const next = { ...prev };
      properties.forEach(p => {
        if (!(p.id in next)) { next[p.id] = 0; changed = true; }
      });
      return changed ? next : prev;
    });
  }, [properties]);

  // Helpers
  const requireLogin = useCallback((e, cb) => {
    e.stopPropagation();
    if (isGuest) { setShowGuestModal(true); return; }
    cb();
  }, [isGuest]);

  const fetchUserActivities = useCallback(async () => {
    if (!userId) return;
    try {
      const res = await fetch(`${BASE_URL}/activities/`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const all = await res.json();
      setUserActivities(all.filter(a => String(a.user_id) === String(userId)));
    } catch (e) {
      console.error('Activities error:', e);
      setUserActivities([]);
    }
  }, [userId]);

  const isSaved = useCallback((property) => savedProperties.includes(String(property.id)), [savedProperties]);

  const addToCart = useCallback(async (propertyId) => {
    const r = await axios.post(`${BASE_URL}/user-cart/`, { user_id: userId, property_id: propertyId });
    return r.data;
  }, [userId]);

  const removeFromCart = useCallback(async (cartId) => axios.delete(`${BASE_URL}/user-cart/${cartId}/`), []);

  const toggleSave = useCallback(async (property) => {
    const pid = String(property.id);
    setSaving(prev => ({ ...prev, [pid]: true }));
    try {
      if (isSaved(property)) {
        const item = cartItems.find(i => String(i.property_id) === pid);
        if (item) await removeFromCart(item.cart_id);
        setSavedProperties(prev => prev.filter(id => id !== pid));
        setCartItems(prev => prev.filter(i => String(i.property_id) !== pid));
      } else {
        const newItem = await addToCart(pid);
        setSavedProperties(prev => [...prev, pid]);
        setCartItems(prev => [...prev, newItem]);
      }
    } catch (e) {
      console.error('Save toggle error:', e);
      setAlertMessage(isSaved(property) ? 'Failed to remove from wishlist' : 'Failed to add to wishlist');
      setShowFailure(true);
    } finally {
      setSaving(prev => ({ ...prev, [pid]: false }));
    }
  }, [isSaved, cartItems, addToCart, removeFromCart]);

  const findProperty = useCallback((propertyId) =>
    properties.find(p => p.id === propertyId) || allFetchedProperties.find(p => p.id === propertyId),
  [properties, allFetchedProperties]);

  const checkPropertyLimit = useCallback((propertyId) => {
    if (!isSubscribed) {
      setFeatureRequested('Property Access');
      setShowSubscribeModal(true);
      return false;
    }
    if (userPlan?.no_of_properties_unlimited) return true;

    const alreadyAccessed = userActivities.some(a => a.property_id === propertyId && a.activity_as === 'Tenant');
    if (alreadyAccessed) return true;

    const uniqueProps = new Set(userActivities.filter(a => a.activity_as === 'Tenant').map(a => a.property_id));
    if (uniqueProps.size >= (userPlan?.no_of_properties || 10)) {
      setShowLimitModal(true);
      return false;
    }
    return true;
  }, [isSubscribed, userPlan, userActivities]);

  const logActivity = useCallback(async (propertyId, activityType) => {
    const exists = userActivities.find(a => a.property_id === propertyId && a.activity_as === 'Tenant');
    if (exists) return false;

    const property = findProperty(propertyId);
    if (!property) return false;

    try {
      const res = await fetch(`${BASE_URL}/activities/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_id: userId,
          property_id: propertyId,
          activity_type: activityType,
          property_by: property.owner,
          activity_as: 'Tenant',
        }),
      });
      if (!res.ok) throw new Error('Failed to log activity');
      return await res.json();
    } catch (e) { console.error('logActivity error:', e); return false; }
  }, [userId, userActivities, findProperty]);

  const handleAction = useCallback(async (e, propertyId, actionName, actionCallback, activityType) => {
    e.stopPropagation();
    if (!isSubscribed) { setFeatureRequested(actionName); setShowSubscribeModal(true); return; }

    const alreadyAccessed = userActivities.some(a => a.property_id === propertyId && a.activity_as === 'Tenant');
    if (!alreadyAccessed) {
      const ok = checkPropertyLimit(propertyId);
      if (!ok) return;
    }

    setPendingAction(() => async () => {
      try {
        await actionCallback();
        if (activityType && !alreadyAccessed) {
          const result = await logActivity(propertyId, activityType);
          if (result) {
            setUserActivities(prev => [...prev, {
              user_id: userId,
              property_id: propertyId,
              activity_type: activityType,
              property_by: findProperty(propertyId)?.owner,
              activity_as: 'Tenant',
              created_at: new Date().toISOString(),
            }]);
          }
        }
      } catch (err) {
        console.error(`${actionName} error:`, err);
      }
    });
    setCurrentPropertyId(propertyId);
    setShowAlertModal(true);
  }, [isSubscribed, userActivities, checkPropertyLimit, logActivity, userId, findProperty]);

  // Action handlers
  const handleCallClick = useCallback((e, property) => {
    return handleAction(e, property.id, 'Call', async () => {
      try {
        await navigator.clipboard.writeText(property.mobile_no);
        setAlertMessage(`Copied: ${property.mobile_no}`);
        setShowSuccess(true); setShowFailure(false);
      } catch {
        setAlertMessage('Failed to copy number');
        setShowFailure(true); setShowSuccess(false);
      }
    }, 'Call');
  }, [handleAction]);

  const handleMessageClick = useCallback((e, property) => {
    return handleAction(e, property.id, 'Message', async () => {
      navigate('/chat', { state: { property: property.id } });
    }, 'Call');
  }, [handleAction, navigate]);

  const handleShareClick = useCallback((e, property) => {
    e.stopPropagation();
    setCurrentPropertyData(property);
    setShowShareModal(true);
  }, []);

  const handleLocationClick = useCallback((e, property) => {
    e.stopPropagation();
    setCurrentPropertyData(property);
    setShowLocationModal(true);
  }, []);

  const openGoogleMaps = () => {
    if (!currentPropertyData) return;
    setLocationLoading(prev => ({ ...prev, [currentPropertyData.id]: true }));

    const fallback = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(currentPropertyData.location)}`;
    const open = (url) => {
      setLocationLoading(prev => ({ ...prev, [currentPropertyData.id]: false }));
      window.open(url, '_blank', 'noopener,noreferrer');
    };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        ({ coords }) => {
          const dest = currentPropertyData.lat && currentPropertyData.long
            ? `https://www.google.com/maps/dir/?api=1&origin=${coords.latitude},${coords.longitude}&destination=${currentPropertyData.lat},${currentPropertyData.long}&travelmode=driving`
            : fallback;
          open(dest);
        },
        () => open(fallback),
        { timeout: 10000 }
      );
    } else { open(fallback); }
  };

  const handleWishlistClick = useCallback((e, property) => {
    e.stopPropagation();
    return handleAction(e, property.id, 'Liked', async () => {
      await toggleSave(property);
      setShowSuccessModal(true);
    }, 'Liked');
  }, [handleAction, toggleSave]);

  const handleNextImage = useCallback((propertyId, e) => {
    e.stopPropagation();
    setCurrentImageIndex(prev => {
      const p = findProperty(propertyId);
      return { ...prev, [propertyId]: (prev[propertyId] + 1) % p.images.length };
    });
  }, [findProperty]);

  const handlePrevImage = useCallback((propertyId, e) => {
    e.stopPropagation();
    setCurrentImageIndex(prev => {
      const p = findProperty(propertyId);
      return { ...prev, [propertyId]: (prev[propertyId] - 1 + p.images.length) % p.images.length };
    });
  }, [findProperty]);

  // ── Card renderer ──
  const renderCard = useCallback((property) => {
    const isAccessed = userActivities.some(a => String(a.property_id) === String(property.id) && a.activity_as === 'Tenant');
    const imgIdx = currentImageIndex[property.id] || 0;
    const pricePerUnit = getPricePerUnit(property);
    const totalArea = getAreaNumber(property);

    return (
      <Card
        key={property.id}
        sx={{
          mb: 1.2, mx: 2, borderRadius: 2, boxShadow: 2, display: 'flex', flexDirection: 'row',
          width: 'auto', height: 170, overflow: 'hidden', transition: 'transform 0.2s ease-in-out',
          '&:hover': { transform: 'scale(1.015)', boxShadow: 4 }, bgcolor: '#fff', flexShrink: 0,
        }}
        onClick={async (e) => {
          if (e.target.closest('button') || e.target.closest('svg')) return;
          if (!isSubscribed) { setFeatureRequested('View Details'); setShowSubscribeModal(true); return; }
          const alreadyAccessed = userActivities.some(a => a.property_id === property.id && a.activity_as === 'Tenant');
          if (!alreadyAccessed) {
            const ok = checkPropertyLimit(property.id);
            if (!ok) return;
            try { await logActivity(property.id, 'Description'); } catch { }
          }
          navigate(`/lease-description/${property.id}`, {
            state: { propertyId: property.id, property: property.propertyData },
          });
        }}
      >
        {/* ── LEFT: Image ── */}
        <Box sx={{ position: 'relative', width: '38%', minWidth: '38%', height: '100%', overflow: 'hidden' }}>
          <CardMedia component="img" image={property.images[imgIdx]} alt="Property" sx={{ width: '100%', height: '100%', objectFit: 'cover', borderTopLeftRadius: 8, borderBottomLeftRadius: 8 }} />

          {property.images.length > 1 && (
            <>
              <IconButton sx={{ position: 'absolute', top: '50%', left: 4, transform: 'translateY(-50%)', backgroundColor: 'rgba(255,255,255,0.6)', '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' }, p: 0.3, width: 22, height: 22 }} onClick={e => handlePrevImage(property.id, e)}>
                <ChevronLeft fontSize="small" />
              </IconButton>
              <IconButton sx={{ position: 'absolute', top: '50%', right: 4, transform: 'translateY(-50%)', backgroundColor: 'rgba(255,255,255,0.6)', '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' }, p: 0.3, width: 22, height: 22 }} onClick={e => handleNextImage(property.id, e)}>
                <ChevronRight fontSize="small" />
              </IconButton>
            </>
          )}

          {property.images.length > 1 && (
            <Box sx={{ position: 'absolute', bottom: 6, left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: '4px' }}>
              {property.images.map((_, i) => (
                <Box key={i} onClick={(e) => { e.stopPropagation(); setCurrentImageIndex(prev => ({ ...prev, [property.id]: i })); }} sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: imgIdx === i ? '#1976d2' : '#ccc', cursor: 'pointer' }} />
              ))}
            </Box>
          )}

          <Tooltip title={isSaved(property) ? 'Remove from Wishlist' : 'Add to Wishlist'}>
            <IconButton
              onClick={(e) => requireLogin(e, () => handleWishlistClick(e, property))}
              disabled={saving[String(property.id)]}
              sx={{ position: 'absolute', top: 7, right: 3, bgcolor: 'white', boxShadow: 1, p: 0.5, width: 24, height: 24, '&:hover': { bgcolor: '#f5f5f5' } }}
            >
              {saving[String(property.id)] ? <CircularProgress size={16} /> : isSaved(property) ? <Favorite color="error" fontSize="small" /> : <FavoriteBorder fontSize="small" />}
            </IconButton>
          </Tooltip>

          {isAccessed && (
            <Box sx={{ position: 'absolute', top: 6, left: 6, bgcolor: 'rgba(46, 125, 50, 0.9)', borderRadius: '50%', p: 0.3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <CheckCircle sx={{ fontSize: 16, color: 'white' }} />
            </Box>
          )}
        </Box>

        {/* ── RIGHT: Content ── */}
        <CardContent sx={{ width: '62%', p: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: 170, boxSizing: 'border-box', '&:last-child': { pb: 1 } }}>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.2 }}>
            <Typography fontWeight="bold" noWrap sx={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.75rem', lineHeight: 1.2, color: '#2C1810', mr: 0.3 }}>
              {property.title}{property.property_name ? ` - ${property.property_name}` : ''}
            </Typography>

            <IconButton onClick={(e) => requireLogin(e, () => handleShareClick(e, property))} size="small" sx={{ width: 25, height: 25, p: 0, flexShrink: 0, bgcolor: '#FFFFFF', boxShadow: '0 2px 4px rgba(0,0,0,0.08)', '&:hover': { bgcolor: '#F5EDE4' } }}>
              <Share sx={{ fontSize: 14, color: '#8D6E63' }} />
            </IconButton>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.1, mb: 0.2 }}>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography sx={{ fontSize: '0.5rem', color: '#888', lineHeight: 1.1 }}>Price / Per {pricePerUnit?.unit || 'sft'}</Typography>
              <Typography fontWeight="bold" sx={{ fontSize: '0.68rem', color: '#8B4F16', lineHeight: 1.2, fontWeight: 900 }}>
                ₹{pricePerUnit ? formatPrice(pricePerUnit.value) : 'NA'}
                <Typography component="span" sx={{ fontSize: '0.5rem', color: '#888', fontWeight: 400 }}> /{pricePerUnit?.unit || 'sft'}</Typography>
              </Typography>
            </Box>
            <Box sx={{ width: '1px', height: 26, bgcolor: '#e0e0e0', mx: 0.6 }} />
            <Box sx={{ flex: 1, minWidth: 0, textAlign: 'right' }}>
              <Typography sx={{ fontSize: '0.5rem', color: '#888', lineHeight: 1.1 }}>Total Price</Typography>
              <Typography fontWeight="bold" sx={{ fontSize: '1rem', lineHeight: 1.2, color: '#1F1F1F' }}>₹{formatTotalPrice(property.price)}</Typography>
            </Box>
          </Box>

          <Box
          //  onClick={(e) => requireLogin(e, () => handleLocationClick(e, property))}
          
          role="button" tabIndex={0} sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5, mt: 0.1, mb: 0.1, cursor: 'pointer', borderRadius: 1, px: 0.3, transition: 'background-color 0.15s', '&:hover': { backgroundColor: 'rgba(201,138,44,0.10)' }, '&:active': { backgroundColor: 'rgba(201,138,44,0.18)' } }}>
            {locationLoading[property.id] ? <CircularProgress size={14} sx={{ mt: 0.1, flexShrink: 0 }} /> : <LocationOn sx={{ fontSize: '0.9rem', color: '#8B4F16', mt: 0.1, flexShrink: 0 }} />}
            <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 0, flex: 1 }}>
              <Typography sx={{ minWidth: 0, overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', textOverflow: 'ellipsis', whiteSpace: 'normal', color: '#5D4037', fontSize: { xs: '0.62rem', sm: '0.72rem' }, lineHeight: 1.2, fontWeight: 500 }}>
                {property.location || 'Location not available'}
              </Typography>
                {/* ← add this */}
  {property.distance_km != null && property.distance_km < 99999 && (
    <Typography sx={{ fontSize: '0.58rem', color: '#8B4F16', fontWeight: 700, lineHeight: 1.2 }}>
      {property.distance_km < 1
        ? `${Math.round(property.distance_km * 1000)} m away`
        : `${property.distance_km.toFixed(1)} km away`}
    </Typography>
  )}
            </Box>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 0.2, mb: 0.2, border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden', minHeight: 30 }}>
            <Box sx={{ flex: 1.2, minWidth: 0, textAlign: 'center', p: 0.4, borderRight: '1px solid #e0e0e0' }}>
              <Typography fontWeight="bold" noWrap sx={{ fontSize: '0.62rem', lineHeight: 1.1, fontWeight: 900 }}>{property.facing ? String(property.facing).split('-')[0] : 'N/A'}</Typography>
              <Typography noWrap sx={{ fontSize: '0.62rem', lineHeight: 1.1, color: '#666', fontWeight: 900 }}>{String(property.facing || '').split('-')[1] || ''}</Typography>
            </Box>
            <Box sx={{ flex: 1.4, minWidth: 0, textAlign: 'center', p: 0.4, borderRight: '1px solid #e0e0e0' }}>
              <Typography fontWeight="bold" noWrap sx={{ fontSize: '0.62rem', lineHeight: 1.1, maxWidth: '60px', mx: 'auto', fontWeight: 900 }}>{totalArea > 0 ? totalArea : 'N/A'}</Typography>
              {property.units && <Typography noWrap sx={{ fontSize: '0.5rem', lineHeight: 1.1, color: '#666' }}>{['ft', 'm', 'cm', 'in'].includes(String(property.units).toLowerCase()) && !String(property.units).toLowerCase().startsWith('sq.') ? `sq.${property.units}` : property.units}</Typography>}
            </Box>
            <Box sx={{ flex: 1, minWidth: 0, textAlign: 'center', p: 0.3 }}>
              <Typography fontWeight="bold" noWrap sx={{ fontSize: '0.62rem', lineHeight: 1.1, fontWeight: 900 }}>{property.posted_by || 'Agent'}</Typography>
            </Box>
          </Box>

          <Button
            variant="contained" size="small" fullWidth
            onClick={(e) => {
              e.stopPropagation();
              (async () => {
                if (!isSubscribed) { setFeatureRequested('View Details'); setShowSubscribeModal(true); return; }
                const alreadyAccessed = userActivities.some(a => a.property_id === property.id && a.activity_as === 'Tenant');
                if (!alreadyAccessed) {
                  const ok = checkPropertyLimit(property.id);
                  if (!ok) return;
                  try { await logActivity(property.id, 'Description'); } catch { }
                }
                navigate(`/lease-description/${property.id}`, { state: { propertyId: property.id, property: property.propertyData } });
              })();
            }}
            sx={{ mt: 0.2, py: 0.18, fontSize: '0.7rem', fontWeight: 600, bgcolor: '#8B4F16', color: '#fff', borderRadius: '2px', '&:hover': { bgcolor: '#f5f5f5' }, textTransform: 'none', minHeight: 22, display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 1.5 }}
          >
            View Details <ArrowForward sx={{ fontSize: '0.9rem' }} />
          </Button>
        </CardContent>
      </Card>
    );
  }, [userActivities, currentImageIndex, isSubscribed, checkPropertyLimit, logActivity, navigate, requireLogin, handleWishlistClick, handleShareClick, handleLocationClick, handleMessageClick, handleCallClick, saving, isSaved, handlePrevImage, handleNextImage]);

  // ─── Properties section — ads after EVERY 2 cards + trailing ads ─────────
  const renderPropertiesSection = useMemo(() => {
    if (initialLoading) return <Box sx={{ mt: 1 }}>{[1, 2, 3].map(i => <SkeletonCard key={i} />)}</Box>;

    if (activeTab === 'lease' && showSkeleton) {
      return (
        <Box>
          {isTyping && <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, py: 1.5 }}><CircularProgress size={16} sx={{ color: '#8B7355' }} /><Typography variant="caption" sx={{ color: '#888' }}>Searching...</Typography></Box>}
          <Box sx={{ mt: isTyping ? 0.5 : 1 }}>{[1, 2, 3].map(i => <SkeletonCard key={i} />)}</Box>
        </Box>
      );
    }

    if (properties.length === 0) {
      return (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: 200, gap: 1, px: 2 }}>
          <Typography variant="body2" color="text.secondary">
            {activeTab === 'accessed' ? "You haven't accessed any properties yet" : selectedCategory ? `No properties found for "${selectedCategory.category}"` : debouncedSearch ? `No results for "${debouncedSearch}"` : 'No properties available right now.'}
          </Typography>
        </Box>
      );
    }

    // How many 3-ad blocks fit inline (after every 2nd property card)?
    const inlineBlockCount = Math.floor(properties.length / 2);

    return (
      <>
        {properties.map((property, index) => {
          const cardNumber = index + 1; // 1-based

          // Insert an ad block AFTER every 2 property cards (lease tab only)
          let adBlock = null;
          if (activeTab === 'lease' && cardNumber % 2 === 0) {
            const blockIndex = cardNumber / 2 - 1;
            const adOffset = blockIndex * 3;
            // Render if first block (even while loading) OR there are ads at this offset
            if (adOffset === 0 || adOffset < leaseAds.length) {
              adBlock = (
                <AddPropertyCards
                  key={`ad-${adOffset}`}
                  ads={leaseAds}
                  offset={adOffset}
                  loading={adsLoading}
                />
              );
            }
          }

          return (
            <React.Fragment key={property.id}>
              {renderCard(property)}
              {adBlock}
            </React.Fragment>
          );
        })}

        {/* ── TRAILING ADS ──────────────────────────────────────────────
            If there are still ads after the last inline block (because there
            weren't enough property cards), keep appending ad blocks until the
            ad list is fully exhausted. This guarantees ALL ads are shown.   */}
        {activeTab === 'lease' && (() => {
          const trailing = [];

          // Edge case: only 0/1 property cards and ads are loading → show skeleton at top
          if (inlineBlockCount === 0 && adsLoading && leaseAds.length === 0) {
            trailing.push(
              <AddPropertyCards key="ad-0" ads={[]} offset={0} loading={true} />
            );
            return trailing;
          }

          // Append remaining ad blocks starting from inlineBlockCount
          for (let i = inlineBlockCount; i * 3 < leaseAds.length; i++) {
            const adOffset = i * 3;
            trailing.push(
              <AddPropertyCards
                key={`ad-${adOffset}`}
                ads={leaseAds}
                offset={adOffset}
                loading={adsLoading}
              />
            );
          }
          return trailing;
        })()}

        <ScrollSentinel onVisible={loadMore} hasMore={hasMore} loading={listLoading} />
      </>
    );
  }, [
    initialLoading, activeTab, showSkeleton, isTyping, properties,
    selectedCategory, debouncedSearch, renderCard, loadMore,
    hasMore, listLoading,
    leaseAds, adsLoading,
  ]);

  return (
    <Box sx={{ backgroundColor: 'rgb(239, 231, 221)', minHeight: '120vh' }}>
      <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1200, backgroundColor: 'rgb(239, 231, 221)' }}>
        <Box sx={{ px: 1, pt: 1, pb: 0.25 }}>
          <CustomSearchBar value={searchQuery} onChange={e => setSearchQuery(e.target.value)} onPriceFilterChange={setPriceFilter} />
        </Box>

        <Box sx={{ px: 2, pt: 0, pb: 0.5 }}>
          <Tabs value={activeTab} onChange={(e, newValue) => { setActiveTab(newValue); if (newValue === 'accessed') setSelectedCategory(null); }} sx={{ minHeight: 36, '& .MuiTabs-indicator': { backgroundColor: '#B66A18', height: 3 } }}>
            <Tab label="Lease Properties" value="lease" sx={{ textTransform: 'none', fontWeight: 'bold', minWidth: 0, mr: 2, minHeight: 36, py: 0.5, color: 'text.secondary', '&.Mui-selected': { color: '#8B4F16' } }} />
            <Tab label="Accessed Properties" value="accessed" sx={{ textTransform: 'none', fontWeight: 'bold', minWidth: 0, minHeight: 36, py: 0.5, color: 'text.secondary', '&.Mui-selected': { color: '#8B4F16' } }} />
          </Tabs>
        </Box>

        {activeTab === 'lease' && (
          <Box sx={{ px: 2, pt: 0, pb: 0.5 }}>
            {categoriesLoading ? <ChipRowSkeleton /> : (
              <Box sx={{ display: 'flex', gap: 0.6, overflowX: 'auto', flexWrap: 'nowrap', pb: 0.5, '&::-webkit-scrollbar': { display: 'none' }, scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
                {categories.map((cat) => {
                  const isActive = selectedCategory?.category_id === cat.category_id;
                  return (
                    <Chip key={cat.category_id} label={cat.category} onClick={() => setSelectedCategory(prev => prev?.category_id === cat.category_id ? null : cat)} sx={{ flexShrink: 0, height: 24, borderRadius: '20px', fontWeight: 'bold', fontSize: '13px', bgcolor: isActive ? '#8B4F16' : 'transparent', color: isActive ? '#fff' : '#000', border: '1px solid black', transition: 'all 0.2s ease', cursor: 'pointer', '&:hover': { bgcolor: isActive ? '#333' : '#e0e0e0', transform: 'scale(1.02)' }, '& .MuiChip-label': { paddingLeft: '6px', paddingRight: '6px', lineHeight: 1 } }} />
                  );
                })}
              </Box>
            )}
          </Box>
        )}
      </Box>

      <Box sx={{ pb: 8, pt: activeTab === 'lease' ? { xs: '115px', sm: '155px' } : { xs: '100px', sm: '92px' } }}>
        {renderPropertiesSection}
      </Box>

      {/* --- MODALS --- */}
      <GuestLoginModal open={showGuestModal} onClose={() => setShowGuestModal(false)} />

      <AlertModal
        open={showAlertModal}
        onClose={() => setShowAlertModal(false)}
        onConfirm={async () => { setShowAlertModal(false); if (pendingAction) await pendingAction(); }}
        title="Confirm Action"
        message="Are you sure you want to perform this action on this property?"
      />

      <AlertModal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        title="Added to Wishlist"
        message="This property has been added to your Wishlist."
        isSuccess={true}
      />

      <SubscriptionModal open={showSubscribeModal} onClose={() => setShowSubscribeModal(false)} onSubscribe={() => { setShowSubscribeModal(false); navigate('/user-subscription'); }} featureRequested={featureRequested} />

      <LimitModal open={showLimitModal} onClose={() => setShowLimitModal(false)} userPlan={userPlan} />

      <LocationModal
        open={showLocationModal}
        onClose={() => setShowLocationModal(false)}
        onOpenMap={openGoogleMaps}
        propertyLocation={currentPropertyData?.location}
      />

      <ShareModal
        open={showShareModal}
        onClose={() => setShowShareModal(false)}
        ownerName={currentPropertyData?.posted_by || currentPropertyData?.owner}
        mobileNo={currentPropertyData?.mobile_no}
      />

      {showSuccess && <CopySuccessAlert message={alertMessage} onClose={() => { setShowSuccess(false); setAlertMessage(''); }} />}
      {showFailure && <CopyFailureAlert message={alertMessage} onClose={() => { setShowFailure(false); setAlertMessage(''); }} />}

      <BottomNavbar />
    </Box>
  );
};

export default LeasePropertyCard;